export enum TypeClassType {
    /// <summary>
    /// Database record state
    /// </summary>
    RecordState = 1,

    UserRole = 2,

    Company = 3,

    DivisionDeliveryModel = 4,

    Visibility = 5,

    AddressType = 6,

    ContactMethod = 7,

    Country = 8,

    ContractDate = 9,

    ContractItem = 10,

    Contract = 11,

    Facility = 12,

    Host = 13,

    Location = 14,

    State = 15,

    Course = 16,

    ProductCategory = 17,

    ProductRelation = 18,

    Section = 19,

    ReleaseState = 20,

    ChangeAction = 21,

    Session = 22,

    Term = 23,

    Language = 24,

    Currency = 25,

    AgeCheck = 28,

    Region = 29,
    /// <summary>
    /// UserType
    /// **** Deprecated ***
    /// </summary>
    UserType = 30,

    RegionRole = 31,

    TimeZone = 32,

    CourseDeposit = 33,

    TermThresholdDataCapacity = 34,

    TermThresholdImportantDate = 35,

    TermThresholdCapacityManagementAlert = 36,

    TermThresholdPaymentOption = 37,

    RelativeRelation = 38,

    RelativeToItem = 39,

    DateType = 40,

    ComparisonOperator = 41,

    LimitType = 42,

    RoleCategory = 43,

    PackageType = 44,

    CourseSubCategory = 45,

    EmployeeStatus = 47,

    Discount = 49,

    ScheduleDefType = 51,

    MultipleInstructors = 52,

    ProductRatioType = 53,

    CompanyContactMethod = 54,

    AttributeDefName = 55,

    AttributeDataType = 56,

    DiscountValueType = 57,

    DiscountDateRelativeToItem = 58,

    HowHeardAbout = 59,

    HowHeardAboutCategory = 60,

    HowHeardAboutAudience = 61,

    CreatedEvent = 62,

    DiscountDivisionRelationship = 63,

    DiscountLimit = 64,

    ProductSubCategory = 65,

    DiscountPaymentReq = 66,

    InfoRequest = 67,

    DiscountScheduleType = 68,

    FollowUpStatusType = 69,

    CanadaProvince = 70,

    RelatedProductType = 71,

    AddressVerificationStatus = 72,

    FulfillmentStatusType = 73,

    CourseRelatedProductInterest = 74,

    TermThresholdCategoryType = 75,

    DiscountProductInclusionType = 76,

    DiscountBlanketRestriction = 77,

    DiscountDiscountTypeRestriction = 78,

    ScheduleDetailType = 79,

    DiscountApplicableToward = 80,

    OrderType = 81,

    AgeRange = 82,

    ShirtSize = 84,

    Suffix = 85,

    AcctgTransactionActivity = 86,

    AcctgTransactionStatus = 87,

    OrderStatus = 88,

    OrderDetailStatus = 89,

    OnlyType = 90,

    FeeAmountType = 91,

    FeeApplyType = 92,

    OrderUserRole = 93,

    PaymentType = 94,

    PaymentMethodType = 95,

    CreditCardType = 96,

    UserRelationship = 97,

    OrderComment = 98,

    Gender = 99,

    ExtraActionItemType = 100,

    OnlyExtraResolutionType = 101,

    RequestInterest = 102,

    CourseInterest = 103,

    AdjustmentCategoryType = 105,

    TermsAndConditionsType = 106,

    Buddy = 107,

    OrderDetailAdjustmentType = 108,

    FileType = 109,

    FileUsageType = 110,

    FileFormat = 111,

    FileDirectoryType = 112,

    OrderDetailDiscountStatusType = 119,

    CouponRoleType = 122,

    CouponType = 126,

    CancellationReason = 127,

    RewardProgramType = 128,

    RewardType = 129,

    CouponDetailType = 132,

    PaymentStatusType = 133,

    ActionItemPriorityType = 134,

    ActionItemCategoryType = 135,

    CouponStatus = 136,

    UserConfirmationType = 137,

    VIPType = 138,

    FormRequiredType = 139,

    FormCategoryType = 140,

    UserAccessRestrictionType = 141,

    RegistrationStatusType = 142,

    FormStatus = 143,

    SqlAgentTaskType = 144,

    UserActivityStatusCode = 145,

    ParticipantAgeRange = 146,

    UserRoleLevel = 147,

    CountryRegionType = 148,

    InfoRequestMethod = 149,

    AddressLabelType = 150,

    CampaignListType = 151,

    SessionAvailabilityStatusType = 152,

    OverrideReasonType = 153,

    CancellationCategoryType = 154,

    VoucherReasonType = 155,

    CancellationReasonType = 127,

    OverrideType = 156,

    ClientLogEntryType = 157,

    ClientIssueType = 158,

    ClientIssueStatusType = 159,

    ClientIssueSeverityType = 160,

    ClientIssueSourceType = 161,

    ClientLogTimePeriod = 162,

    ClientLogOwnerType = 163,

    ClientIssueCategory = 164,

    ClientLogReviewStatus = 166,

    ActionItemCompletionStrategy = 167,

    ClientIssueResolutionCategory = 168,

    CampaignListDisplayFields = 169,

    CampaignListDisplayFieldSubsets = 170,

    ClientLogRole = 171,

    Note = 172,

    ClientLogAssignment = 173,

    StatementViewTransactionsType = 174,

    StatementViewTimePeriodType = 175,

    ActionItemContactMethodType = 176,

    CorrespondenceUserRoleType = 177,

    FormSectionType = 178,

    CouponReceivingOrganizationType = 179,

    CorrespondenceDirectionType = 180,

    CorrespondenceContactType = 181,

    CorrespondenceTopicType = 182,

    DiscountCategory = 183,

    CouponCategory = 185,

    SecurityQuestionType = 186,

    CompanyAlias = 187,

    ReferenceContact = 188,

    ReferenceOK = 189,

    RefundPriority = 190,

    RefundType = 191,

    RefundStatus = 192,

    InfoRequestMethodCategory = 194,

    AnnouncementType = 195,

    OrderSource = 196,

    AllergyType = 197,

    ImmunizationType = 198,

    ImmunizationStatus = 199,

    InsuranceType = 200,

    FormPersonRole = 201,

    SchoolGrade = 202,

    OrderCommentWorkflowStatusType = 203,

    MedicationTimeTaken = 204,

    AttendanceType = 205,

    TermGroupStatus = 206,

    SurveyType = 207,

    SurveyAnswerFormat = 208,

    SurveyAnswerDataType = 209,

    SurveyAnswerCommentDispType = 210,

    EquipmentReportType = 211,

    EquipmentCategoryType = 212,

    SupplyRequestStatus = 213,

    SupplyCategoryType = 214,

    StatisticsAnswerType = 215,

    StatisticsQuestionType = 216,

    ProductImportantDateType = 217,

    ProductImportantDateStatusType = 218,

    ProductImptDateRelativeToType = 219,

    ProductSkillType = 220,

    JobFLSACompensation = 221,

    JobClass = 222,

    JobVisibility = 223,

    UserAccountTypeMask = 224,

    FormApplicationProcesssingStatus = 225,

    Availability = 227,

    ProductDisplayConfig = 228,

    JobResidencyPreference = 229,

    DiscountSubcategory = 230,

    SchoolDegree = 231,

    QAMeasurementType = 232,

    FormProcessHistoryType = 233,

    SavableSearchType = 234,

    SavableSearchCriteriaType = 235,

    JobInterviewType = 236,

    HRLogCategoryType = 237,

    HRLogActionType = 238,

    JobInterviewStatusType = 239,

    HRLogReasonType = 240,

    LetterCategoryType = 241,

    LetterType = 242,

    ApplicationProcesssingStatusPublic = 243,

    ApplicationProcessHistoryAction = 244,

    HRLogEntry = 245,

    JobOfferStatus = 246,

    JobOfferType = 247,

    FormLocationUsageType = 248,

    DiscretionaryPayReason = 249,

    PayItem = 250,

    PayItemDuration = 251,

    PayCalculation = 252,

    FormCategoryGroup = 253,

    FileDirectoryUsage = 254,

    ThresholdType = 255,

    Acquaintance = 256,

    AcquaintanceDuration = 257,

    PayDisbursementOption = 258,

    Visa = 259,

    BankAccount = 260,

    VisaStatus = 261,

    ProcessingStatusUsage = 262,

    ReferenceRating = 263,

    AvailabilityEnteredBy = 264,

    StaffAssignmentPubStatus = 265,

    StaffAssignmentType = 266,

    GeographicRegion = 267,

    JobPurview = 268,

    JobGenre = 269,

    HousingReason = 270,

    UserRoleRequired = 271,

    WorkFlowStatus = 272,

    FormPersonChange = 274,

    PayItemOffset = 275,

    DormRoomCapacity = 276,

    PayrollApprovalStatus = 277,

    PayrollCycle = 278,

    RelativeToItemGrouping = 280,

    SkillType = 281,

    LocationContactUsage = 282,

    LocationUserRole = 283,

    ShippingOption = 284,

    ApplicationSearchStatusInternal = 285,

    LSISection = 286,

    AttendanceAction = 289,

    Checkpoint = 291,

    DivisionText = 292,

    DiscountBannerUsageType = 293,

    ProductURLType = 294,

    ProductGenre = 295,

    ShirtSizeGroup = 296,

    JobApprovalRequirement = 297,

    /// <summary>
    /// ProductEquipment
    /// TypeClassID = 298
    /// NOTE: Deprecated on 05/12/2014
    ///       Merged with EquipmentCategoryType = 212
    /// </summary>
    //ProductEquipment = 298,

    TuitionAssistanceSalaryRange = 299,

    TuitionAssistanceStatus = 300,

    TuitionAssistanceSubStatus = 301,

    TuitionAssistanceLetterType = 302,

    StaffTaskCategory = 303,

    StaffTaskSchedule = 304,

    StaffTaskUserStatus = 305,

    StaffTaskDisplayType = 306,

    DivisionProgramType = 307,

    StudentActivityCategory = 308,

    StudentActivityNumOfPlayers = 309,

    StudentActivityDuration = 310,

    StudentActivityProps = 311,

    StudentActivityLocation = 312,

    TokenUsageType = 313,

    PhoneCarrier = 314,

    EquipmentUsage = 315,

    ClientIssueCategoryGrouping = 316,

    SurveyTagTypeMask = 317,

    /// <summary>
    /// Status of entries on the client purchase wait list.  Tracks status of wait list requests through the workflow.
    /// </summary>
    WaitListStatus = 318,

    ContactMethodCategory = 319,

    ProductTextUsage = 321,

    JobScheduleType = 322,

    /// <summary>
    /// For segmentation on the availability charts, week scheduler, and cap man features.
    /// </summary>
    ProductSchedule = 323,

    /// <summary>
    /// Used in Locations to designate a region with a State.
    /// </summary>
    StateSubRegion = 324,

    LocationSessionText = 325,

    CouponStatusForStaffReferral = 327,

    ImmunizationRefusal = 329,

    ProductVisibility = 330,

    WSQueueActivity = 331,

    WSQueueSyncTarget = 332,

    WSQueueAffectedTable = 333,

    SupplyRatio = 334,

    SupplyShipmentBox = 335,

    SupplyItemReturn = 336,

    SupplyRequest = 337,

    CorrespondenceCreationType = 338,

    CorrespondenceAccessType = 339,

    MaritalStatus = 340,

    RegFlowProgressStep = 342,

    SalesCatalog = 343,

    ShoppingAbandonmentEmailType = 344,

    RequestAmount = 347,

    ShoppingCart = 348,

    AllergySeverityType = 352,

    RoomOccupant = 354,

    RoomGender = 355,

    UTMCreationTrigger = 358,

    SupplyItemClass = 361,

    MetroArea = 365,

    StaffAppAvailability = 390
}

export enum AcctgTransactionActivityType {
    /// <summary>
    /// TypeID = 86000
    /// </summary>
    InitialPurchase = 86000,
    /// <summary>
    /// TypeID = 86001
    /// </summary>
    BalancePayment = 86001,
    /// <summary>
    /// TypeID = 86002
    /// </summary>
    CreditIssued_Return = 86002,
    /// <summary>
    /// TypeID = 86003
    /// </summary>
    CreditIssued_Discount = 86003,
    /// <summary>
    /// TypeID = 86004
    /// </summary>
    Refund = 86004,
    /// <summary>
    /// TypeID = 86005
    /// </summary>
    Reward = 86005,
    /// <summary>
    /// TypeID = 86006
    /// </summary>
    ApplyCredit = 86006,
    /// <summary>
    /// TypeID = 86007
    /// </summary>
    PaymentReversal = 86007,
    /// <summary>
    /// TypeID = 86008
    /// </summary>
    DiscountReversal = 86008,
    /// <summary>
    /// TypeID = 86009
    /// </summary>
    RewardReversal = 86009
}

export enum AcctgTransactionStatus {
    New = 87000, //1
    InProcess = 87001, //2
    Success = 87002, // 3
    ActionRequired = 87003, //4
    Failed = 87004, // 5
    ActionTaken = 87005 // 6
}

export enum Acquaintance {
    CoWorker = 256000,
    Professor = 256001,
    Supervisor = 256002,
    Other = 256003
}

export enum AcquaintanceDuration {
    OneToTwoMonths = 257000,
    ThreeToFiveMonths = 257001,
    SixToTwelveMonths = 257002,
    OneOrMoreYears = 257003,
    FiveOrMoreYears = 257004
}

export enum ActionItemCompletionStrategy {
    InternallyWithoutClient = 167000,
    ThroughCorrespondenceWithClient = 167001
}

export enum ActionItemCategoryType {
    AdditionalRequiredForms = 135000,
    AtSessionChangesFees = 135001,
    CarpoolChange = 135002,
    ClientIssue = 135003,
    ClientInfoUpdateChange_Data_Payment = 135004,
    DiscountCreditsVouchers = 135005,
    DocumentRequest = 135006,
    EmailBlast = 135007,
    Feedback = 135008,
    FeesCharges = 135009,
    FridayMailer = 135010,
    InappropriateConduct = 135011,
    IncompleteChange = 135012,
    IncorrectData = 135013,
    InventoryRequest = 135014,
    LocationFacilityInfo = 135015,
    OnlyExtraSituation = 135016,
    PayBalance = 135017,
    ProjectRequest = 135018,
    RequiredForms = 135019,
    SessionSpecialRequest = 135020,
    SessionLocationProductChange = 135021,
    SessionMailerPaperwork = 135022,
    Statement = 135023,
    SystemAdmin = 135024,
    WaitingList = 135025,
    Other = 135026,
    AtSessionIncompletePayment = 135027
}

/**
 * The method used to contact customer to resolve an action item.
 * TypeClassID = 176.
 */
export enum ActionItemContactMethodType {
    /// <summary>
    /// TypeID = 176000
    /// </summary>
    Phone = 176000,

    /// <summary>
    /// TypeID = 176001
    /// </summary>
    Email = 176001,

    /// <summary>
    /// TypeID = 176002
    /// </summary>
    Other = 176002
}

export enum ActionItemPriorityType {
    Required = 134000,
    Recommended = 134001,
    ForStatusOnly = 134002
}

export enum AdjustmentCategoryType {
    Cost = 105000,
    Payment = 105001
}

export enum AddressLabelType {
    Avery5960 = 150000,
    Avery5962 = 150001
}

export enum AddressType {
    Home = 6000,
    Work = 6001,
    Billing = 6002,

    /// <summary>
    /// Used only for sending tax or other official documents to term staff.
    /// TypeID = 6003.
    /// </summary>
    Permanent = 6003,
    Shipping = 6004
}

/**
 * Indicates how, or if, an address was validated.
 */
export enum AddressVerificationStatusType {
    /// <summary>
    /// Not Verified. TypeID = 72000.
    /// </summary>
    NotVerified = 72000,
    /// <summary>
    /// Verified By User. TypeID = 72001.
    /// </summary>
    VerifiedByUser = 72001,
    /// <summary>
    /// Verified By System. TypeID = 72002.
    /// </summary>
    VerifiedBySystem = 72002
}

export enum AgeCheckType {
    StartOfCalendarYear = 28000,
    StartOfTerm = 28001,
    StartOfSession = 28002,
    EndOfCalendarYear = 28003,
    EndOfTerm = 28004,
    EndOfSession = 28005,
    LastDayOnCampusInTheSession = 28006
}

export enum AgeRangeType {
    /// <summary>
    /// Course Recommender. TypeID = 82000.
    /// </summary>
    CourseRecommender = 82000,

    /// <summary>
    /// Used to designate a student's age group placement, which affects name tags, door decorations, participation in activities, etc.
    /// TypeID = 82001
    /// </summary>
    CampAgeGroup = 82001,

    /// <summary>
    /// Supported by Division(s).
    /// TypeID = 82002
    /// </summary>
    DivisionSupported = 82002,

    /// <summary>
    /// Dorm Room
    /// TypeID = 82003
    /// </summary>
    DormRoom = 82003
}

/**
 * Defines the named allergens that appear on the participants' required form.
 */
export enum AllergyType {
    /// <summary>
    /// TypeID = 197000
    /// </summary>
    HayFever = 197000,

    /// <summary>
    /// TypeID = 197001
    /// </summary>
    Asthma = 197001,

    /// <summary>
    /// TypeID = 197002
    /// </summary>
    Eczema = 197002,

    /// <summary>
    /// TypeID = 197003
    /// </summary>
    InsectStings = 197003,

    /// <summary>
    /// TypeID = 197004
    /// </summary>
    Peanuts = 197004,

    /// <summary>
    /// TypeID = 197005
    /// </summary>
    Other = 197005,

    /// <summary>
    /// TypeID = 197006
    /// </summary>
    Gluten = 197006,

    /// <summary>
    /// TypeID = 197007
    /// </summary>
    Dairy = 197007,

    /// <summary>
    /// TypeID = 197008
    /// </summary>
    Eggs = 197008,

    /// <summary>
    /// TypeID = 197009
    /// </summary>
    Meat = 197009,

    /// <summary>
    /// TypeID = 197010
    /// </summary>
    Nuts = 197010,

    /// <summary>
    /// TypeID = 197010
    /// </summary>
    Food = 197011
}

export enum AllergySeverityType {
    Mild = 352000,
    Moderate = 352001,
    Severe = 352002
}

/**
 * Defines the type of the Announcement.
 */
export enum AnnouncementType {
    /// <summary>
    /// TypeID = 195000.
    /// </summary>
    WelcomeMessage = 195000
}

export enum ApplicationProcessHistoryAction {
    /// <summary>
    /// TypeID = 244000
    /// </summary>
    Claim = 244000,
    /// <summary>
    /// TypeID = 244001
    /// </summary>
    Unclaim = 244001,
    /// <summary>
    /// TransferOwnership = 244002
    /// </summary>
    TransferOwnership = 244002
}

export enum ApplicationSearchStatusInternal {
    /// <summary>
    /// TypeID = 285000
    /// </summary>
    New = 285000,
    /// <summary>
    /// TypeID = 285001
    /// </summary>
    Claimed = 285001,
    /// <summary>
    /// TypeID = 285002
    /// </summary>
    InterviewPhase = 285002,
    /// <summary>
    /// TypeID = 285003
    /// </summary>
    OfferPhase = 285003,
    /// <summary>
    /// TypeID = 285004
    /// </summary>
    PendingEmploymentPaperwork = 285004,
    /// <summary>
    /// TypeID = 285005
    /// </summary>
    EmploymentPaperworkCompleted = 285005,
    /// <summary>
    /// TypeID = 285006
    /// </summary>
    ClearedForScheduling = 285006,
    /// <summary>
    /// Scheduled = 285007
    /// </summary>
    Scheduled = 285007,
    /// <summary>
    /// Rejected = 285008
    /// </summary>
    Rejected = 285008,
    /// <summary>
    /// Terminated = 285009
    /// </summary>
    Terminated = 285009
}

export enum AttendanceAction {
    CheckIn = 289000,
    CheckOut = 289001,
    MarkAbsent = 289002
}

export enum AttendanceType {
    Absent = 205000,
    Present = 205001,
    Late = 205002
}

export enum AttributeDataType {
    /// <summary>
    /// TypeID = 56000
    /// </summary>
    Integer = 56000,

    /// <summary>
    /// TypeID = 56001
    /// </summary>
    String = 56001,

    /// <summary>
    /// TypeID = 56002
    /// </summary>
    Boolean = 56002,

    /// <summary>
    /// TypeID = 56003
    /// </summary>
    DateTime = 56003,

    /// <summary>
    /// TypeID = 56004
    /// </summary>
    Money = 56004
}

export enum AttributeDefNameType {
    DefaultMaxParticipants = 55000,
    DefaultMaxOvernight = 55001,
    DefaultMaxWeekend = 55002,
    DefaultMapsAndDirectionsUrl = 55003,
    DefaultLocationInfoUrl = 55004,

    /// <summary>
    /// TypeID = 55005.
    /// </summary>
    DefaultPhotoURL = 55005,

    /// <summary>
    /// TypeID = 55006.
    /// </summary>
    DefaultMaxWeekendWithin = 55006,

    /// <summary>
    /// Offset from Session Start date which represents the deadline for purchasing or adding course products at a Location.
    /// TypeID = 55007.
    /// </summary>
    LocationSessionNewAddEndDate = 55007,

    /// <summary>
    /// Offset from Session Start date which represents the deadline for changing options or cancelling courses at a Location.
    /// TypeID = 55008.
    /// </summary>
    LocationSessionChgCancelEndDate = 55008,

    /// <summary>
    /// Location map url (on google maps or yahoo maps etc.), to show location map to job applicants.
    /// It does not depend on anything (term, session, important dates...)
    /// TypeID = 55009.
    /// </summary>
    JobLocationMapURL = 55009,

    /// <summary>
    /// Location is visible during registration.
    /// TypeID = 55010.
    /// </summary>
    AllowsRegistrations = 55010,

    /// <summary>
    /// Visible in the application process.
    /// TypeID = 55011.
    /// </summary>
    HasTermStaff = 55011,

    /// <summary>
    /// Distinguishes one version of a form from another.  E.g., international vs. domestic version of the W-4.
    /// TypeID = 55012.
    /// </summary>
    FormVariant = 55012,

    /// <summary>
    /// Used to identify forms within a Required Type or Form Category Type.  Provides a constant ID that can be used in enums acrosss systems.
    /// TypeID = 55013.
    /// </summary>
    FormIdentifier = 55013,

    /// <summary>
    /// Used to indicate how many positions of a given job genre are required at a given location.
    /// TypeID = 55014.
    /// </summary>
    JobGenreCount = 55014,

    /// <summary>
    /// TypeID = 55015.
    /// </summary>
    OrientationStartDate = 55015,

    /// <summary>
    /// TypeID = 55016.
    /// </summary>
    OrientationLength = 55016,

    /// <summary>
    /// TypeID = 55017.
    /// </summary>
    SetUpStartDate = 55017,

    /// <summary>
    /// TypeID = 55018.
    /// </summary>
    SetUPLength = 55018,
    EmergencyContactOtherPhone = 55019,
    EmergencyContactOtherName = 55020,
    ParkingPasses = 55021,
    BestParkingRatesStaff = 55022,
    BestParkingRatesFamilyShowcase = 55023,
    BestParkingRatesPressVisits = 55024,
    BestParkingLotsLab = 55025,
    BestParkingLotsResidenceHall = 55026,
    ParkingConsiderationsCheckInOut = 55027,
    PostDirectionalSigns = 55028,
    ConstructionThatEffectsParkingOrCheckInOut = 55029,
    RecentSecurityIssues = 55030,
    SpecialFormsRequired = 55031,
    MailroomHours = 55032,
    VerizonCellPhonesReception = 55033,
    IndoorspaceForFamilyShowcase = 55034,
    Accesstosupplystorage = 55035,
    TvDvdPlayerInResidenceHall = 55036,
    DistanceFromTheDropoffPickupLocationToLabs = 55037,
    DistanceFromLabsToDorms = 55038,
    DistanceFromDiningHallToDorms = 55039,
    DistanceFromDiningHallToLabs = 55040,
    SportsFieldsOrGrassyAreas = 55041,
    IsSportsFieldGrassyAreaOnCampus = 55042,
    BasketballCourt = 55043,
    SwimmingPool = 55044,
    Volleyball = 55045,
    GymOrRecreationCenter = 55046,
    Bowling = 55047,
    Arcade = 55048,
    PoolHall = 55049,
    CoffeeShop = 55050,
    YogurtOrIceCreamShop = 55051,
    Bookstore = 55052,
    Shopping = 55053,
    CampusTours = 55054,
    ScienceCenterOrMuseum = 55055,
    ImaxTheatre = 55056,
    EarlyStaffArrivalDate = 55057,
    MediaAllowed = 55058,
    MediaParkingPass = 55059,
    BestParkingForMedia = 55060,
    OffCampusDayTrips = 55061,
    PassesForAccessToGymsPoolsEtc = 55062,
    HandyStoresNearby = 55063,
    RestaurantsNearby = 55064,
    WeekendActivities = 55065,
    DoesItRainOftenInSummer = 55066,
    EarliestLargeShipmentArrivalDate = 55067,
    CampSupplyStorageLocation = 55068,
    CampSupplyStorageToLabTransportation = 55069,
    HowManySingleRooms = 55070,
    HowManyDoubleRooms = 55071,
    HowManyTripleRooms = 55072,
    HowManyQuadRooms = 55073,
    TotalOfBeds = 55074,
    AirConditionedRooms = 55075,
    BathroomsAreShared = 55076,
    MattressSize = 55077,
    WheelchairAccessibleRoomsAvailable = 55078,
    HowOftenAreTheRoomsCleaned = 55079,
    DoorLocks = 55080,
    ArelinensIncluded = 55081,
    WhichLinensAreProvided = 55082,
    LimitedLinensPossible = 55083,
    SodaSnackMachines = 55084,
    WasherDryerAccess = 55085,
    AdditionalNotes = 55086,
    DiningHallBreakfastHours = 55087,
    DiningHallLunchHours = 55088,
    DiningHallDinnerHours = 55089,
    DiningHallOtherhours = 55090,
    BuffetAllYouCanEat = 55091,
    VegetarianOptions = 55092,
    KosherOptions = 55093,
    GlutenFreeOptions = 55094,
    CanDiningHallAccommodateAllergies = 55095,
    WillDiningBeOpen4thOfJuly = 55096,
    MealCountSystem = 55097,
    OutsideFoodAllowedSundayAndFriday = 55098,
    AreBagLunchesAllowedInTheDiningHall = 55099,
    RefrigeratorAccess = 55100,
    CanLunchBePurchased = 55101,
    Labhoursaccessibletostaff = 55102,
    LabHoursAccessibleToComputerSetupTeardown = 55103,
    WalkingDistanceBetweenLabs = 55104,
    DateAccessToSpaceIsNeeded = 55105,
    WillWeBeIssuedKeyForRooms = 55106,
    WillTablesAndChairsWillBeProvidedByUniversity = 55107,
    WillAnyoneElseHaveAccessToTheRooms = 55108,
    DimensionsOfTheTables = 55109,
    CandecorationsBePutOnWalls = 55110,
    WillAccessBeLimitedOnJuly4th = 55111,
    AdditionalLabNotes = 55112,
    WillElectricianMeetUsForComputerSetup = 55113,
    DoYouProvideIPAddressesForOurComputers = 55114,
    DHCPorOther = 55115,
    AnythingThatWeNeedtoProvide = 55116,
    ParkingPassNeeded = 55117,
    WhoWillProvideTheParkingPass = 55118,
    IsThereaLoadingDockAvailable = 55119,
    WhatParkingLotShouldMTUse = 55120,
    IsThereSpecificEntranceThatMTShouldUse = 55121,
    WillThereBeAnElevator = 55122,
    AirConditioned = 55123,
    IsTheSpaceWheelchairAccessible = 55124,
    DirectorStationBuildingAndRoom = 55125,
    EthernetWallPortCount = 55126,
    CircuitAmps = 55127,
    CircuitOutlets = 55128,
    CircuitNotesComments = 55129,
    ElectricalSchematicwillbeprovided = 55130,
    FloorPlanwillbeprovided = 55131,

    /// <summary>
    /// TypeID = 55141.
    /// </summary>
    DefaultAlertTitle = 55141,

    /// <summary>
    /// TypeID = 55142.
    /// </summary>
    DefaultAlertNotes = 55142
}

export enum Availability {
    /// <summary>
    /// TypeID = 227000.
    /// </summary>
    Available = 227000,

    /// <summary>
    /// TypeID = 227001.
    /// </summary>
    Unavailable = 227001
}

export enum AvailabilityEnteredBy {
    /// <summary>
    /// TypeID = 264000
    /// </summary>
    ApplicantEmployee = 264000,

    /// <summary>
    /// TypeID = 264001
    /// </summary>
    HiringManagerOrAdmin = 264001
}

/**
 * Used to indicate AccountType in the UserFormDisbursement table.
 */
export enum BankAccount {
    /// <summary>
    /// TypeID = 260000.
    /// </summary>
    Checking = 260000,
    /// <summary>
    /// TypeID = 260001.
    /// </summary>
    Savings = 260001
}

/**
 * Used to indicate Buddy Group with or Room with selections in the OderDetailBuddy table.
 */
export enum BuddyType {
    /// <summary>
    /// TypeID = 107000.
    /// </summary>
    GroupWith = 107000,
    /// <summary>
    /// TypeID = 107001.
    /// </summary>
    RoomWith = 107001
}

/**
 * Used to categorize cancellation reasons for customer/customer service
 */
export enum CancellationCategoryType {
    /// <summary>
    /// TypeID = 154000
    /// </summary>
    Customer = 154000,
    /// <summary>
    /// TypeID = 154001
    /// </summary>
    CustomerService = 154001
}

export enum CancellationReasonType {
    /// <summary>
    /// TypeID = 127010
    /// </summary>
    UnpaidBalance = 127010,
    /// <summary>
    /// TypeID = 127014
    /// </summary>
    CSAdjustmentReturn = 127014
}

/**
 * Selectable Display Fields used by the Campaign List Maker
 */
export enum CampaignListDisplayFields {
    ParticipantAccountNumber = 169000,
    ParticipantFirstName = 169001,
    ParticipantLastName = 169002,
    ParticipantMiddleInitial = 169003,
    ParticipantDOB = 169004,
    ParticipantAgeToday = 169005,
    ParticipantGender = 169006,
    AdultFirstName = 169007,
    AdultLastName = 169008,
    AdultAccountNumber = 169009,
    AdultUserName = 169010,
    Relationship = 169011,
    AdultHomePhone = 169012,
    AdultWorkPhone = 169013,
    AdultCellPhone = 169014,
    AdultFax = 169015,
    AdultEmail = 169016,
    AdultEmailOK = 169017,
    AdultAddress = 169018,
    AdultAddress2 = 169019,
    AdultCity = 169020,
    AdultStateProvince = 169021,
    AdultPostalCode = 169022,
    AdultCountry = 169023,
    AdultMailingOK = 169024,
    AccessRestriction = 169025,
    CatalogRequestDate = 169026,
    iDOnsiteRequestDate = 169027,
    AccountCreationDate = 169028,
    HowHeardAbout = 169029,
    VerificationStatus = 169030,
    LastVerificationDate = 169031
}

/**
 *  Used to catagorize Campaign List Display Fields.
 */
export enum CampaignListDisplayFieldSubsets {
    ClientDisplayList = 170000,
    ProspectDisplayList = 170001
}

/**
 * Used in Campaign List Maker to select the type of campaigns list results.
 */
export enum CampaignListType {
    Mailings = 151000,
    EmailBlast = 151001,
    PressInquiry = 151002,
    CatalogMailing = 151003
}

/**
 * The list of Canada Provinces and Territories.
 */
export enum CanadaProvinceType {
    /// <summary>
    /// Alberta. TypeID = 70009
    /// </summary>
    AB = 70009,
    /// <summary>
    /// British Columbia. TypeID = 70006
    /// </summary>
    BC = 70006,
    /// <summary>
    /// Manitoba. TypeID = 70005
    /// </summary>
    MB = 70005,
    /// <summary>
    /// New Brunswick. TypeID = 70004
    /// </summary>
    NB = 70004,
    /// <summary>
    /// Newfoundland and Labrador. TypeID = 70010
    /// </summary>
    NL = 70010,
    /// <summary>
    /// Nova Scotia. TypeID = 70003
    /// </summary>
    NS = 70003,
    /// <summary>
    /// Northwest Territories. TypeID = 70011
    /// </summary>
    NT = 70011,
    /// <summary>
    /// Nunavut. TypeID = 70013
    /// </summary>
    NU = 70013,
    /// <summary>
    /// Ontario. TypeID = 70000
    /// </summary>
    ON = 70000,
    /// <summary>
    /// Prince Edward Island. TypeID = 70007
    /// </summary>
    PE = 70007,
    /// <summary>
    /// Quebec. TypeID = 70001
    /// </summary>
    QC = 70001,
    /// <summary>
    /// Saskatchewan. TypeID = 70008
    /// </summary>
    SK = 70008,
    /// <summary>
    /// Yukon. TypeID = 70012
    /// </summary>
    YT = 70012
}

/**
 * Reason for canceling the session. Admin sees all records. Client
 * sees only the subset. See PulseCache for the method to get the list.
 * <remarks>
 * Used in the Cancel session workflow.
 * </remarks>
 */
export enum CancellationReason {
    StudentSick = 127000,
    SchedulingConflict = 127001,
    FamilyEmergency = 127002,
    MedicalCondition = 127003,
    FemaleOnly = 127004,
    CourseOnly = 127005,
    TravelingAbroad = 127006,
    FinancialHardship = 127007,
    UnhappyWithServiceAtCamp = 127008,
    DoNotAgreeToTandC = 127009,
    UnpaidBalance = 127010,
    IncompleteRequiredForms = 127011,
    NoReason = 127012
}

/**
 * NOT A DATABASE TYPE
 * Must match types in \Pulse.BusinessLogic\Enums\ChangePurchasedOrderType.cs
 */
export enum ChangePurchasedOrderType {
    ChangeLocation = 1,
    ChangeSessionDate = 2,
    ChangeCourseSession = 3,
    ChangeOptionsOnly = 4,
    Cancel = 5, //Added for SPA
    AddNew = 6 //Added for SPA
}

/**
 * Describes the type of record stored in the UserCheckPoint table.
 */
export enum CheckpointType {
    /// <summary>
    /// TypeID = 291000
    /// </summary>
    StudentCSR = 291000,

    /// <summary>
    /// TypeID = 291001
    /// </summary>
    StaffCSR = 291001,

    /// <summary>
    /// TypeID = 291002
    /// </summary>
    StaffEarlyArrival = 291002,

    /// <summary>
    /// TypeID = 291003
    /// </summary>
    StaffRooming = 291003
}

export enum ClientIssueCategory {
    Instructor = 164000,
    Other = 164001
}

export enum ClientIssueCategoryGrouping {
    RM_EvalManagement = 316000
}

export enum ClientIssueResolutionCategory {
    TalkedToInstructor = 168000,
    TalkedToDirector = 168001,
    ChangedToDifferentProduct = 168002,
    Voucher = 168003,
    Refund = 168004,
    Other = 168005
}

export enum ClientIssueStatusType {
    New = 159000,
    InProgress = 159001,
    RequiresCSMgtReview = 159002,
    EscalateToManager = 159003,
    EscalateToRegionalManager = 159004,
    ProposedResolutionInProgress = 159005,
    Closed = 159006
}

export enum ClientIssueSeverityType {
    None = 160000,
    Low = 160001,
    Standard = 160002,
    High = 160003,
    Critical = 160004
}

export enum ClientIssueSourceType {
    DirectPhoneCall = 161000,
    ParentEvaluation = 161009,
    StudentEvaluation = 161011
}

export enum ClientIssueType {
    Concern = 158000,
    Suggestion = 158001
}

export enum ClientLogAssignmentType {
    CSManager = 173000,
    RegionalManager = 173001,
    Unassigned = 173002
}

export enum ClientLogEntryType {
    ClientIssue = 157000,
    ActionIssue = 157001
}

export enum ClientLogOwnerType {
    Individual = 163000,
    Position = 163001
}

export enum ClientLogRoleType {
    ConcernedClient = 171000,
    InvolvedParticipant = 171001,
    IssueOwner = 171002,
    ClosedByUser = 171003,
    ToBeCompletedBy = 171004,
    ActionItemClient = 171005,
    ReviewedBy = 171006,
    ClientInContext = 171007
}

export enum ClientLogTimePeriod {
    BeforeSession = 162000,
    DuringSession = 162001,
    AfterSession = 162002
}

export enum ClientLogReviewStatus {
    NotReviewed = 166000,
    Reviewed = 166001
}

/**
 * Used for company and division aliases.  Aliases are display names for various purposes.
 */
export enum CompanyAliasType {
    /// <summary>
    /// Display name on the Public site.  Aliases the legal name or the official company name in the Company table.
    /// TypeID = 187000.
    /// </summary>
    PublicCompanyName = 187000,
    SubBrand2Singular = 187001,
    SubBrand2Plural = 187002
}

export enum CompanyContactMethodType {
    /// <summary>
    /// TypeID = 54000
    /// </summary>
    Email = 54000,
    /// <summary>
    /// TypeID = 54001.
    /// </summary>
    Phone = 54001,
    /// <summary>
    /// TypeID = 54002.
    /// </summary>
    PhoneInternational = 54002,
    /// <summary>
    /// TypeID = 54003.
    /// </summary>
    Fax = 54003,
    /// <summary>
    /// TypeID = 54004.
    /// </summary>
    PhoneTollFree = 54004,

    /// <summary>
    /// TypeID = 54005.
    /// </summary>
    InternalTechSupportEmail = 54005,

    /// <summary>
    /// TypeID = 54006.
    /// </summary>
    DoNotReplyEmail = 54006
}

export enum CompanyType {
    /// <summary>
    /// TopLevel
    /// </summary>
    TopLevel = 3000,
    /// <summary>
    /// Subsidiary
    /// </summary>
    Subsidiary = 3001,
    /// <summary>
    /// Partner
    /// </summary>
    Partner = 3002,
    /// <summary>
    /// Licensee
    /// </summary>
    Licensee = 3003,
    /// <summary>
    /// VendorSupplier
    /// </summary>
    VendorSupplier = 3004,
    /// <summary>
    /// Host
    /// </summary>
    Host = 3005,

    /// <summary>
    /// Camp Advisor Organization.
    /// TypeID = 3006.
    /// </summary>
    CampAdvisor = 3006,

    /// <summary>
    /// Company whose referrals will be tracked with a cookie.  These companies will get referral codes.
    /// TypeID = 3007.
    /// </summary>
    ContractElectronicReferralSource = 3007
}

export enum ComparisonOperator {
    /// <summary>
    /// Equals
    /// </summary>
    Equals = 41000,
    /// <summary>
    /// LessThan
    /// </summary>
    LessThan = 41001,
    /// <summary>
    /// GreaterThan
    /// </summary>
    GreaterThan = 41002,
    /// <summary>
    /// LessThanEquals
    /// </summary>
    LessThanEquals = 41003,
    /// <summary>
    /// GreaterThanEquals
    /// </summary>
    GreaterThanEquals = 41004
}

export enum ContactMethodType {
    HomePhone = 7000,
    OfficePhone = 7001,
    CellPhone = 7002,
    Fax = 7003,
    Email = 7004,
    URL = 7005,
    Other = 7006,
    /// <summary>
    /// This type is deprecated.
    /// It was used in the Location-Session Tab for Location contact.  This information is now stored in the LSI.
    /// </summary>
    EmergencyPhone = 7007
}

export enum ContactMethodCategory {
    /// <summary>
    /// TypeID = 319000
    /// </summary>
    PhoneNumbers = 319000
}

/**
 * Specifies Contact Type of the correspondence.
 */
export enum CorrespondenceContactType {
    /// <summary>
    /// TypeID = 181000
    /// </summary>
    PhoneCall = 181000,

    /// <summary>
    /// TypeID = 181001
    /// </summary>
    Voicemail = 181001,

    /// <summary>
    /// TypeID = 181002
    /// </summary>
    Email = 181002,

    /// <summary>
    /// TypeID = 181003
    /// </summary>
    Fax = 181003,

    /// <summary>
    /// TypeID = 181004
    /// </summary>
    Mail = 181004,

    /// <summary>
    /// TypeID = 181005
    /// </summary>
    WalkIn = 181005,

    /// <summary>
    /// TypeID = 181006
    /// </summary>
    SocialMedia = 181006
}

/**
 * Specifies direction of the correspondence with respect to CS Admin.
 */
export enum CorrespondenceDirectionType {
    /// <summary>
    /// TypeID = 180000
    /// </summary>
    Incoming = 180000,

    /// <summary>
    /// TypeID = 180001
    /// </summary>
    Outgoing = 180001
}

/**
 * Correspondence Topic Type
 */
export enum CorrespondenceTopicType {
    /// <summary>
    /// Add - Session (TypeID = 182000)
    /// </summary>
    AddSession = 182000,

    /// <summary>
    /// Add/Remove - Meal Plan (TypeID = 182001)
    /// </summary>
    AddOrRemoveMealPlan = 182001,

    /// <summary>
    /// Add/Remove - Residency (TypeID = 182002)
    /// </summary>
    AddOrRemoveResidency = 182002,

    /// <summary>
    /// Cancellation (TypeID = 182003)
    /// </summary>
    Cancellation = 182003,

    /// <summary>
    /// Change - Billing Info (TypeID = 182004)
    /// </summary>
    ChangeBillingInfo = 182004,

    /// <summary>
    /// Change - Carpool (TypeID = 182005)
    /// </summary>
    ChangeCarpool = 182005,

    /// <summary>
    /// Change - Contact Info (TypeID = 182006)
    /// </summary>
    ChangeContactInfo = 182006,

    /// <summary>
    /// Change - Course (TypeID = 182007)
    /// </summary>
    ChangeCourse = 182007,

    /// <summary>
    /// Change - Location (TypeID = 182008)
    /// </summary>
    ChangeLocation = 182008,

    /// <summary>
    /// Change - Meal Plan (TypeID = 182009)
    /// </summary>
    ChangeMealPlan = 182009,

    /// <summary>
    /// Change - Residency (TypeID = 182010)
    /// </summary>
    ChangeResidency = 182010,

    /// <summary>
    /// Change - Session (TypeID = 182011)
    /// </summary>
    ChangeSession = 182011,

    /// <summary>
    /// Client Reference Program (TypeID = 182012)
    /// </summary>
    ClientReferenceProgram = 182012,

    /// <summary>
    /// Client Issue (TypeID = 182013)
    /// </summary>
    ClientIssue = 182013,

    /// <summary>
    /// Welcome Packet (TypeID = 182014)
    /// </summary>
    WelcomePacket = 182014,

    /// <summary>
    /// Email - Required Forms (TypeID = 182015)
    /// </summary>
    EmailRequiredForms = 182015,

    /// <summary>
    /// Email - Client Reference Program (TypeID = 182016)
    /// </summary>
    EmailClientReferenceProgram = 182016,

    /// <summary>
    /// Email - Promotional (TypeID = 182017)
    /// </summary>
    EmailPromotional = 182017,

    /// <summary>
    /// Tech Rocket (TypeID = 182018)
    /// </summary>
    TechRocket = 182018,

    /// <summary>
    /// Email - Announcement (TypeID = 182019)
    /// </summary>
    EmailAnnouncement = 182019,

    /// <summary>
    /// Email - Balance Due (TypeID = 182020)
    /// </summary>
    EmailBalanceDue = 182020,

    /// <summary>
    /// Email – Feedback (TypeID = 182021)
    /// </summary>
    EmailFeedback = 182021,

    /// <summary>
    /// Feedback (TypeID = 182022)
    /// </summary>
    Feedback = 182022,

    /// <summary>
    /// Forms - Required Forms (TypeID = 182023)
    /// </summary>
    FormsRequiredForms = 182023,

    /// <summary>
    /// Forms - Additional  Required Forms (TypeID = 182024)
    /// </summary>
    FormsAdditionalRequiredForms = 182024,

    /// <summary>
    /// General Info (TypeID = 182025)
    /// </summary>
    GeneralInfo = 182025,

    /// <summary>
    /// Inappropriate Conduct (TypeID = 182026)
    /// </summary>
    InappropriateConduct = 182026,

    /// <summary>
    /// Location/Facility questions (TypeID = 182027)
    /// </summary>
    LocationOrFacilityquestions = 182027,

    /// <summary>
    /// Maps & Driving Directions (TypeID = 182028)
    /// </summary>
    MapsAndDrivingDirections = 182028,

    /// <summary>
    /// Only/Extra Situation (TypeID = 182029)
    /// </summary>
    OnlyOrExtraSituation = 182029,

    /// <summary>
    /// Participant Project (TypeID = 182030)
    /// </summary>
    ParticipantProject = 182030,

    /// <summary>
    /// Pay Balance (TypeID = 182031)
    /// </summary>
    PayBalance = 182031,

    /// <summary>
    /// Refunds/Credits (TypeID = 182032)
    /// </summary>
    RefundsOrCredits = 182032,

    /// <summary>
    /// Staff Referral Rebate (TypeID = 182033)
    /// </summary>
    StaffReferralRebate = 182033,

    /// <summary>
    /// Statement (TypeID = 182034)
    /// </summary>
    Statement = 182034,

    /// <summary>
    /// Other (TypeID = 182035)
    /// </summary>
    Other = 182035,

    /// <summary>
    /// Email - Balance Overdue 1 (TypeID = 182036)
    /// </summary>
    EmailBalanceOverdue1 = 182036,

    /// <summary>
    /// Email - Balance Overdue 2 (TypeID = 182037)
    /// </summary>
    EmailBalanceOverdue2 = 182037,

    /// <summary>
    /// Email - Balance Overdue 3 (TypeID = 182038)
    /// </summary>
    EmailBalanceOverdue3 = 182038,

    /// <summary>
    /// Email - Balance Overdue 4 (TypeID = 182039)
    /// </summary>
    EmailBalanceOverdue4 = 182039,

    /// <summary>
    /// Unsubscribed (TypeID = 182040)
    /// </summary>
    Unsubscribed = 182040,

    /// <summary>
    /// At Session - Attendance (TypeID = 182041)
    /// </summary>
    AtSessionAttendance = 182041,

    /// <summary>
    /// Session Mailer (TypeID = 182042)
    /// </summary>
    SessionMailer = 182042,

    /// <summary>
    /// Subscription Auto-Renew Success (TypeID = 182043)
    /// </summary>
    SubscriptionAutoRenewSuccess = 182043,

    /// <summary>
    /// Subscription Auto-Renew Failure (TypeID = 182044)
    /// </summary>
    SubscriptionAutoRenewFailure = 182044,

    /// <summary>
    /// Subscription Auto-Renew Reminder 2 (TypeID = 182045)
    /// </summary>
    SubscriptionAutoRenewReminder2 = 182045,

    /// <summary>
    /// Subscription Auto-Renew Reminder 1 (TypeID = 182046)
    /// </summary>
    SubscriptionAutoRenewReminder1 = 182046,

    /// <summary>
    /// Subscription Std Expiry Reminder 2 (TypeID = 182047)
    /// </summary>
    SubscriptionStdExpiryReminder2 = 182047,

    /// <summary>
    /// Subscription Std Expiry Reminder 1 (TypeID = 182048)
    /// </summary>
    SubscriptionStdExpiryReminder1 = 182048,

    /// <summary>
    /// Subscription Expiration (TypeID = 182049)
    /// </summary>
    SubscriptionExpiration = 182049,

    /// <summary>
    /// Fee (TypeID = 182050)
    /// </summary>
    Fee = 182050,

    /// <summary>
    /// TBD 2 (TypeID = 182051)
    /// </summary>
    TBD2 = 182051,

    /// <summary>
    /// At Session - Medication Schedule Change (TypeID = 182052)
    /// </summary>
    AtSessionMedicationScheduleChange = 182052,

    /// <summary>
    /// At Session - Note to Parent (TypeID = 182053)
    /// </summary>
    AtSessionNotetoParent = 182053,

    /// <summary>
    /// Age Exception (TypeID = 182054)
    /// </summary>
    AgeException = 182054,

    /// <summary>
    /// BGC Forms (TypeID = 182055)
    /// </summary>
    BGCForms = 182055,

    /// <summary>
    /// Change - Security Information (TypeID = 182056)
    /// </summary>
    ChangeSecurityInformation = 182056,

    /// <summary>
    /// Change - Student Information (TypeID = 182057)
    /// </summary>
    ChangeStudentInformation = 182057,

    /// <summary>
    /// Check-in Check-out (TypeID = 182058)
    /// </summary>
    CheckinCheckout = 182058,

    /// <summary>
    /// Course Pre-Requisites (TypeID = 182059)
    /// </summary>
    CoursePreRequisites = 182059,

    /// <summary>
    /// Discounts (TypeID = 182060)
    /// </summary>
    Discounts = 182060,

    /// <summary>
    /// Login Assistance (TypeID = 182061)
    /// </summary>
    LoginAssistance = 182061,

    /// <summary>
    /// Payment Exception (TypeID = 182062)
    /// </summary>
    PaymentException = 182062,

    /// <summary>
    /// Roommate Request (TypeID = 182063)
    /// </summary>
    RoommateRequest = 182063,

    /// <summary>
    /// TAP/Scholarships (TypeID = 182064)
    /// </summary>
    TAPOrScholarships = 182064,

    /// <summary>
    /// T-Shirt Size (TypeID = 182065)
    /// </summary>
    TShirtSize = 182065,

    /// <summary>
    /// Waitlist (TypeID = 182066)
    /// </summary>
    Waitlist = 182066,

    /// <summary>
    /// Client Contact Request (TypeID = 182067)
    /// </summary>
    ClientContactRequest = 182067,

    /// <summary>
    /// Accessed Account (TypeID = 182068)
    /// </summary>
    AccessedAccount = 182068,

    /// <summary>
    /// Group-With Request (TypeID = 182069)
    /// </summary>
    GroupWithRequest = 182069,

    /// <summary>
    /// Connect Student (TypeID = 182070)
    /// </summary>
    ConnectStudent = 182070,

    /// <summary>
    /// Change - Student Relationship (TypeID = 182071)
    /// </summary>
    ChangeStudentRelationship = 182071,

    /// <summary>
    /// Reset User Activity (TypeID = 182072)
    /// </summary>
    ResetUserActivity = 182072,

    /// <summary>
    /// Medic App Text Message (TypeID = 182073)
    /// </summary>
    MedicAppTextMessage = 182073,

    /// <summary>
    /// Medic App Add Medication (TypeID = 182074)
    /// </summary>
    MedicAppAddMedication = 182074,

    /// <summary>
    /// Medic App Change Medication (TypeID = 182075)
    /// </summary>
    MedicAppChangeMedication = 182075,

    /// <summary>
    /// Medic App Remove Medication (TypeID = 182076)
    /// </summary>
    MedicAppRemoveMedication = 182076
}

/**
 * Specifies the role the individual plays with respect to the correspondence.
 */
export enum CorrespondenceUserRoleType {
    /// <summary>
    /// TypeID = 177000
    /// </summary>
    Client = 177000,

    /// <summary>
    /// TypeID = 177001
    /// </summary>
    InvolvedParticipant = 177001,

    /// <summary>
    /// TypeID = 177002
    /// </summary>
    OtherInvolvedPerson = 177002,

    /// <summary>
    /// TypeID = 177003
    /// </summary>
    Admin = 177003,

    /// <summary>
    /// TypeID = 177004
    /// </summary>
    Reviewer = 177004,

    /// <summary>
    /// TypeID = 177005
    /// </summary>
    ClientInContext = 177005
}

/**
 * Parent Class for Coupon Types. Classifies for definition and usage.
 */
export enum CouponCategory {
    /// <summary>
    /// Includes items like tuition assistance, marketing, and scholarships.
    /// TypeID = 185000.
    /// </summary>
    Coupon = 185000
}

/**
 * Defines the type of the Detail record, attached to the Coupon record.
 */
export enum CouponDetailType {
    /// <summary>
    /// TypeID = 132000.
    /// </summary>
    StudentName = 132000,

    /// <summary>
    /// TypeID = 132001.
    /// </summary>
    ParentName = 132001,

    /// <summary>
    /// TypeID = 132002.
    /// </summary>
    ParentEmail = 132002,

    /// <summary>
    /// TypeID = 132003.
    /// </summary>
    InvalidReason = 132003,

    /// <summary>
    /// TypeID = 132004.
    /// </summary>
    Note = 132004,

    /// <summary>
    /// TypeID = 132005.
    /// </summary>
    SequenceNumber = 132005,

    /// <summary>
    /// TypeID = 13200.6
    /// </summary>
    SponsoringOrganization = 132006,

    /// <summary>
    /// TypeID = 132007.
    /// </summary>
    ReceivingOrganizationOrEvent = 132007,

    /// <summary>
    /// TypeID = 132008.
    /// </summary>
    Description = 132008,

    /// <summary>
    /// Name of the friend for a Term Staff Refer-a-Friend for hire coupon.
    /// </summary>
    ApplicantName = 132009,

    /// <summary>
    /// Email address of the friend for a Term Staff Refer-a-Friend for hire coupon.
    /// </summary>
    ApplicantEmail = 132010,

    /// <summary>
    /// For CouponDetails where the RewardAmount, Adjustor Name, AdjustmentDate and Adjustment Reason
    /// are logged for a given RAF for hire coupon.
    /// </summary>
    RewardAmountHistory = 132011
}

export enum CouponReceivingOrganizationType {
    /// <summary>
    /// TypeID = 179000
    /// </summary>
    Auctions = 179000,

    /// <summary>
    /// TypeID = 179001
    /// </summary>
    NonProfits = 179001,

    /// <summary>
    /// TypeID = 179002
    /// </summary>
    HostLocationContacts = 179002,

    /// <summary>
    /// TypeID = 179003
    /// </summary>
    ProductCorporatePartners = 179003,

    /// <summary>
    /// TypeID = 179004
    /// </summary>
    Other = 179004
}

export enum CouponStatus {
    /// <summary>
    /// TypeID = 136000.
    /// </summary>
    NotUsed = 136000,

    /// <summary>
    /// TypeID = 136001.
    /// </summary>
    WaitingApproval = 136001,

    /// <summary>
    /// TypeID = 136002.
    /// </summary>
    Valid = 136002,

    /// <summary>
    /// TypeID = 136003.
    /// </summary>
    Invalid = 136003,

    /// <summary>
    /// TypeID = 136004.
    /// </summary>
    BeingProcessed = 136004,

    /// <summary>
    /// TypeID = 136005.
    /// </summary>
    Canceled = 136005,

    /// <summary>
    /// TypeID = 136006.
    /// </summary>
    Invoiced = 136006
}

/**
 * Defines the Coupon Status for Staff Referrals (for Hire)
 */
export enum CouponStatusForStaffReferral {
    NotUsed = 327000,

    Used = 327001,

    Qualified = 327002,

    Reviewed = 327003,

    Cancelled = 327004,

    Processed = 327005
}

/**
 * Used to group regions by countries.
 */
export enum CountryRegionType {
    USStates = 148000,
    CanadianProvinces = 148001
}

/**
 * List of countries. TypeClassID = 8.
 */
export enum CountryType {
    Andorra = 8000,
    UnitedArabEmirates = 8001,
    Afghanistan = 8002,
    AntiguaandBarbuda = 8003,
    Anguilla = 8004,
    Albania = 8005,
    Armenia = 8006,
    NetherlandsAntilles = 8007,
    Angola = 8008,
    Antarctica = 8009,
    Argentina = 8010,
    AmericanSamoa = 8011,
    Austria = 8012,
    Australia = 8013,
    Aruba = 8014,
    ÅlandIslands = 8015,
    Azerbaijan = 8016,
    BosniaandHerzegovina = 8017,
    Barbados = 8018,
    Bangladesh = 8019,
    Belgium = 8020,
    BurkinaFaso = 8021,
    Bulgaria = 8022,
    Bahrain = 8023,
    Burundi = 8024,
    Benin = 8025,
    SaintBarthelemy = 8026,
    Bermuda = 8027,
    BruneiDarussalam = 8028,
    Bolivia = 8029,
    Brazil = 8030,
    Bahamas = 8031,
    Bhutan = 8032,
    BouvetIsland = 8033,
    Botswana = 8034,
    Belarus = 8035,
    Belize = 8036,
    /// <summary>
    /// TypeID = 8037
    /// </summary>
    Canada = 8037,
    CocosKeelingIslands = 8038,
    CongoKinshasa = 8039,
    CentralAfricanRepublic = 8040,
    CongoBrazzaville = 8041,
    Switzerland = 8042,
    CotedIvoire = 8043,
    CookIslands = 8044,
    Chile = 8045,
    Cameroon = 8046,
    China = 8047,
    Colombia = 8048,
    CostaRica = 8049,
    Cuba = 8050,
    CapeVerde = 8051,
    ChristmasIsland = 8052,
    Cyprus = 8053,
    CzechRepublic = 8054,
    Germany = 8055,
    Djibouti = 8056,
    Denmark = 8057,
    Dominica = 8058,
    DominicanRepublic = 8059,
    Algeria = 8060,
    Ecuador = 8061,
    Estonia = 8062,
    Egypt = 8063,
    WesternSahara = 8064,
    Eritrea = 8065,
    Spain = 8066,
    Ethiopia = 8067,
    Finland = 8068,
    Fiji = 8069,
    FalklandIslands = 8070,
    Micronesia = 8071,
    FaroeIslands = 8072,
    France = 8073,
    Gabon = 8074,
    UnitedKingdom = 8075,
    Grenada = 8076,
    Georgia = 8077,
    FrenchGuiana = 8078,
    Guernsey = 8079,
    Ghana = 8080,
    Gibraltar = 8081,
    Greenland = 8082,
    Gambia = 8083,
    Guinea = 8084,
    Guadeloupe = 8085,
    EquatorialGuinea = 8086,
    Greece = 8087,
    Guatemala = 8088,
    Guam = 8089,
    GuineaBissau = 8090,
    Guyana = 8091,
    HongKong = 8092,
    Honduras = 8093,
    Croatia = 8094,
    Haiti = 8095,
    Hungary = 8096,
    Indonesia = 8097,
    Ireland = 8098,
    Israel = 8099,
    IsleofMan = 8100,
    India = 8101,
    Iraq = 8102,
    Iran = 8103,
    Iceland = 8104,
    Italy = 8105,
    Jersey = 8106,
    Jamaica = 8107,
    Jordan = 8108,
    Japan = 8109,
    Kenya = 8110,
    Kyrgyzstan = 8111,
    Cambodia = 8112,
    Kiribati = 8113,
    Comoros = 8114,
    SaintKittsandNevis = 8115,
    KoreaNorth = 8116,
    KoreaSouth = 8117,
    Kuwait = 8118,
    CaymanIslands = 8119,
    Kazakhstan = 8120,
    Laos = 8121,
    Lebanon = 8122,
    SaintLucia = 8123,
    Liechtenstein = 8124,
    SriLanka = 8125,
    Liberia = 8126,
    Lesotho = 8127,
    Lithuania = 8128,
    Luxembourg = 8129,
    Latvia = 8130,
    Libya = 8131,
    Morocco = 8132,
    Monaco = 8133,
    Moldova = 8134,
    Montenegro = 8135,
    SaintMartin = 8136,
    Madagascar = 8137,
    MarshallIslands = 8138,
    Macedonia = 8139,
    Mali = 8140,
    Myanmar = 8141,
    Mongolia = 8142,
    Macao = 8143,
    NorthernMarianaIslands = 8144,
    Martinique = 8145,
    Mauritania = 8146,
    Montserrat = 8147,
    Malta = 8148,
    Mauritius = 8149,
    Maldives = 8150,
    Malawi = 8151,
    Mexico = 8152,
    Malaysia = 8153,
    Mozambique = 8154,
    Namibia = 8155,
    NewCaledonia = 8156,
    Niger = 8157,
    NorfolkIsland = 8158,
    Nigeria = 8159,
    Nicaragua = 8160,
    Netherlands = 8161,
    Norway = 8162,
    Nepal = 8163,
    Nauru = 8164,
    Niue = 8165,
    NewZealand = 8166,
    Oman = 8167,
    Panama = 8168,
    Peru = 8169,
    FrenchPolynesia = 8170,
    PapuaNewGuinea = 8171,
    Philippines = 8172,
    Pakistan = 8173,
    Poland = 8174,
    SaintPierreandMiquelon = 8175,
    Pitcairn = 8176,
    PuertoRico = 8177,
    PalestinianTerritory = 8178,
    Portugal = 8179,
    Palau = 8180,
    Paraguay = 8181,
    Qatar = 8182,
    Reunion = 8183,
    Romania = 8184,
    Serbia = 8185,
    RussianFederation = 8186,
    Rwanda = 8187,
    SaudiArabia = 8188,
    SolomonIslands = 8189,
    Seychelles = 8190,
    Sudan = 8191,
    Sweden = 8192,
    Singapore = 8193,
    SaintHelena = 8194,
    Slovenia = 8195,
    SvalbardandJanMayen = 8196,
    Slovakia = 8197,
    SierraLeone = 8198,
    SanMarino = 8199,
    Senegal = 8200,
    Somalia = 8201,
    Suriname = 8202,
    SaoTomeandPrincipe = 8203,
    ElSalvador = 8204,
    Syria = 8205,
    Swaziland = 8206,
    TurksandCaicosIslands = 8207,
    Chad = 8208,
    Togo = 8209,
    Thailand = 8210,
    Tajikistan = 8211,
    Tokelau = 8212,
    Timorleste = 8213,
    Turkmenistan = 8214,
    Tunisia = 8215,
    Tonga = 8216,
    Turkey = 8217,
    TrinidadandTobago = 8218,
    Tuvalu = 8219,
    Taiwan = 8220,
    Tanzania = 8221,
    Ukraine = 8222,
    Uganda = 8223,
    /// <summary>
    /// TypeID = 8224
    /// </summary>
    USA = 8224,
    Uruguay = 8225,
    Uzbekistan = 8226,
    VaticanCityHolySee = 8227,
    SaintVincent = 8228,
    Venezuela = 8229,
    VirginIslandsBritish = 8230,
    VirginIslandsUS = 8231,
    VietNam = 8232,
    Vanuatu = 8233,
    WallisandFutuna = 8234,
    Samoa = 8235,
    Yemen = 8236,
    Mayotte = 8237,
    SouthAfrica = 8238,
    Zambia = 8239,
    Zimbabwe = 8240
}

export enum CouponRoleType {
    /// <summary>
    /// TypeID = 122000.
    /// </summary>
    Creator = 122000,

    /// <summary>
    /// TypeID = 122001.
    /// </summary>
    Consumer = 122001
}

export enum CouponType {
    /// <summary>
    /// TypeID = 126000
    /// </summary>
    Standard = 126000,

    /// <summary>
    /// TypeID = 126001
    /// </summary>
    Voucher = 126001,

    /// <summary>
    /// TypeID = 126002
    /// </summary>
    ReferFriend = 126002,

    /// <summary>
    /// TypeID = 126003
    /// </summary>
    Scholarship = 126003,

    /// <summary>
    /// TypeID = 126004
    /// </summary>
    TuitionAssistance = 126004,

    /// <summary>
    /// TypeID = 126005
    /// </summary>
    MarketingCoupon = 126005,

    /// <summary>
    /// TypeID = 126006
    /// </summary>
    ThirdPartyPayer = 126006,

    /// <summary>
    /// TypeID = 126007
    /// </summary>
    LetterOfIntent = 126007,

    /// <summary>
    /// TypeID = 126008
    /// </summary>
    ThirdPartyPayerGroup = 126008,

    /// <summary>
    /// Coupon representing referral of a single person in the Term Staff Refer-a-Friend program
    /// </summary>
    TermStaffReferAFriend = 126009,

    /// <summary>
    /// TypeID = 126010
    /// </summary>
    PurchasedCredit = 126010
}

export enum CourseDeposit {
    /// <summary>
    /// FixedAmount
    /// </summary>
    FixedAmount = 33000,
    /// <summary>
    /// Percent
    /// </summary>
    Percent = 33001
}

export enum CourseSubCategoryType {
    /// <summary>
    /// None
    /// </summary>
    None = 45000
}

/**
 * Enumerates the user activities that result in creating certain data, such as How Heard About.
 */
export enum CreatedEventType {
    /// <summary>
    /// Request for Catalog, Brochure, etc.
    /// TypeID = 62000
    /// </summary>
    InformationRequest = 62000,
    /// <summary>
    /// Create Account - Public pages.
    /// TypeID = 62001
    /// </summary>
    CreateAccountPublic = 62001,
    /// <summary>
    /// Create Account - Staff.
    /// TypeID = 62002
    /// </summary>
    CreateAccountStaff = 62002,
    /// <summary>
    /// Identify requests made with iD OnSite Request form.
    /// TypeID = 62003.
    /// </summary>
    iDOnsiteRequest = 62003
}

export enum CreditCardType {
    Visa = 96000,
    Mastercard = 96001,
    AmericanExpress = 96002,
    Discover = 96003
}

export enum CurrencyType {
    USD = 25000
}

export enum DateType {
    /// <summary>
    /// Absolute
    /// </summary>
    Absolute = 40000,
    /// <summary>
    /// Relative
    /// </summary>
    Relative = 40001
}

export enum DiscountBannerUsageType {
    /// <summary>
    /// Homepage
    /// Type ID = 293000
    /// </summary>
    Homepage = 293000,
    /// <summary>
    /// Second Level Page
    /// Type ID = 293001
    /// </summary>
    SecondLevelPage = 293001,
    /// <summary>
    /// Email
    /// Type ID = 293002
    /// </summary>
    Email = 293002
}

export enum DiscountCategory {
    /// <summary>
    /// Standard
    /// Type ID = 183000
    /// </summary>
    Standard = 183000,
    /// <summary>
    /// Coupon
    /// Type ID = 183001
    /// </summary>
    Coupon = 183001,
    /// <summary>
    /// Voucher
    /// Type ID = 183002
    /// </summary>
    Voucher = 183002,
    /// <summary>
    /// Refer a Friend
    /// Type ID = 183003
    /// </summary>
    ReferAFriend = 183003,
    /// <summary>
    /// Promotion
    /// Type ID = 183004
    /// </summary>
    Promotion = 183004
}

export enum DiscountType {
    /// <summary>
    /// TypeID = 49000
    /// </summary>
    /// <remarks>No longer supported.</remarks>
    Special = 49000,

    /// <summary>
    /// TypeID = 49001
    /// </summary>
    /// <remarks>No longer supported.</remarks>
    Group = 49001,

    /// <summary>
    /// TypeID = 49002
    /// </summary>
    /// <remarks>No longer supported. Replaced with MultiSession_Sibling</remarks>
    MultiSession = 49002,

    /// <summary>
    /// TypeID = 49003
    /// </summary>
    /// <remarks>No longer supported. Replaced with CorporatePartnerStaff_LocationStaffFaculty</remarks>
    CorporatePartnerStaff = 49003,

    /// <summary>
    /// TypeID = 49004
    /// </summary>
    /// <remarks>No longer supported. Replaced with CorporatePartnerStaff_LocationStaffFaculty</remarks>
    LocationStaffFaculty = 49004,

    /// <summary>
    /// TypeID = 49006
    /// </summary>
    /// <remarks>No longer supported. Replaced with MultiSession_Sibling</remarks>
    Sibling = 49006,

    /// <summary>
    /// TypeID = 49007
    /// </summary>
    Promotion = 49007,

    /// <summary>
    /// TypeID = 49008
    /// </summary>
    ReferAFriend = 49008,

    /// <summary>
    /// TypeID = 49009
    /// </summary>
    Voucher = 49009,

    /// <summary>
    /// TypeID = 49010
    /// </summary>
    /// <remarks>No longer supported. Replaced with Scholarship_TuitionAssistance_MarketingCoupon</remarks>
    Scholarship = 49010,

    /// <summary>
    /// TypeID = 49011
    /// </summary>
    /// <remarks>No longer supported. Replaced with Scholarship_TuitionAssistance_MarketingCoupon</remarks>
    TuitionAssistance = 49011,

    /// <summary>
    /// TypeID = 49012
    /// </summary>
    ClientServicesDiscretionary = 49012,

    /// <summary>
    /// TypeID = 49013
    /// </summary>
    /// <remarks>No longer supported.</remarks>
    Courtesy = 49013,

    /// <summary>
    /// TypeID = 49014
    /// </summary>
    ThirdPartyPayer = 49014,

    /// <summary>
    /// TypeID = 49015
    /// </summary>
    ReferAFriendReward = 49015,

    /// <summary>
    /// TypeID = 49016
    /// </summary>
    VoucherServiceProblem = 49016,

    /// <summary>
    /// TypeID = 49017
    /// </summary>
    /// <remarks>No longer supported. Replaced with Scholarship_TuitionAssistance_MarketingCoupon</remarks>
    MarketingCoupon = 49017,

    /// <summary>
    /// TypeID = 49018
    /// </summary>
    WriteOff = 49018,

    /// <summary>
    /// TypeID = 49019
    /// </summary>
    /// <remarks>No longer supported.</remarks>
    KermitVoucherClientProblem = 49019,

    /// <summary>
    /// TypeID = 49020
    /// </summary>
    /// <remarks>No longer supported.</remarks>
    KermitVoucherServiceProblem = 49020,

    /// <summary>
    /// TypeID = 49021
    /// </summary>
    Multisession_Sibling = 49021,

    /// <summary>
    /// TypeID = 49022
    /// </summary>
    CorporatePartnerStaff_LocationStaffFaculty = 49022,

    /// <summary>
    /// TypeID = 49023
    /// </summary>
    Scholarship_TuitionAssistance_MarketingCoupon = 49023,

    /// <summary>
    /// TypeID = 49024
    /// </summary>
    PurchasedCredit = 49024
}

export enum DiscountApplicableToward {
    /// <summary>
    /// AmountLessDeposit
    /// </summary>
    AmountLessDeposit = 80000,
    /// <summary>
    /// FullAmount
    /// </summary>
    FullAmount = 80001
}

export enum DiscountBlanketRestriction {
    /// <summary>
    /// ExclusivePerOrder
    /// </summary>
    ExclusivePerOrder = 77000,
    /// <summary>
    /// ExclusivePerTerm
    /// </summary>
    ExclusivePerTerm = 77001
}

export enum DiscountDateRelativeToItemType {
    FirstDayOfTerm = 58000,
    LastDayOfTerm = 58001,
    FirstDayOfLastSession = 58002
}

export enum DiscountDiscountTypeRestriction {
    /// <summary>
    /// NotInSameTerm
    /// </summary>
    NotInSameTerm = 78000
}

export enum DiscountDivisionRelationshipType {
    /// <summary>
    /// Primary Owner
    /// </summary>
    Primary = 63000,
    /// <summary>
    /// Secondary Non-owner
    /// </summary>
    Secondary = 63001
}

export enum DiscountLimitType {
    /// <summary>
    /// PerTermGroup
    /// </summary>
    PerTermGroup = 64000,
    /// <summary>
    /// Per Location
    /// </summary>
    PerLocation = 64001,
    /// <summary>
    /// PerCustomer
    /// </summary>
    PerCustomer = 64002,
    /// <summary>
    /// PerParticipant
    /// </summary>
    PerParticipant = 64003,
    /// <summary>
    /// PerOrder
    /// </summary>
    PerOrder = 64004
}

export enum DiscountPaymentReqType {
    /// <summary>
    /// No Requirement
    /// </summary>
    NoRequirement = 66000,
    /// <summary>
    /// Pay In Full By Payment Due Date
    /// </summary>
    PayInFullByPaymentDueDate = 66001,
    /// <summary>
    /// Pay In Full Immediately
    /// </summary>
    PayInFullImmediately = 66002
}

export enum DiscountProductInclusionType {
    /// <summary>
    /// Include
    /// </summary>
    Include = 76000,
    /// <summary>
    /// Exclude
    /// </summary>
    Exclude = 76001
}

export enum DiscountScheduleType {
    /// <summary>
    /// OfferDate
    /// </summary>
    OfferDate = 68000,
    /// <summary>
    /// Payment before date.
    /// </summary>
    PaymentReqDate = 68001
}

export enum DiscountSubcategoryType {
    /// <summary>
    /// TypeID = 230000
    /// </summary>
    CorporatePartnerStaff = 230000,
    /// <summary>
    /// TypeID = 230001
    /// </summary>
    LocationStaffFaculty = 230001,
    /// <summary>
    /// TypeID = 230002
    /// </summary>
    Scholarship = 230002,
    /// <summary>
    /// TypeID = 230003
    /// </summary>
    TuitionAssistance = 230003,
    /// <summary>
    /// TypeID = 230004
    /// </summary>
    MarketingCoupon = 230004,
    /// <summary>
    /// TypeID = 230005
    /// </summary>
    LetterOfIntent = 230005,
    /// <summary>
    /// TypeID = 230006
    /// </summary>
    ThirdPartyPayerGroup = 230006,

    /// <summary>
    /// Coupon amount add-on - Vouchers (TypeID = 230007)
    /// </summary>
    CouponamountAddonVouchers = 230007,

    /// <summary>
    /// Coupon amount add-on - Scholarships (TypeID = 230008)
    /// </summary>
    CouponamountAddonScholarships = 230008,

    /// <summary>
    /// Coupon amount add-on - iD Scholarship Program (TypeID = 230009)
    /// </summary>
    CouponamountAddoniDScholarshipProgram = 230009,

    /// <summary>
    /// Coupon amount add-on - Marketing Coupons (TypeID = 230010)
    /// </summary>
    CouponamountAddonMarketingCoupons = 230010,

    /// <summary>
    /// Coupon amount add-on - Third Party Payers (TypeID = 230011)
    /// </summary>
    CouponamountAddonThirdPartyPayers = 230011,

    /// <summary>
    /// Positively Outrageous Service (POS) (TypeID = 230012)
    /// </summary>
    PositivelyOutrageousServicePOS = 230012,

    /// <summary>
    /// Client Issues credit (formerly refunds) (TypeID = 230013)
    /// </summary>
    ClientIssuedCreditOrRefund = 230013,

    /// <summary>
    /// Sales credits - Promotions (TypeID = 230014)
    /// </summary>
    SalesCreditsPromotions = 230014,

    /// <summary>
    /// Sales credits - Corporate Partner Staff (TypeID = 230015)
    /// </summary>
    SalesCreditsCorporatePartnerStaff = 230015,

    /// <summary>
    /// Sales credits - Location Faculty & Staff (TypeID = 230016)
    /// </summary>
    SalesCreditsLocationFacultyAndStaff = 230016,

    /// <summary>
    /// EarlyAccess (TypeID = 230017)
    /// </summary>
    EarlyAccess = 230017
}

export enum DiscountValueType {
    /// <summary>
    /// TypeID = 57000.
    /// </summary>
    FixedAmount = 57000,
    /// <summary>
    /// TypeID = 57001.
    /// </summary>
    Percent = 57001
}

export enum DiscretionaryPayReason {
    /// <summary>
    /// Type ID = 249000
    /// </summary>
    ExceptionalExperience = 249000,

    /// <summary>
    /// Type ID = 249001
    /// </summary>
    AdjustmentToMeetPreviousPayRate = 249001,

    /// <summary>
    /// Type ID = 249002
    /// </summary>
    Other = 249002
}

/**
 * Bit masking flags used for specifying Division behavior.
 * <remarks>This enum does not use the TypeIDs in the Type table.  Values are set to bit masks.</remarks>
 */
export enum DivisionBehaviorMask {
    None = 0x0,

    /// <summary>
    /// Flag = 0x1. Bit pos 0.
    /// a.	Position 0 (Choose Location Display):
    ///     i.	If 0, the Choose Location page in the course recommender flow should display only those locations that have courses scheduled in the Division in context.
    ///     ii.	If 1, the Choose Location page should display Locations from all divisions that have courses scheduled.
    /// </summary>
    IncludeLocationsFromOtherDivisions = 0x1,

    /// <summary>
    /// Flag = 0x2. Bit pos 1. Employee of Partner corporation
    /// b.	Position 1 (Camp Age Group):
    ///     i.	If 0, the division does not use age groups to manage items such as name tags, door decs, etc.
    ///     ii.	If 1, the division does use age groups to determine what elements should be displayed on name tags, door decs, etc.
    /// </summary>
    AgeGroupSensitive = 0x2,

    All = 0xffff
}

export enum DivisionProgramType {
    iDTechCamps = 307000,
    iDTechAcademies = 307001,

    /// <summary>
    /// iD Tech Mini. TypeID = 307002
    /// </summary>
    iDTechMini = 307002,

    /// <summary>
    /// TypeID = 307003
    /// </summary>
    AlexaCafe = 307003
}

/**
 * Identifies the types of text or HTML blocks that can be defined and stored for each Division
 */
export enum DivisionTextType {
    WelcomePacketEmail = 292000,

    /// <summary>
    /// Day Program Description used in the Avail Chart.
    /// TypeID = 292001
    /// </summary>
    DayProgramDescription = 292001,

    /// <summary>
    /// Overnight Program Description used on the Avail Chart.
    /// TypeID = 292002
    /// </summary>
    OvernightProgramDescription = 292002,

    /// <summary>
    /// Displayed in the Availability chart price details overlay.
    /// TypeID = 292003
    /// </summary>
    IncludedInTuition = 292003,

    /// <summary>
    /// Displayed on the Welcome Packet landing Tab
    /// </summary>
    WelcomePacketWelcomeAndRecapTab = 292004,

    /// <summary>
    /// Displayed on the Welcome Packet Maps & Directions Tab
    /// </summary>
    WelcomePacketMapsAndDirectionsTab = 292005,

    /// <summary>
    /// Displayed on the Welcome Packet Packing List Tab
    /// </summary>
    WelcomePacketPackingListTab = 292006,

    /// <summary>
    /// Displayed on the Welcome Packet Medications Tab
    /// </summary>
    WelcomePacketMedicationsTab = 292007,

    /// <summary>
    /// Displayed on the Welcome Packet Code of Conduct Tab
    /// </summary>
    WelcomePacketCodeOfConductTab = 292008,

    /// <summary>
    /// Displayed on the Welcome Packet FAQs Tab
    /// </summary>
    WelcomePacketFAQsTab = 292009,

    /// <summary>
    /// Displayed on the Welcome Packet Family Showcase Tab
    /// </summary>
    WelcomePacketFamilyShowcaseTab = 292010,

    /// <summary>
    /// Tech Rocket - Email content for Account Creation Confirmation
    /// </summary>
    TechRocketAccountCreationEmail = 292011,

    /// <summary>
    /// Tech Rocket - Email content for Purchase Confirmation
    /// </summary>
    TechRocketPurchaseConfirmationEmail = 292012,

    /// <summary>
    /// Generated after an upsale purchase has been completed
    /// </summary>
    TechRocketPurchaseConfirmationEmail_UpsaleReg = 292013,

    /// <summary>
    /// Generated after the referal is marked valid
    /// </summary>
    ReferAFriendRewardEmail = 292014,

    /// <summary>
    /// Displayed in VIP Early Access Pass landing page in My Account.
    /// </summary>
    VIPEarlyAccessPass = 292015
}

/**
 * Indicates a division's main line of business
 */
export enum DivisionDeliveryModelType {
    YouthEducationalServices = 4000,
    TermStaffTraining = 4001,
    EducationProgramComponents = 4002
}

/**
 * The number of people that can sleep in a room.
 */
export enum DormRoomCapacity {
    Single = 276000,
    Double = 276001,
    Triple = 276002,
    Suite = 276003
}

export enum EmployeeStatusType {
    Applicant = 47000,
    CurrentEmployee = 47001,
    Terminated = 47002
}

export enum EquipmentCategoryType {
    iMac = 212000,
    StandardPC = 212001,
    Monitor = 212004,
    Printer = 212005,
    MacMini = 212006,
    MacBookPro = 212007,
    GamingPC = 212008,
    AndroidTablet = 212009
}

export enum EquipmentReportType {
    SummaryOfIssuesReportedThisWeek = 211000,
    NewEquipmentReceived = 211001,
    ReturnedEquipment = 211002,
    NoIssuesReportedThisWeek = 211003
}

export enum ExtraActionItemType {
    SectionCapacityZero = 100000
}

/**
 * A subset of Location-Specific Information
 */
export enum FacilityType {
    ResidenceHall = 12000,
    DiningHall = 12001,
    LabBuilding = 12002,
    LabRoom = 12003
}

/**
 * Used in Product.FeeAmountTypeID column.
 */
export enum FeeAmountType {
    Predefined = 91000,
    DefinedWhenApplied = 91001
}

/**
 * Used in Product.FeeApplyTypeID column.
 */
export enum FeeApplyType {
    Automatic = 92000,
    Manual = 92001
}

/**
 * Identify the type of the directory. Example: folder in the local file system, Virtual path...
 * Used in the FileDirectory table.
 */
export enum FileDirectoryType {
    /// <summary>
    /// Indicates that record contains path to the directory in the local file system.
    /// TypeID = 112000.
    /// </summary>
    LocalDirectory = 112000,
    /// <summary>
    /// Indicates that record contains the path to the virtual directory (relative to the host root).
    /// TypeID = 112001
    /// </summary>
    VirtualDirectory = 112001
}

export enum FileDirectoryUsage {
    /// <summary>
    /// TypeID = 254000
    /// </summary>
    HRLogFiles = 254000,

    /// <summary>
    /// TypeID = 254001
    /// </summary>
    TermStaffFiles = 254001,

    /// <summary>
    /// TypeID = 254002
    /// </summary>
    EmailTemplates = 254002,

    /// <summary>
    /// TypeID = 254003
    /// </summary>
    TermStaffWelcomeMsgs = 254003,

    /// <summary>
    /// TypeID = 254004
    /// </summary>
    EmployeeHandbookFiles = 254004,

    /// <summary>
    /// TypeID = 254005
    /// </summary>
    RequiredEmploymentPaperwork = 254005,

    /// <summary>
    /// TypeID = 254006
    /// </summary>
    AttendanceSignatureImages = 254006,

    /// <summary>
    /// Certain certifications and other forms, such as Weekend Housing.
    /// TypeID = 254007
    /// </summary>
    JobApplicantPaperworkUploads = 254007,

    /// <summary>
    /// Tuition Assistance Program documents, such as tax returns.
    /// TypeID = 254008
    /// </summary>
    TAPDocuments = 254008,

    /// <summary>
    /// TypeID = 254009
    /// </summary>
    OrderConfirmationFiles = 254009,

    /// <summary>
    /// TypeID = 254010  Job Applicant Compliance Uploads
    /// </summary>
    JobApplicantComplianceUploads = 254010,

    /// <summary>
    /// TypeID = 254011  Employee Handbook PDF
    /// </summary>
    EmployeeHandbookPdf = 254011,

    /// <summary>
    /// TypeID = 254012  Required Employment Paperwork PDF
    /// </summary>
    RequiredEmploymentPaperworkPdf = 254012,

    /// <summary>
    /// TypeID = 254013  Job Applicant Application PDF
    /// </summary>
    JobApplicationApplicantPdf = 254013,

    /// <summary>
    /// TypeID = 254014 Client Additional Required Forms
    /// </summary>
    ClientARF = 254014
}

/**
 * Identify the format of the file. Example: html, jpg picture, plain text.
 * Used in Files table.
 */
export enum FileFormat {
    /// <summary>
    /// Indicates that file contains html text.
    /// TypeID = 111000.
    /// </summary>
    HTML = 111000,

    /// <summary>
    /// PDF file.
    /// TypeID = 111001
    /// </summary>
    PDF = 111001,

    /// <summary>
    /// Png image file
    /// TypeID = 111002
    /// </summary>
    PNG = 111002,

    /// <summary>
    /// JPG image file
    /// TypeID = 111003
    /// </summary>
    JPG = 111003,

    /// <summary>
    /// Zip Archive
    /// TypeID = 111004
    /// </summary>
    ZIP = 111004,

    /// <summary>
    /// TypeID = 111005
    /// </summary>
    DOC = 111005,

    /// <summary>
    /// TypeID = 111006
    /// </summary>
    DOCX = 111006
}

/**
 * Identify the type of the file. This can be used to indicate whether the file is a local file or a Web page.
 * Used in the Files table
 */
export enum FileType {
    /// <summary>
    /// Identify file in the local file system.
    /// TypeID = 109000.
    /// </summary>
    LocalFile = 109000,
    /// <summary>
    /// Identify a Web page.
    /// TypeID = 109001
    /// </summary>
    Web = 109001
}

/**
 * Summarizes the results of a file upload.
 * Used in the multi-file upload facility.
 */
export enum FileUploadReturnCode {
    Success,
    Failure
}

/**
 * Identify the type of the file's content. Example: image, Terms and Conditions text...
 * Used in the Files table.
 */
export enum FileUsageType {
    /// <summary>
    /// Part of the Terms and Conditions about carpooling.
    /// TypeID = 110000.
    /// </summary>
    CarpoolTermsAndConditions = 110000,

    /// <summary>
    /// Terms and Conditions.
    /// TypeID = 110001.
    /// </summary>
    TermsAndConditions = 110001,

    /// <summary>
    /// Part of the Terms and Conditions about Refer-a-Friend program.
    /// TypeID = 110002.
    /// </summary>
    ReferAFriendTermsAndConditions = 110002,

    /// <summary>
    /// TypeID = 110006
    /// </summary>
    InterviewNotes = 110006,

    /// <summary>
    /// TypeID = 110007
    /// </summary>
    HRLogRelatedFile = 110007,

    /// <summary>
    /// TypeID = 110021
    /// </summary>
    TermStaffWorkSchedule = 110021,

    /// <summary>
    /// Certain certifications and other forms, such as Weekend Housing.
    /// TypeID = 110024
    /// </summary>
    JobApplicantPaperwork = 110024,

    /// <summary>
    /// Tax Return Documents for the Tuition Assistance Program.
    /// TypeID = 110025
    /// </summary>
    TaxReturnDocuments = 110025,

    /// <summary>
    /// TypeID = 110026
    /// </summary>
    Resume = 110026
}

export enum FollowUpStatusType {
    /// <summary>
    /// TypeID = 69000
    /// </summary>
    NeedsFollowUp = 69000,

    /// <summary>
    /// TypeID = 69001
    /// </summary>
    WaitingForReply = 69001,

    /// <summary>
    /// TypeID = 690002
    /// </summary>
    NoneNeeded = 69002
}

/**
 * Used as Parent types in type structure to group FormCategoryTypes.
 */
export enum FormCategoryGroup {
    /// <summary>
    /// TypeID = 253000.
    /// </summary>
    ClientForms = 253000,

    /// <summary>
    /// TypeID = 253001.
    /// </summary>
    JobApplicationForms = 253001,

    /// <summary>
    /// TypeID = 253002.
    /// </summary>
    TermStaffPaperworkForms = 253002
}

/**
 * Indicates whether the form is a "health" form, an "other" form, or a "bring" form.
 * Used in the From table.
 */
export enum FormCategoryType {
    /// <summary>
    /// TypeID = 140000.
    /// </summary>
    Health = 140000,

    /// <summary>
    /// TypeID = 140001.
    /// </summary>
    ClientOther = 140001,

    /// <summary>
    /// TypeID = 140002.
    /// </summary>
    Bring = 140002,

    /// <summary>
    /// Required form.
    /// TypeID 140003.
    /// </summary>
    EmergencyContact = 140003,

    /// <summary>
    /// Required form.
    /// TypeID 140004.
    /// </summary>
    HealthHistory = 140004,

    /// <summary>
    /// Required form.
    /// TypeID 140005.
    /// </summary>
    StudentAssessment = 140005,

    /// <summary>
    /// Term staff job application form.
    /// TypeID = 140006.
    /// </summary>
    TermStaffApplicationForm = 140006,

    /// <summary>
    /// Term staff medical info, etc.
    /// TypeID = 140007.
    /// NOTE: This has been deprecated.
    /// </summary>
    //TermStaffOEP = 140007

    /// <summary>
    /// Term staff Employee Handbook
    /// TypeID = 140008.
    /// </summary>
    EmployeeHandbook = 140008,

    /// <summary>
    /// Term staff Required Employment Paperwork (REP)
    /// TypeID = 140009.
    /// </summary>
    RequiredEmploymentPaperwork = 140009,

    /// <summary>
    ///  CPR, First Aid, etc.
    ///  TypeID = 140010.
    /// </summary>
    Certificate = 140010,

    /// <summary>
    /// No Category.
    /// TypeID = 140011.
    /// </summary>
    None = 140011,

    /// <summary>
    /// Weekend Housing Agreement.
    /// TypeID = 140012.
    /// </summary>
    WeekendHousingAgreement = 140012,

    /// <summary>
    /// W-4.
    /// TypeID = 140013.
    /// </summary>
    W4 = 140013
}

/**
 * used for filtering UserFormLocation
 */
export enum FormLocationUsageType {
    ApplicantPreference = 248000,
    HomeLocation = 248001,
    HiringManagerPreference = 248002,
    AssignedLocation = 248003
}

/**
 * Indicator of the type of change made to a Form Person Detail record.
 * Needed to report on changes to the reference rating, etc.
 */
export enum FormPersonChange {
    /// <summary>
    /// Reference Rating has changed.
    /// TypeID = 274000
    /// </summary>
    ReferenceRatingUpdate = 274000
}

export enum FormPersonRole {
    PrimaryContact = 201000,

    SecondaryContact = 201001,

    PickUp = 201002,

    EmploymentReference = 201003
}

export enum FormProcessHistoryType {
    /// <summary>
    /// TypeID = 233000
    /// </summary>
    StatusChange = 233000,

    /// <summary>
    /// TypeID = 233001
    /// </summary>
    OwnershipChange = 233001,

    /// <summary>
    /// TypeID = 233002
    /// </summary>
    LogEntryOnly = 233002
}

/**
 * Specifies the processing status of the form (particularly for Job Application workflow). Used in the UserFormDetail table.
 */
export enum FormApplicationProcessingStatus {
    /// <summary>
    /// TypeID = 225000.
    /// </summary>
    New = 225000,

    /// <summary>
    /// TypeID = 225001.
    /// </summary>
    Claimed = 225001,

    /// <summary>
    /// TypeID = 225002.
    /// </summary>
    ContactedForInterview = 225002,

    /// <summary>
    /// TypeID = 225003.
    /// </summary>
    NeedAdditionalInterview = 225003,

    /// <summary>
    /// TypeID = 225004.
    /// </summary>
    InterviewsCompleted = 225004,

    /// <summary>
    /// TypeID = 225005.
    /// </summary>
    VerbalOfferMade = 225005,

    /// <summary>
    /// TypeID = 225006.
    /// </summary>
    VerbalOfferDeclined = 225006,

    /// <summary>
    /// TypeID = 225007.
    /// </summary>
    VerbalOfferAccepted = 225007,

    /// <summary>
    /// TypeID = 225008.
    /// </summary>
    WrittenOfferPreparation = 225008,

    /// <summary>
    /// TypeID = 225009.
    /// </summary>
    WrittenOfferNeedApproval = 225009,

    /// <summary>
    /// TypeID = 225010.
    /// </summary>
    WrittenOfferApproved = 225010,

    /// <summary>
    /// TypeID = 225011.
    /// </summary>
    WrittenOfferPublished = 225011,

    /// <summary>
    /// TypeID = 225012.
    /// </summary>
    WrittenOfferDeclined = 225012,

    /// <summary>
    /// TypeID = 225013.
    /// </summary>
    PendingEmploymentPaperwork = 225013,

    /// <summary>
    /// TypeID = 225014.
    /// </summary>
    EmploymentPaperworkCompleted = 225014,

    /// <summary>
    /// TypeID = 225015.
    /// </summary>
    ClearedForScheduling = 225015,

    /// <summary>
    /// TypeID = 225016.
    /// </summary>
    Scheduled = 225016,

    /// <summary>
    /// TypeID = 225017.
    /// </summary>
    Rejected = 225017,

    /// <summary>
    /// TypeID = 225018.
    /// </summary>
    Withdrawn = 225018,

    /// <summary>
    /// TypeID = 225019
    /// </summary>
    InterviewCancelled = 225019,

    /// <summary>
    /// TypeID = 225020.
    /// </summary>
    WrittenOfferAccepted = 225020,

    /// <summary>
    /// TypeID = 225021
    /// </summary>
    Terminated = 225021,

    /// <summary>
    /// TypeID = 225022
    /// </summary>
    WrittenOfferApprovalDenied = 225022,

    /// <summary>
    /// TypeID = 225023
    /// </summary>
    None = 225023,

    /// <summary>
    /// TypeID = 225024
    /// </summary>
    Run = 225024,

    /// <summary>
    /// TypeID = 225025
    /// </summary>
    Cleared = 225025,

    /// <summary>
    /// TypeID = 225026
    /// </summary>
    DidNotClear = 225026,

    /// <summary>
    /// TypeID = 225027
    /// </summary>
    UnclaimedAuto = 225027,

    /// <summary>
    /// TypeID = 225028
    /// </summary>
    UnclaimedByUser = 225028
}

/**
 * Indicates whether the form is required or additional.
 * Used in the From table.
 */
export enum FormRequiredType {
    /// <summary>
    /// TypeID = 139000.
    /// </summary>
    Required = 139000,

    /// <summary>
    /// TypeID = 139001.
    /// </summary>
    Additional = 139001,

    /// <summary>
    /// TypeID = 139002.
    /// Deprecated.
    /// </summary>
    //TermStaffApplication = 139002

    /// <summary>
    /// Displayed in the “Required Paperwork” grid on the applicant paperwork pages.
    /// TypeID = 139003.
    /// </summary>
    EmployeeRequired = 139003,

    /// <summary>
    /// Displayed in the “Additional Required Paperwork” grid on the applicant paperwork pages.
    /// TypeID = 139004.
    /// </summary>
    EmployeeAdditional = 139004,

    /// <summary>
    /// Displayed in the “Location Specific Required Paperwork” grid on the applicant paperwork pages.
    /// TypeID = 139005.
    /// </summary>
    EmployeeLocationSpecific = 139005,

    /// <summary>
    /// used to not display in my account ui
    /// TypeID = 139006
    /// </summary>
    EmployeeInternalTrackingOnly = 139006
}

/**
 * Designates the type of information in the form section.
 */
export enum FormSectionType {
    /// <summary>
    /// TypeID = 178000
    /// </summary>
    PhysicalExam = 178000,

    /// <summary>
    /// TypeID = 178001
    /// </summary>
    Immunization = 178001,

    /// <summary>
    /// TypeID = 178002
    /// </summary>
    Medication = 178002,

    /// <summary>
    /// TypeID = 178003
    /// </summary>
    EmployeeHandbook = 178003,

    /// <summary>
    /// TypeID = 178004
    /// </summary>
    EmployeeConfidentialityAgreement = 178004,

    /// <summary>
    /// TypeID = 178005
    /// </summary>
    ArbitrationAgreement = 178005,

    /// <summary>
    /// TypeID = 178006
    /// </summary>
    EmergencyContacts = 178006,

    /// <summary>
    /// TypeID = 178007
    /// </summary>
    HealthInformation = 178007,

    /// <summary>
    /// TypeID = 178008
    /// </summary>
    BackgroundCheckAuthorization = 178008,

    /// <summary>
    /// TypeID = 178009
    /// </summary>
    References = 178009,

    /// <summary>
    /// TypeID = 178010
    /// </summary>
    DirectDepositInformation = 178010,

    /// <summary>
    /// TypeID = 178011
    /// </summary>
    PayDisbursement = 178011,

    /// <summary>
    /// TypeID = 178012
    /// </summary>
    iPayAuthorization = 178012,

    /// <summary>
    /// TypeID = 178013
    /// </summary>
    iDDebitCardAgreement = 178013,

    /// <summary>
    /// TypeID = 178014
    /// </summary>
    StaffBioApparel = 178014,

    /// <summary>
    /// TypeID = 178015
    /// </summary>
    VoluntaryDisclosure = 178015
}

/**
 * Specifies the submission status of the form (or form section). Used in the UserFormDetail table.
 */
export enum FormStatus {
    NotReceived = 143000,

    Received = 143001,

    Complete = 143002,

    Incomplete = 143003,

    NotApplicable = 143004,

    BringToSession = 143005,

    UpdateRecommended = 143006,

    MedsOnlyIncomplete = 143007
}

export enum FulfillmentStatusType {
    /// <summary>
    /// FulfillmentStatusTypeID = 73000.
    /// </summary>
    Pending = 73000,
    /// <summary>
    /// FulfillmentStatusTypeID = 73001
    /// </summary>
    ReferredtoCS = 73001,
    /// <summary>
    /// FulfillmentStatusTypeID = 73002
    /// </summary>
    Fulfilled = 73002,
    /// <summary>
    /// FulfillmentStatusTypeID = 73003
    /// </summary>
    Dismissed = 73003
}

/**
 *  Used in Users.GenderTypeID column.
 */
export enum GenderType {
    /// <summary>
    /// TypeID = 99000.
    /// </summary>
    Male = 99000,
    /// <summary>
    /// TypeID = 99001
    /// </summary>
    Female = 99001
}

/**
 * Used in Users.GenderTypeID column.
 */
export enum GeographicRegion {
    /// <summary>
    /// TypeID = 267000.
    /// </summary>
    East = 267000,
    /// <summary>
    /// TypeID = 267001
    /// </summary>
    Central = 267001,
    /// <summary>
    /// TypeID = 267002
    /// </summary>
    West = 267002
}

export enum HousingReason {
    /// <summary>
    /// TypeID = 270000
    /// </summary>
    Orientation = 270000,

    /// <summary>
    /// TypeID = 270001
    /// </summary>
    SetUp = 270001,

    /// <summary>
    /// TypeID = 270002
    /// </summary>
    ERTransfer = 270002,

    /// <summary>
    /// TypeID = 270003
    /// </summary>
    EETransfer = 270003,

    /// <summary>
    /// TypeID = 270004
    /// </summary>
    PayrollUseOnly = 270004
}

/**
 * List of "How heard about" types.
 */
export enum HowHeardAboutType {
    /// <summary>
    /// Article in Newspaper/Publication.
    /// TypeID = 59000
    /// </summary>
    ArticleInPublication = 59000,
    /// <summary>
    /// Ad in Parent/Family Magazine.
    /// TypeID = 59001
    /// </summary>
    AdInMagazine = 59001,
    /// <summary>
    /// Brochure from a Store.
    /// TypeID = 59002
    /// </summary>
    BrochureFromStore = 59002,
    /// <summary>
    /// DVD from iD.
    /// TypeID = 59003
    /// </summary>
    DVDfromiD = 59003,
    /// <summary>
    /// Campus Career Center Job Board.
    /// TypeID = 59004
    /// </summary>
    CampusCareerCenter = 59004,
    /// <summary>
    /// Flyer on School Campus.
    /// TypeID = 59005
    /// </summary>
    FlyerOnSchoolCampus = 59005,
    /// <summary>
    /// Banner Ad on Web Site.
    /// TypeID = 59006
    /// </summary>
    BannerAdOnWebSite = 59006,
    /// <summary>
    /// Camp Directories on the Web.
    /// TypeID = 59007
    /// </summary>
    CampDirectoriesOnWeb = 59007,
    /// <summary>
    /// CraigsList.org.
    /// TypeID = 59008
    /// </summary>
    CraigsList = 59008,
    /// <summary>
    /// ULoop.
    /// TypeID = 59009
    /// </summary>
    ULoop = 59009,
    /// <summary>
    /// Web Search – Google.
    /// TypeID = 59010
    /// </summary>
    WebSearchGoogle = 59010,
    /// <summary>
    /// Web Search – Yahoo.
    /// TypeID = 59011
    /// </summary>
    WebSearchYahoo = 59011,
    /// <summary>
    /// Referral from a Friend.
    /// TypeID = 59012
    /// </summary>
    ReferralFromFriend = 59012,
    /// <summary>
    /// Returning Participant.
    /// TypeID = 59013
    /// </summary>
    ReturningParticipant = 59013,
    /// <summary>
    /// I am Former Participant.
    /// TypeID = 59014
    /// </summary>
    FormerParticipant = 59014,
    /// <summary>
    /// Email from internalDrive.
    /// TypeID = 59015
    /// </summary>
    EmailFrominternalDrive = 59015,
    /// <summary>
    /// School Newsletter.
    /// TypeID = 59016
    /// </summary>
    SchoolNewsletter = 59016,
    /// <summary>
    /// Movie Theatre Ad.
    /// TypeID = 59017
    /// </summary>
    MovieTheatreAd = 59017,
    /// <summary>
    /// Camp Fair.
    /// TypeID = 59018
    /// </summary>
    CampFair = 59018,
    /// <summary>
    /// Trade Show.
    /// TypeID = 59019
    /// </summary>
    TradeShow = 59019,
    /// <summary>
    /// Job Fair.
    /// TypeID = 59020
    /// </summary>
    JobFair = 59020,
    /// <summary>
    /// Campus Event.
    /// TypeID = 59021
    /// </summary>
    CampusEvent = 59021,
    /// <summary>
    /// Radio.
    /// TypeID = 59022
    /// </summary>
    Radio = 59022,
    /// <summary>
    /// TV/News.
    /// TypeID = 59023
    /// </summary>
    TVNews = 59023,

    /// <summary>
    /// Camp Advisors.
    /// TypeID = 59025
    /// </summary>
    CampAdvisors = 59025,

    BrochurefromSchool = 59026,

    Other = 59027,

    ReferralFromFriendFamily = 59028,

    CampusProfessorStaff = 59029,

    NACElink = 59030,

    CampusWebsiteOrCampusJobBoardDuplicate = 59031,

    SummerJobsSearchSite = 59032,

    /// <summary>
    /// Used when the referral is being managed through the Referral Code table.  When this value is used, the ReferralCodeID field in the HHA table must not be null.
    /// TypeID = 59033
    /// </summary>
    TrackingCodeReferral = 59033
}

/**
 * Classifies "How Heard About" types.
 */
export enum HowHeardAboutCategoryType {
    /// <summary>
    /// Print Media.
    /// TypeID = 60000
    /// </summary>
    PrintMedia = 60000,
    /// <summary>
    /// Direct mail.
    /// TypeID = 60001
    /// </summary>
    DirectMail = 60001,
    /// <summary>
    /// Online.
    /// TypeID = 60002
    /// </summary>
    Online = 60002,
    /// <summary>
    /// Web Search.
    /// TypeID = 60003
    /// </summary>
    WebSearch = 60003,
    /// <summary>
    /// Referral.
    /// TypeID = 60004
    /// </summary>
    Referral = 60004,
    /// <summary>
    /// Newsletter.
    /// TypeID = 60005
    /// </summary>
    Newsletter = 60005,
    /// <summary>
    /// Event.
    /// TypeID = 60006
    /// </summary>
    Event = 60006,
    /// <summary>
    /// Public Media.
    /// TypeID = 60007
    /// </summary>
    PublicMedia = 60007
}

/**
 * Classifies "How Heard About Audience" types.
 */
export enum HowHeardAboutAudienceType {
    /// <summary>
    /// Client. TypeID = 61000
    /// </summary>
    Client = 61000,
    /// <summary>
    /// Staff. TypeID = 61001
    /// </summary>
    Staff = 61001
}

export enum HRLogActionType {
    /// <summary>
    /// TypeID = 238000
    /// </summary>
    ScheduledInterview = 238000,

    /// <summary>
    /// TypeID = 238001
    /// </summary>
    ActualInterview = 238001,

    /// <summary>
    /// TypeID = 238002
    /// </summary>
    RejectApplicant = 238002,

    /// <summary>
    /// TypeID = 238003
    /// </summary>
    RescindOffer = 238003,

    /// <summary>
    /// TypeID = 238004
    /// </summary>
    OfferDeclined = 238004,

    /// <summary>
    /// TypeID = 238005
    /// </summary>
    TerminateEmployee = 238005,

    /// <summary>
    /// TypeID = 238006
    /// </summary>
    Resignation = 238006,

    /// <summary>
    /// TypeID = 238007
    /// </summary>
    SubmitApplication = 238007,

    /// <summary>
    /// TypeID = 238008
    /// </summary>
    ResubmitApplication = 238008,

    /// <summary>
    /// TypeID = 238009
    /// </summary>
    WithdrawApplication = 238009,

    /// <summary>
    /// TypeID = 238010
    /// </summary>
    OfferAccepted = 238010,

    /// <summary>
    /// TypeID = 238011
    /// </summary>
    GeneralNote = 238011,

    /// <summary>
    /// Offer modified for a promotion.
    /// TypeID 238012.
    /// </summary>
    Promotion = 238012,

    /// <summary>
    /// Offer changed to a lesser position..
    /// TypeID = 238013
    /// </summary>
    Demotion = 238013,

    /// <summary>
    /// TypeID = 238014
    /// </summary>
    Change = 238014,

    /// <summary>
    /// TypeID = 238016
    /// </summary>
    RequestApproval = 238016,

    /// <summary>
    /// TypeID = 238017
    /// </summary>
    ApprovalDenied = 238017,

    /// <summary>
    /// TypeID = 238018
    /// </summary>
    Published = 238018,

    /// <summary>
    /// TypeID = 238019
    /// </summary>
    Claim = 238019,

    /// <summary>
    /// TypeID = 238020
    /// </summary>
    Unclaim = 238020,

    /// <summary>
    /// TypeID = 238021
    /// </summary>
    TransferOwnership = 238021,

    /// <summary>
    /// Comments regarding background checks for prospective staff.
    /// TypeID = 238025
    /// </summary>
    BackgroundCheck = 238025,

    /// <summary>
    /// Comments regarding the required paperwork submission by prospective staff.
    /// TypeID = 238026.
    /// </summary>
    RequiredPaperwork = 238026,

    /// <summary>
    /// Comments regarding submission of the employee handbook by prospective staff.
    /// TypeID = 238027.
    /// </summary>
    EmployeeHandbook = 238027,

    /// <summary>
    /// Comments regarding reference checks for propective staff.
    /// TypeID = 238028.
    /// </summary>
    ReferenceCheck = 238028,

    /// <summary>
    /// Notes and actions related to term staff certifications.
    /// TypeID = 238028.
    /// </summary>
    Certifications = 238029,

    /// <summary>
    /// Notes and actions related to paperwork other than the standard term staff submissions.
    /// TypeID = 238030
    /// </summary>
    OtherPaperwork = 238030,

    /// <summary>
    /// TypeID = 238044
    /// </summary>
    ApprovalGranted = 238044,

    /// <summary>
    /// TypeID = 238045
    /// </summary>
    OfferPreparation = 238045,

    /// <summary>
    /// Final processing step for prospective employee.
    /// TypeID = 238046.
    /// </summary>
    ClearForScheduling = 238046,

    /// <summary>
    /// Employee that had been cleared for scheduling is no longer cleared.
    /// TypeID = 238047
    /// </summary>
    RevokeClearanceForScheduling = 238047,

    /// <summary>
    /// In the processing category, records when the page status is changed through administrator action.
    /// TypeID = 238048
    /// </summary>
    FormStatusChange = 238048,

    /// <summary>
    /// In the processing category, records when the form Expiration Date Change is changed through administrator action.
    /// TypeID = 238049
    /// </summary>
    ExpirationDateChange = 238049,

    /// <summary>
    /// In the processing category, records when the form Advanced Certification setting is changed through admin action.
    /// TypeID = 238029
    /// </summary>
    Certification = 238029,

    /// <summary>
    /// In the processing category, records when the location specific form is changed through admin action.
    /// TypeID = 238050
    /// </summary>
    ARFStatusChange = 238050,

    /// <summary>
    /// TypeID = 238051
    /// </summary>
    ManualChange = 238051,

    /// <summary>
    /// TypeID = 238052
    /// </summary>
    AutoChange = 238052,

    /// <summary>
    /// TypeID = 238053
    /// </summary>
    WeekSchedulerChange = 238053,

    /// <summary>
    /// TypeID = 238054
    /// </summary>
    TabAssignmentsSchedulerChange = 238054,

    /// <summary>
    /// TypeID = 238055
    /// </summary>
    ProductControllerChange = 238055,

    /// <summary>
    /// TypeID = 238056
    /// </summary>
    JobOfferControllerChange = 238056,

    /// <summary>
    /// TypeID = 238057
    /// </summary>
    JobAppReviewControllerChange = 238057
}

export enum HRLogCategoryType {
    /// <summary>
    /// TypeID = 237000
    /// </summary>
    Interview = 237000,

    /// <summary>
    /// TypeID = 237001
    /// </summary>
    Reject_Terminate = 237001,

    /// <summary>
    /// TypeID = 237002
    /// </summary>
    Application = 237002,

    /// <summary>
    /// TypeID = 237003
    /// </summary>
    WrittenOffer = 237003,

    /// <summary>
    /// TypeID = 237004
    /// </summary>
    VerbalOffer = 237004,

    /// <summary>
    /// TypeID = 237006
    /// </summary>
    Preferences = 237006,

    /// <summary>
    /// TypeID = 237007
    /// </summary>
    Processing = 237007,

    /// <summary>
    /// TypeID = 237015
    /// </summary>
    ContactInfoChange = 237015,

    /// <summary>
    /// TypeID = 237016
    /// </summary>
    EmploymentProfileChange = 237016,

    /// <summary>
    /// TypeID = 237017
    /// </summary>
    StatusChange = 237017,

    /// <summary>
    /// TypeID = 237018
    /// </summary>
    Scheduling = 237018
}

export enum HRLogEntryType {
    /// <summary>
    /// TypeID = 245000
    /// </summary>
    Auto = 245000,

    /// <summary>
    /// TypeID = 245001
    /// </summary>
    Manual = 245001
}

export enum HRLogReasonType {
    /// <summary>
    /// TypeID = 240005
    /// </summary>
    Other = 240005,

    /// <summary>
    /// TypeID = 240015
    /// </summary>
    UnsatisfactoryPerformance = 240015,

    /// <summary>
    /// TypeID = 240016
    /// </summary>
    ViolationOfCompanyPolicy = 240016,

    /// <summary>
    /// TypeID = 240017
    /// </summary>
    EndOfTerm = 240017
}

export enum ImmunizationStatus {
    /// <summary>
    /// TypeID = 199000
    /// </summary>
    NeverImmunized = 199000,

    /// <summary>
    /// TypeID = 199001
    /// </summary>
    ImmunizedNotSureWhen = 199001,

    /// <summary>
    /// TypeID = 199002
    /// </summary>
    Immunized = 199002
}

export enum ImmunizationType {
    /// <summary>
    /// TypeID = 198000
    /// </summary>
    Tetanus = 198000,

    /// <summary>
    /// TypeID = 198001
    /// </summary>
    Diphtheria = 198001,

    /// <summary>
    /// TypeID = 198002
    /// </summary>
    Polio = 198002,

    /// <summary>
    /// TypeID = 198003
    /// </summary>
    MeaslesMumpsRubella = 198003,

    /// <summary>
    /// TypeID = 198004
    /// </summary>
    Measles = 198004,

    /// <summary>
    /// TypeID = 198005
    /// </summary>
    Mumps = 198005,

    /// <summary>
    /// TypeID = 198006
    /// </summary>
    Rubella = 198006,

    /// <summary>
    /// TypeID = 198007
    /// </summary>
    HaemophilusInfluenzaTypeB = 198007,

    /// <summary>
    /// TypeID = 198008
    /// </summary>
    HepatitisA = 198008,

    /// <summary>
    /// TypeID = 198009
    /// </summary>
    HepatitisB = 198009,

    /// <summary>
    /// TypeID = 198010
    /// </summary>
    Varicella = 198010
}

export enum InsuranceType {
    /// <summary>
    /// TypeID = 200000.
    /// </summary>
    Health = 200000
}

/**
 * Identifies manner in which information request is entered.
 */
export enum InfoRequestMethod {
    /// <summary>
    /// Entered by CS.
    /// TypeID = 149000.
    /// </summary>
    CSPhone = 149000,

    /// <summary>
    /// Entered on line by Client.
    /// TypeID = 149001
    /// </summary>
    Client = 149001,

    /// <summary>
    /// TypeID = 149002.
    /// </summary>
    CSEmail = 149002,

    /// <summary>
    /// TypeID = 149003.
    /// </summary>
    CSMail = 149003,

    /// <summary>
    /// TypeID = 149004.
    /// </summary>
    CSCampAdvisor = 149004
}

/**
 * Group Info Request Method types.
 */
export enum InfoRequestMethodCategory {
    /// <summary>
    /// InfoRequestMethod values viewable to client.
    /// TypeID = 194000.
    /// </summary>
    Client = 194000,

    /// <summary>
    /// InfoRequestMethod values viewable to CS Representative.
    /// TypeID = 194001.
    /// </summary>
    CustomerService = 194001
}

/**
 * Types of information that users may request, such as catalogs.
 */
export enum InfoRequestType {
    /// <summary>
    /// Course/Program Catalog. TypeID = 67000.
    /// </summary>
    Catalog = 67000,
    /// <summary>
    /// Identify requests made with iD OnSite Request form.
    /// TypeID = 67001.
    /// </summary>
    iDOnSite = 67001,

    /// <summary>
    /// Wait List Request.
    /// TypeID = 67002
    /// </summary>
    WaitList = 67002,

    /// <summary>
    /// Shopping Session
    /// TypeID = 67003
    /// </summary>
    ShoppingSession = 67003
}

export enum JobClass {
    /// <summary>
    /// TypeID = 222000.
    /// </summary>
    CL_Clerical = 222000,
    /// <summary>
    /// TypeID = 222001.
    /// </summary>
    MG_Management = 222001,
    /// <summary>
    /// TypeID = 222002.
    /// </summary>
    SM_SeniorManagement = 222002,
    /// <summary>
    /// TypeID = 222003.
    /// </summary>
    TC_Technical = 222003,
    /// <summary>
    /// TypeID = 222004.
    /// </summary>
    SP_SalesPersonnel = 222004
}

export enum JobFLSACompensation {
    /// <summary>
    /// TypeID = 221000.
    /// </summary>
    Exempt = 221000,
    /// <summary>
    /// TypeID = 221001.
    /// </summary>
    NonExempt = 221001
}

export enum JobGenre {
    /// <summary>
    /// TypeID = 269000.
    /// </summary>
    Director = 269000,
    /// <summary>
    /// TypeID = 269001.
    /// </summary>
    AsstDirector = 269001,
    /// <summary>
    /// TypeID = 269002.
    /// </summary>
    HealthSafety = 269002,
    /// <summary>
    /// TypeID = 269003.
    /// </summary>
    ActivityCoordinator = 269003,
    /// <summary>
    /// TypeID = 269004.
    /// </summary>
    LeadInstructor = 269004,
    /// <summary>
    /// TypeID = 269005.
    /// </summary>
    Instructor = 269005
}

export enum JobInterviewStatusType {
    /// <summary>
    /// TypeID = 239000
    /// </summary>
    Cancelled = 239000,

    /// <summary>
    /// TypeID = 239001
    /// </summary>
    Completed = 239001,

    /// <summary>
    /// TypeID = 239002
    /// </summary>
    NeedAdditional = 239002
}

export enum JobInterviewType {
    /// <summary>
    /// TypeID = 236000
    /// </summary>
    Scheduled = 236000,

    /// <summary>
    /// TypeID = 236001
    /// </summary>
    Actual = 236001
}

export enum JobApprovalRequirement {
    /// <summary>
    /// TypeID = 297000
    /// </summary>
    DiscretionaryPay = 297000,

    /// <summary>
    /// TypeID = 297001
    /// </summary>
    RequireIfNoAssignmentHistory = 297001,

    /// <summary>
    /// TypeID = 297002
    /// </summary>
    AlwaysRequire = 297002
}

export enum JobOfferType {
    /// <summary>
    /// TypeID = 247000
    /// </summary>
    VerbalOffer = 247000,

    /// <summary>
    /// TypeID = 247001
    /// </summary>
    WrittenOffer = 247001
}

export enum JobOfferStatus {
    /// <summary>
    /// TypeID = 246000
    /// </summary>
    Declined = 246000,

    /// <summary>
    /// TypeID = 246001
    /// </summary>
    Draft = 246001,

    /// <summary>
    /// TypeID = 246002
    /// </summary>
    NeedApproval = 246002,

    /// <summary>
    /// TypeID = 246003
    /// </summary>
    Approved = 246003,

    /// <summary>
    /// TypeID = 246004
    /// </summary>
    Published = 246004,

    /// <summary>
    /// TypeID = 246005
    /// </summary>
    Accepted = 246005,

    /// <summary>
    /// TypeID = 246006
    /// </summary>
    ApprovalDenied = 246006,

    /// <summary>
    /// TypeID = 246007
    /// </summary>
    Rescinded = 246007
}

export enum JobPurview {
    /// <summary>
    /// TypeID = 268000.
    /// </summary>
    CampWide = 268000,
    /// <summary>
    /// TypeID = 268001.
    /// </summary>
    Instruction = 268001
}

export enum JobResidencyPreference {
    /// <summary>
    /// TypeID = 229000.
    /// </summary>
    ON = 229000,

    /// <summary>
    /// TypeID = 229001.
    /// </summary>
    ON_Wknd = 229001,

    /// <summary>
    /// TypeID = 229002.
    /// </summary>
    Commute = 229002,

    /// <summary>
    /// TypeID = 229003.
    /// </summary>
    Com_Housing = 229003,

    /// <summary>
    /// TypeID = 229004.
    /// </summary>
    Com_Housing_Wnd = 229004
}

export enum JobSchedule {
    /// <summary>
    /// TypeID = 322000.
    /// </summary>
    HalfDay = 322000,
    /// <summary>
    /// TypeID = 322001.
    /// </summary>
    FullDay = 322001
}

export enum JobVisibility {
    /// <summary>
    /// TypeID = 223000.
    /// </summary>
    TermStaffAppOnly = 223000,
    /// <summary>
    /// TypeID = 223001.
    /// </summary>
    TermStaffAppAndOfferTitle = 223001,
    /// <summary>
    /// TypeID = 223002.
    /// </summary>
    JobOfferTitleOnly = 223002,
    /// <summary>
    /// TypeID = 223003.
    /// </summary>
    SchedulingUnit = 223003
}

export enum LanguageType {
    EnglishUS = 24000
}

export enum LetterType {
    /// <summary>
    /// TypeID = 242000
    /// </summary>
    PostInterviewRejection_NewApplicant = 242000,

    /// <summary>
    /// TypeID = 242001
    /// </summary>
    PostInterviewRejection_ReturningApplicant = 242001,

    /// <summary>
    /// TypeID = 242002
    /// </summary>
    RescindOffer_Unresponsive = 242002,

    /// <summary>
    /// TypeID = 242003
    /// </summary>
    RescindOffer_BackgroundReferences = 242003,

    /// <summary>
    /// TypeID = 242004
    /// </summary>
    PreInterviewRejection_NewApplicant = 242004,

    /// <summary>
    /// TypeID = 242005
    /// </summary>
    PreInterviewRejection_ReturningApplicant = 242005,

    /// <summary>
    /// TypeID = 242006
    /// </summary>
    VerbalOffer_CommitmentToID = 242006,

    /// <summary>
    /// TypeID = 242007
    /// </summary>
    WrittenOfferNotification = 242007,

    /// <summary>
    /// TypeID = 242008
    /// </summary>
    WrittenOffer = 242008,

    /// <summary>
    /// TypeID = 242009
    /// </summary>
    WrittenOfferJobDescription = 242009,

    /// <summary>
    /// TypeID = 242010
    /// </summary>
    WrittenOfferQualityAssurance = 242010,

    /// <summary>
    /// TypeID = 242011
    /// </summary>
    WrittenOfferReminder = 242011,

    /// <summary>
    /// TypeID = 242012
    /// </summary>
    ReferenceCheck = 242012,

    /// <summary>
    /// TypeID = 242013
    /// </summary>
    TermStaffWorkSchedule = 242013
}

export enum LimitType {
    /// <summary>
    /// Numeric
    /// </summary>
    Numeric = 42000,
    /// <summary>
    /// Percent
    /// </summary>
    Percent = 42001
}

export enum LocationType {
    UniversityCollege = 14000,
    Online = 14001,
    Virtual = 14002, // iDVC iDVA
    VirtualSquads = 14003,
    BootcampPartnership = 14004
}

export enum LocationContactUsageType {
    VisitorInformation = 282000,
    CampDirector = 282001,
    CampAssistantDirector = 282002
}

export enum LocationSessionTextType {
    /// <summary>
    /// TypeID = 325000
    /// </summary>
    AlertNotes = 325000,
    /// <summary>
    /// TypeID = 325000
    /// </summary>
    CSAlertNotes = 325001
}

export enum LocationUserRoleType {
    MainContactLiaison = 283000,
    SummerConferenceAsst = 283001,
    PressLiaison = 283002,
    ParkingContact = 283003,
    ResidenceHallContact = 283004,
    DiningServicesContact = 283005,
    LabSpaceContact = 283006,
    LabTechnicalSupportContact = 283007,
    LabTechnicalSupportContactAlt = 283008,
    ElectricalAuthorityContact = 283009,
    ShippingContact = 283010,
    MailroomContact = 283011
}

export enum LSISectionType {
    GeneralInfo2 = 286000,
    Parking = 286001,
    MiscellaneousInformation = 286002,
    Activities = 286003,
    ResidenceHallInformation = 286004,
    DiningandMeals = 286005,
    GeneralLabInfo = 286006,
    NetworkSetUpInfo = 286007,
    ElectricalRoomDetails = 286008,
    ComputerSetup = 286009,
    DeliveriesandShipping = 286010,
    AddressN = 286011,
    LabBuildingDetails = 286012,
    GeneralInfo1 = 286013,
    AdditionalGeneralNotesGeneralInfo = 286014,
    AdditionalGeneralNotesHousing_Meals = 286015,
    AdditionalGeneralNotesLabInfo = 286016,
    AdditionalGeneralNotesShipping = 286017
}

export enum MedicationTimeTaken {
    /// <summary>
    /// TypeID = 204000
    /// </summary>
    DuringBreakfast = 204000,

    /// <summary>
    /// TypeID = 204001
    /// </summary>
    DuringLunch = 204001,

    /// <summary>
    /// TypeID = 204002
    /// </summary>
    DuringDinner = 204002,

    /// <summary>
    /// TypeID = 204003
    /// </summary>
    AtBedTime = 204003,

    /// <summary>
    /// TypeID = 204004
    /// </summary>
    Other = 204004,

    /// <summary>
    /// TypeID = 204005
    /// </summary>
    AsNeeded = 204005
}

export enum MigrationOutcome {
    /// <summary>
    /// Not used
    /// </summary>
    NotMigratedUnknownReason = 0,

    /// <summary>
    /// User has already been migrated
    /// </summary>
    MigratedAlready = 1,

    /// <summary>
    /// User provided a valid username, the primary email for which
    /// yielded a single result
    /// </summary>
    MigratedUsernameToPrimaryEmail = 2,

    /// <summary>
    /// User provided a valid primary email, yielding a single result
    /// </summary>
    MigratedUsernameToProvidedPrimaryEmail = 3,

    /// <summary>
    /// Multiple accounts were found using the provided email as
    /// their Primary Email
    /// </summary>
    NotMigratedMultipleAccountsWithProvidedEmail = 4,

    /// <summary>
    /// Multiple accounts were found matching the Primary Email of the
    /// account resolved using the provided Username
    /// </summary>
    NotMigratedMultiplePrimaryEmailsWithProvidedUsername = 5,

    /// <summary>
    /// The resolved user did not have a primary email
    /// </summary>
    NotMigratedPublicUserMissingPrimaryEmail = 6,

    /// <summary>
    /// A public user was not found matching the given username
    /// </summary>
    NotMigratedPublicUserNotFound = 7,

    /// <summary>
    /// Migration could not take place because the user password was incorrect,
    /// the user would have been migrated had the password been correct.
    /// </summary>
    NotMigratedAuthenticationFailure = 8
}

export enum NoteType {
    ClientLogDetail = 172000,
    CompletionNote = 172001,
    ProgressNote = 172002,
    AssignmentNote = 172003,
    ClientLogResolutionDetail = 172004,
    CorrespondenceDetail = 172005
}

export enum OnlyExtraResolutionType {
    /// <summary>
    /// TypeID = 101000
    /// </summary>
    Unresolved = 101000,

    /// <summary>
    /// TypeID = 101001
    /// </summary>
    Closed = 101001,

    /// <summary>
    /// TypeID = 101002
    /// </summary>
    ApprovedAsIs = 101002,

    /// <summary>
    /// TypeID = 101003
    /// </summary>
    ChangedProductOnly = 101003,

    /// <summary>
    /// TypeID = 101004
    /// </summary>
    ChangedSessionOnly = 101004,

    /// <summary>
    /// TypeID = 101005
    /// </summary>
    ChangedLocationOnly = 101005,

    /// <summary>
    /// TypeID = 101006
    /// </summary>
    ChangedSessionAndProduct = 101006,

    /// <summary>
    /// TypeID = 101007
    /// </summary>
    ChangedLocationAndProduct = 101007,

    /// <summary>
    /// TypeID = 101008
    /// </summary>
    AutomaticallyResolved = 101008,

    /// <summary>
    /// TypeID = 101009
    /// </summary>
    SessionStarted = 101009,

    /// <summary>
    /// TypeID = 101010
    /// </summary>
    Cancellation = 101010
}

export enum OnlyType {
    OnlyParticipantInMealPlanForTheSession = 90000,
    OnlyParticipantWithoutMealPlanForTheSession = 90001,
    OnlyParticipantInACourseForTheSession = 90002,
    OnlyParticipantInOvernightOrWeekendForTheSession = 90003,
    OnlyFemaleInASession = 90004,
    OnlyFemaleInOvernightOrWeekendForTheSession = 90005,
    OnlyTeenInASession = 90006,
    OnlyTeenInOvernightOrWeekendForTheSession = 90007,
    OnlyNonTeenInASession = 90008,
    OnlyNonTeenInOvernightOrWeekendForTheSession = 90009,
    OvernightParticipantIsYoungerThanOthersByAtLeast3Years = 90010,
    OvernightParticipantIsOlderThanOthersByAtLeast3Years = 90011
}

export enum OrderCommentType {
    /// <summary>
    /// TypeID = 98000
    /// </summary>
    RoomWith = 98000,
    /// <summary>
    /// TypeID = 98001
    /// </summary>
    GroupWith = 98001,
    /// <summary>
    /// TypeID = 98002
    /// </summary>
    General = 98002,
    /// <summary>
    /// TypeID = 98003
    /// </summary>
    FeeDetails = 98003,
    /// <summary>
    /// TypeID = 98004
    /// </summary>
    // NotUsed = 98004,
    /// <summary>
    /// TypeID = 98005
    /// </summary>
    Diploma = 98005,
    /// <summary>
    /// TypeID = 98006
    /// </summary>
    // NotUsed = 98006,
    /// <summary>
    /// TypeID = 98007
    /// </summary>
    PrivateComment = 98007,

    /// <summary>
    /// TypeID = 98008
    /// </summary>
    AutoRenewTurnedOn = 98008,

    /// <summary>
    /// TypeID = 98009
    /// </summary>
    AutoRenewTurnedOff = 98009
}

export enum OrderCommentWorkflowStatusType {
    /// <summary>
    /// TypeID = 203000
    /// </summary>
    Draft = 203000,
    /// <summary>
    /// TypeID = 203001
    /// </summary>
    PendingReview = 203001,
    /// <summary>
    /// TypeID = 203002
    /// </summary>
    Complete = 203002
}

export enum OrderDetailAdjustmentType {
    Return = 108000,
    DiscountReversal = 108001,
    Payment = 108002
}

export enum OrderDetailDiscountStatusType {
    Valid = 119000,
    Pending = 119001,
    Reversed = 119003
}

export enum OrderDetailStatusType {
    /// <summary>
    /// TypeID=89000
    /// </summary>
    SaleComplete = 89000,
    /// <summary>
    /// TypeID=89001
    /// </summary>
    ShoppingCart = 89001,
    /// <summary>
    /// TypeID=89002
    /// </summary>
    Returned = 89002,
    /// <summary>
    /// TypeID=89003
    /// </summary>
    Cancelled = 89003
}

export enum OrderSourceType {
    /// <summary>
    /// TypeID = 196000
    /// </summary>
    Online = 196000,
    /// <summary>
    /// TypeID = 196001
    /// </summary>
    Phone = 196001,
    /// <summary>
    /// TypeID = 196002
    /// </summary>
    Mail = 196002,
    /// <summary>
    /// TypeID = 196003
    /// </summary>
    Fax = 196003
}

export enum OrderStatusType {
    SaleComplete = 88000,
    ShoppingCart = 88001,
    PaymentProcessing = 88002
}

export enum OrderType {
    Standard = 81000,
    WaitList = 81001,
    ShoppingCart = 81002
}

export enum OrderUserRoleType {
    /// <summary>
    /// TypeID = 93000.
    /// </summary>
    PrimaryCustomer = 93000,
    /// <summary>
    /// TypeID = 93001.
    /// </summary>
    SecondaryCustomer = 93001,
    /// <summary>
    /// TypeID = 93002.
    /// </summary>
    ParentGuardian = 93002,
    /// <summary>
    /// TypeID = 93003.
    /// </summary>
    Participant = 93003,
    /// <summary>
    /// TypeID = 93004.
    /// </summary>
    PickUpPerson = 93004,
    /// <summary>
    /// TypeID = 93005.
    /// </summary>
    Parent = 93005,
    /// <summary>
    /// TypeID = 93006.
    /// </summary>
    Guardian = 93006,
    /// <summary>
    /// TypeID = 93007.
    /// </summary>
    Other = 93007
}

export enum OverrideReasonType {
    /// <summary>
    /// TypeID = 153000
    /// </summary>
    FitBetterWithYoungerCourse = 153000,

    /// <summary>
    /// TypeID = 153001
    /// </summary>
    FitBetterWithOlderCourse = 153001,

    /// <summary>
    /// TypeID = 153002
    /// </summary>
    MaturityLevelSufficient = 153002,

    /// <summary>
    /// TypeID = 153003
    /// </summary>
    WantJoinFriend = 153003,

    /// <summary>
    /// TypeID = 153004
    /// </summary>
    AtSessionChangeApprovedbyDirector = 153004
}

export enum OverrideType {
    /// <summary>
    /// TypeID = 156000
    /// </summary>
    CSRegistrationEndPassed = 156000,

    /// <summary>
    /// TypeID = 156001
    /// </summary>
    CSAddSessionEndPassed = 156001,

    /// <summary>
    /// TypeID = 156002
    /// </summary>
    CSChangeSessionEndPassed = 156002,

    /// <summary>
    /// TypeID = 156003
    /// </summary>
    ParticipantTooYoung = 156003,

    /// <summary>
    /// TypeID = 156004
    /// </summary>
    ParticipantTooOld = 156004
}

export enum PackageType {
    Standard = 44000
}

export enum ParticipantAgeRangeType {
    _13 = 146000,
    _14 = 146001,
    _15 = 146002,
    _16 = 146003,
    _17 = 14600
}

export enum PayCalculation {
    /// <summary>
    /// Type ID = 252000
    /// </summary>
    DefinedAmount_Hourly = 252000,

    /// <summary>
    /// Type ID = 252001
    /// </summary>
    DefinedAmount_Exempt = 252001,

    /// <summary>
    /// Type ID = 252002
    /// </summary>
    BaseSalary_Plus_DiscretionaryPay_Minus_Daily = 252002
}

export enum PayDisbursementOption {
    /// <summary>
    /// Type ID = 258000
    /// </summary>
    DirectDeposit = 258000,

    /// <summary>
    /// Type ID = 258001
    /// </summary>
    WireTransfer = 258001,

    /// <summary>
    /// Type ID = 258002
    /// </summary>
    LiveCheck = 258002
}

export enum PayItem {
    /// <summary>
    /// Type ID = 250000
    /// </summary>
    Overnight = 250000,

    /// <summary>
    /// Type ID = 250001
    /// </summary>
    Weekend = 250001,

    /// <summary>
    /// Type ID = 250002
    /// </summary>
    LocationSetUp = 250002,

    /// <summary>
    /// Type ID = 250003
    /// </summary>
    Orientation = 250003,

    /// <summary>
    /// Type ID = 250004
    /// </summary>
    NonWorkingWeekendHousing_Charged = 250004,

    /// <summary>
    /// Type ID = 250005
    /// </summary>
    NonWorkingWeekendHousing_Waived = 250005,

    /// <summary>
    /// Type ID = 250006
    /// </summary>
    WeeknightHousing = 250006,

    /// <summary>
    /// Type ID = 250007
    /// </summary>
    NonWorkingWeekendHousing_Included = 250007,

    /// <summary>
    /// Type ID = 250008
    /// </summary>
    ManualPayAdjustment = 250008
}

export enum PayItemDuration {
    /// <summary>
    /// Type ID = 251000
    /// </summary>
    Hourly = 251000,

    /// <summary>
    /// Type ID = 251001
    /// </summary>
    Daily = 251001,

    /// <summary>
    /// Type ID = 251002
    /// </summary>
    Weekly = 251002,

    /// <summary>
    /// Type ID = 251003
    /// </summary>
    Monthly = 251003
}

export enum PayItemOffset {
    /// <summary>
    /// TypeID = 275000
    /// </summary>
    SessionStart = 275000,
    /// <summary>
    /// TypeID = 275001
    /// </summary>
    Sunday = 275001,
    /// <summary>
    /// TypeID = 275002
    /// </summary>
    AssignmentStartEndDate = 275002
}

export enum PaymentMethodType {
    /// <summary>
    /// TypeID = 95000
    /// </summary>
    Check = 95000,
    /// <summary>
    /// TypeID = 95001
    /// </summary>
    Cash = 95001,
    /// <summary>
    /// TypeID = 95002
    /// </summary>
    CreditCard = 95002,
    /// <summary>
    /// TypeID = 95003
    /// </summary>
    Voucher = 95003,
    /// <summary>
    /// TypeID = 95004
    /// </summary>
    MoneyOrder = 95004,
    /// <summary>
    /// TypeID = 95005
    /// </summary>
    Scholarship = 95005
}

export enum PaymentStatusType {
    Submitted = 133000
}

export enum PaymentType {
    Incoming = 94000,
    Outgoing = 94001
}

export enum PayrollApprovalStatus {
    /// <summary>
    /// TypeID = 277000
    /// </summary>
    NotStarted = 277000,

    /// <summary>
    /// TypeID = 277001
    /// </summary>
    RMCorrectionsNeeded = 277001,

    /// <summary>
    /// TypeID = 277002
    /// </summary>
    RMReviewing = 277002,

    /// <summary>
    /// TypeID = 277003
    /// </summary>
    RMApproved = 277003,

    /// <summary>
    /// TypeID = 277004
    /// </summary>
    COMCorrectionsNeeded = 277004,

    /// <summary>
    /// TypeID = 277005
    /// </summary>
    COMReviewing = 277005,

    /// <summary>
    /// TypeID = 277006
    /// </summary>
    COMApproved = 277006,

    /// <summary>
    /// TypeID = 277007
    /// </summary>
    PayrollReviewing = 277007,

    /// <summary>
    /// TypeID = 277008
    /// </summary>
    PayrollApproved = 277008,

    /// <summary>
    /// TypeID = 277009
    /// </summary>
    PayrollTransmitted = 277009,

    /// <summary>
    /// TypeID = 277010
    /// </summary>
    PayrollHold = 277010
}

export enum PayrollCycle {
    /// <summary>
    /// TypeID = 278000
    /// </summary>
    Normal = 278000,

    /// <summary>
    /// TypeID = 278001
    /// </summary>
    Early = 278001
}

export enum ProcessingUsageStatus {
    /// <summary>
    /// TypeID = 262000
    /// </summary>
    TermStaffApplicationHiringWorkflow = 262000,

    /// <summary>
    /// TypeID = 262001
    /// </summary>
    BackgroundCheck = 262001,

    /// <summary>
    /// TypeID = 262002
    /// </summary>
    ReferenceCheck = 262002
}

export enum ProductCategoryType {
    Course = 17000,
    Meal = 17001,
    Activity = 17002,
    Residency = 17003,
    Merchandise = 17004,
    CEU = 17005,
    Fee = 17006,
    Subscription = 17007,
    Transportation = 17008,
    PurchaseCredit = 17009,
    Tutor = 17010
}

export enum ProductDisplayConfigType {
    /// <summary>
    /// TypeID = 228000
    /// </summary>
    Standard = 228000
}

/**
 * Used to set the equipment needed for a course.
 * NOTE: Deprecated on 05/12/2014
 */
//export enum ProductEquipmentType
//{
//    /// <summary>
//    /// TypeID = 298000
//    /// </summary>
//    Mac = 298000,
//    GamingPC = 298001,
//    RegularPC = 298002,
//}

/**
 * Used to set the genre of a product.
 */
export enum ProductGenreType {
    /// <summary>
    /// TypeID = 295000
    /// </summary>
    Coding = 295000,
    GameDevelopment = 295002,
    Robotics = 295001,
    Design = 295003
}

export enum ProductImportantDateType {
    AutoRenewReminder2 = 217000,
    AutoRenewReminder1 = 217001,
    AutoRenewBillDate = 217002,
    StandardSubscriptionExpirationReminder2 = 217003,
    StandardSubscriptionExpirationReminder1 = 217004
}

export enum ProductImportantDateStatusType {
    Pending = 218000,
    Sent = 218001
}

export enum ProductImptDateRelativeToType {
    StartOfSubscription = 219000,
    EndOfSubscription = 219001
}

export enum ProductRatioType {
    /// <summary>
    /// ParticipantsPerInstructor
    /// </summary>
    ParticipantsPerInstructor = 53000
}

/**
 * For segmentation on the availability charts, week scheduler, and cap man features.
 */
export enum ProductSchedule {
    /// <summary>
    /// All-day courses.
    /// TypeID = 323000.
    /// </summary>
    FullDay = 323000,

    /// <summary>
    /// Half-day courses - morning.
    /// TypeID = 323001
    /// </summary>
    Morning = 323001,

    /// <summary>
    /// Half-day courses - afternoon.
    /// TypeID = 323002.
    /// </summary>
    Afternoon = 323002
}

export enum ProductSkillType {
    /// <summary>
    /// TypeID = 220000.
    /// </summary>
    StaffSkill = 220000,

    /// <summary>
    /// TypeID = 220001.
    /// </summary>
    ParticipantSkill = 220001
}

export enum ProductSubCategoryType {
    /// <summary>
    /// TypeID = 65000.
    /// </summary>
    Breakfast = 65000,
    /// <summary>
    /// TypeID = 65001.
    /// </summary>
    Lunch = 65001,
    /// <summary>
    /// TypeID = 65002.
    /// </summary>
    Dinner = 65002,
    /// <summary>
    /// TypeID = 65024.
    /// </summary>
    B_L_D = 65024,
    /// <summary>
    /// TypeID = 65003.
    /// </summary>
    Overnight = 65003,
    /// <summary>
    /// Weekend After.
    /// TypeID = 65004.
    /// </summary>
    WeekendAfter = 65004,
    /// <summary>
    /// ***WARNING:  This type is no longer Active.  Please use B_L_D to check for ExtendedDay.
    /// TypeID = 65026.
    /// </summary>
    ExtendedDay = 65026,
    /// <summary>
    /// TypeID = 65012.
    /// </summary>
    AdministrativeChangeFee = 65012,
    /// <summary>
    /// TypeID = 65029.
    /// </summary>
    ProductChangeAfterSessionStartFee = 65029,
    /// <summary>
    /// TypeID = 65014.
    /// </summary>
    BalancePaymentExtensionOverdueFee = 65014,
    /// <summary>
    /// TypeID = 65013.
    /// </summary>
    BalancePaymentOverdueFee = 65013,
    /// <summary>
    /// TypeID = 65015.
    /// </summary>
    BackgroundCheckProcessingFeeNotNY = 65015,
    /// <summary>
    /// TypeID = 65027.
    /// </summary>
    BackgroundCheckProcessingFeeNY = 65027,
    /// <summary>
    /// TypeID = 65025.
    /// </summary>
    CancellationFee = 65025,
    /// <summary>
    /// TypeID = 65030
    /// </summary>
    WeekendBefore = 65030,

    /// <summary>
    /// TypeID = 65032
    /// </summary>
    WeekendWithin = 65032,

    /// <summary>
    /// TypeID = 65028
    /// </summary>
    OvernightAndWeekend = 65028,

    /// <summary>
    /// TypeID = 65033
    /// </summary>
    RecoupWriteOffDiscountFee = 65033,

    /// <summary>
    /// TypeID = 65022
    /// </summary>
    LatePickupFee = 65022,

    /// <summary>
    /// TypeID = 65017
    /// </summary>
    LostKeyFee = 65017,

    /// <summary>
    /// TypeID = 65019
    /// </summary>
    MedicationsPurchasedDuringSessionFee = 65019,

    /// <summary>
    /// TypeID = 65016
    /// </summary>
    PropertyDamageDuringSessionFee = 65016,

    /// <summary>
    /// TypeID = 65021
    /// </summary>
    PurchaseReimbursementDuringSessionFee = 65021,

    /// <summary>
    /// TypeID = 65023
    /// </summary>
    ReturnedCheckFee = 65023,

    /// <summary>
    /// TypeID = 65020
    /// </summary>
    TransportationDuringSessionFee = 65020,

    /// <summary>
    /// TypeID = 65018
    /// </summary>
    LostMealCardDuringSessionFee = 65018,

    /// <summary>
    /// TypeID = 65036
    /// </summary>
    GenericFeeForUnusualSituations = 65036,

    /// <summary>
    /// TypeID = 65043
    /// </summary>
    Subscription_Monthly = 65043,

    /// <summary>
    /// TypeID = 65044
    /// </summary>
    ComplianceAndSafetyFee = 65044,

    /// <summary>
    /// TypeID = 65045
    /// </summary>
    CourseChangeFee = 65045,

    /// <summary>
    /// TypeID = 65054
    /// </summary>
    EarlyAccess = 65054
}

export enum ProductTextUsage {
    SubscriptionSelectionButtonText = 321000
}

export enum ProductURLType {
    /// <summary>
    /// TypeID = 294000
    /// </summary>
    CourseDetailsURL = 294000,

    /// <summary>
    /// TypeID = 294001
    /// </summary>
    CourseVideoURL = 294001,

    /// <summary>
    /// contains the part of the path not held in web.config. Points to the image displayed before the video plays.
    /// TypeID = 294002
    /// </summary>
    CourseVideoIntroImageURL = 294002
}

/**
 * Bit masking flags
 * <remarks>This enum does not use the TypeIDs in the Type table.  Values are set to bit masks.</remarks>
 */
export enum ProjectUploadOptionMask {
    None = 0x0,

    /// <summary>
    /// Flag = 0x1. Bit pos 1. Download
    /// </summary>
    Download = 0x1,

    /// <summary>
    /// Flag = 0x2. Bit pos 2. Gallery
    /// </summary>
    Gallery = 0x2,
    /// <summary>
    /// Flag = 0x4. Bit pos 3. YouTube
    /// </summary>
    YouTube = 0x4,
    /// <summary>
    /// Flag = 0x8. Bit pos 4. Fusion SWF
    /// </summary>
    FusionSWF = 0x8,
    /// <summary>
    /// Flag = 0x10. Bit pos 5. Scratch
    /// </summary>
    Scratch = 0x10,
    /// <summary>
    /// Flag = 0x20. Bit pos 6. Website
    /// </summary>
    Website = 0x20,
    /// <summary>
    /// Flag = 0x40. Bit pos 7. Vimeo
    /// </summary>
    Vimeo = 0x40,

    All = 0xffff
}

export enum QAMeasurementType {
    TermStaff = 232000
}

export enum RelatedProductType {
    IncludedProduct = 71000,
    StandardOptionalProduct = 71001,
    MutuallyExclusiveProduct = 71002,
    Combo = 71004,
    PrimaryOptionalProduct = 71005,
    ProductVariant = 71006,
    Required = 71007
}

export enum RecordStateType {
    /// <summary>
    /// Active
    /// </summary>
    Active = 1000,
    /// <summary>
    /// Soft Delete
    /// </summary>
    Deleted = 1001,
    /// <summary>
    /// Pending
    /// </summary>
    Archived = 1002
}

export enum ReferenceContactType {
    /// <summary>
    /// Person has been contacted about serving as a reference.
    /// TypeID = 188000.
    /// </summary>
    Yes = 188000,

    /// <summary>
    /// Person not contacted about serving as a reference.
    /// TypeID = 188001.
    /// </summary>
    No = 188001,

    /// <summary>
    /// Person should not be asked to serve as a reference.
    /// TypeID = 188002.
    /// </summary>
    DoNotContact = 188002
}

export enum ReferenceOKType {
    /// <summary>
    /// Not yet contacted about being a reference.
    /// TypeID = 189000.
    /// </summary>
    NotYetAsked = 189000,

    /// <summary>
    /// Asked, but not yet replied about being a reference.
    /// TypeID = 189001.
    /// </summary>
    NotYetReplied = 189001,

    /// <summary>
    /// Willing to serve as a reference.
    /// TypeID = 189002.
    /// </summary>
    Yes = 189002,

    /// <summary>
    /// Has been asked and is not willing to serve as a reference.
    /// TypeID = 189003.
    /// </summary>
    No = 189003
}

/**
 * Rating values for job applicants, to be used when grading the applicants based upon the comments from their references.
 */
export enum ReferenceRating {
    NA = 263001,
    Poor = 263002,
    Fair = 263003,
    Good = 263004,
    Excellent = 263005,
    InvalidReference = 263006,
    UnresponsiveReference = 263007
}

export enum RefundPriority {
    /// <summary>
    /// TypeID = 190000
    /// </summary>
    ASAP = 190000,
    /// <summary>
    /// TypeID = 190001
    /// </summary>
    Urgent = 190001,
    /// <summary>
    /// TypeID = 190002
    /// </summary>
    Normal = 190002
}

export enum RefundStatus {
    /// <summary>
    /// TypeID = 192000
    /// </summary>
    Incomplete = 192000,
    /// <summary>
    /// TypeID = 192001
    /// </summary>
    AwaitingCheckNumber = 192001,
    /// <summary>
    /// TypeID = 192002
    /// </summary>
    Complete = 192002
}

export enum RefundType {
    /// <summary>
    /// TypeID = 191000
    /// </summary>
    SingleCreditCard = 191000,
    /// <summary>
    /// TypeID = 191001
    /// </summary>
    MultipleCreditCards = 191001,
    /// <summary>
    /// TypeID = 191002
    /// </summary>
    Check = 191002,
    /// <summary>
    /// TypeID = 191003
    /// </summary>
    CheckOverrideForCreditCards = 191003
}

export enum RegionRoleType {
    Manager = 31000
}

export enum RegistrationStatusType {
    Scheduled = 142000,
    Past = 142001,
    NotRegistered = 142002
}

export enum RegFlowProgressStep {
    ///// <summary>
    ///// StudentInformation = 342000
    ///// </summary>
    //StudentInformation = 342000,

    ///// <summary>
    ///// CoursesAndOptions = 342001
    ///// </summary>
    //CoursesAndOptions = 342001,

    ///// <summary>
    ///// TechRocketUpsell = 342002
    ///// </summary>
    //TechRocketUpsell = 342002,

    ///// <summary>
    ///// CustomerInformation = 342003
    ///// </summary>
    //CustomerInformation = 342003,

    ///// <summary>
    ///// OrderSummaryAndPayment = 342004,
    ///// </summary>
    //OrderSummaryAndPayment = 342004,

    /// <summary>
    /// AvailChart2017 = 342005,
    /// </summary>
    AvailChart2017 = 342005,

    /// <summary>
    /// ShoppingCart2017 = 342006,
    /// </summary>
    ShoppingCart2017 = 342006,

    /// <summary>
    /// OrderSummary2017 = 342007,
    /// </summary>
    OrderSummary2017 = 342007
}

/**
 *  Residency Option (TypeClass = 356)
 *  Used in LocationAttribute
 * */
export enum ResidencyOption {
    /// <summary>
    /// Day (TypeID = 356000)
    /// </summary>
    Day = 356000,

    /// <summary>
    /// Overnight (TypeID = 356001)
    /// </summary>
    Overnight = 356001,

    /// <summary>
    /// DayAndOvernight (TypeID = 356002)
    /// </summary>
    DayAndOvernight = 356002
}

/**
 * List of reward programs.
 * <remarks>Used in the RewardDef table.</remarks>
 */
export enum RewardProgramType {
    ReferAFriend = 128000,

    ReferAFriendForHire = 128001
}

/**
 * Defines the method by which the reward will be issued.
 * <remarks>Used in the RewardDef table.</remarks>
 */
export enum RewardType {
    CreditToAccount = 129000,
    GiftCard = 129001
}

export enum RelativeRelationType {
    Before = 38000,
    After = 38001
}

export enum RelativeToItemType {
    StartOfEachSession = 39000,
    StartOfTerm = 39001,
    EndOfEachSession = 39002,
    EndOfTerm = 39003,

    /// <summary>
    /// Start Date of Job assignment.
    /// TypeID = 39006
    /// </summary>
    StartOfAssignment = 39006,

    /// <summary>
    /// End of Term Staff (job or pay item) assignment.
    /// TypeID = 39007
    /// </summary>
    EndOfAssignment = 39007
}

/**
 * used as parent types to group RelativeToItemType
 */
export enum RelativeToItemGroupingType {
    /// <summary>
    /// Term RelativeToItem parent type
    /// TypeID = 280000
    /// </summary>
    Term = 280000,

    /// <summary>
    /// TermGroup RelativeToItem parent type.
    /// TypeID = 280001
    /// </summary>
    TermGroup = 280001
}

export enum ReleaseStateType {
    /// <summary>
    /// Released
    /// </summary>
    Released = 20000,
    /// <summary>
    /// Pending
    /// </summary>
    Pending = 20001,
    /// <summary>
    /// Obsolete
    /// </summary>
    Obsolete = 20002
}

export enum RoleCategory {
    /// <summary>
    /// TypeID = 43000
    /// </summary>
    CompanyRoles = 43000,
    /// <summary>
    /// TypeID = 43001
    /// </summary>
    DivisionRoles = 43001,
    /// <summary>
    /// TypeID = 43002
    /// </summary>
    SystemRoles = 43002
}

export enum RoomGender {
    /// <summary>
    /// Male (TypeID = 355000)
    /// </summary>
    Male = 355000,

    /// <summary>
    /// Female (TypeID = 355001)
    /// </summary>
    Female = 355001,

    /// <summary>
    /// All (TypeID = 355002)
    /// </summary>
    All = 355002
}

export enum RoomOccupant {
    /// <summary>
    /// Student (TypeID = 354000)
    /// </summary>
    Student = 354000,

    /// <summary>
    /// Staff (TypeID = 354001)
    /// </summary>
    Staff = 354001,

    /// <summary>
    /// All (TypeID = 354002)
    /// </summary>
    All = 354002
}

export enum SalesCatalogType {
    /// <summary>
    /// Standard Camp
    /// </summary>
    StandardCamp = 343000,
    /// <summary>
    /// At School Multi-Week
    /// </summary>
    AtSchoolMultiWeek = 343001,
    /// <summary>
    /// At School One Day
    /// </summary>
    AtSchoolOneDay = 343002,
    /// <summary>
    /// Merchandise
    /// </summary>
    Merchandise = 343003
}

export enum SavableSearchType {
    /// <summary>
    /// TypeID = 234000
    /// </summary>
    TermStaffApplicationSearch = 234000
}

export enum SavableSearchCriteriaType {
    /// <summary>
    /// TypeID = 235000
    /// </summary>
    TermGroup = 235000,

    /// <summary>
    /// TypeID = 235001
    /// </summary>
    Division = 235001,

    /// <summary>
    /// TypeID = 235002
    /// </summary>
    ClaimedByRM = 235002,

    /// <summary>
    /// TypeID = 235003
    /// </summary>
    Region = 235003,

    /// <summary>
    /// TypeID = 235004
    /// </summary>
    Location = 235004,

    /// <summary>
    /// TypeID = 235005
    /// </summary>
    JobTitle = 235005,

    /// <summary>
    /// TypeID = 235006
    /// </summary>
    ApplicationStatus = 235006,

    /// <summary>
    /// TypeID = 235007
    /// </summary>
    FirstName = 235007,

    /// <summary>
    /// TypeID = 235008
    /// </summary>
    LastName = 235008,

    /// <summary>
    /// TypeID = 235009
    /// </summary>
    PreferredName = 235009,

    /// <summary>
    /// TypeID = 235010
    /// </summary>
    Email = 235010,

    /// <summary>
    /// TypeID = 235011
    /// </summary>
    AdvancedSearchOption = 235011,

    /// <summary>
    /// TypeID = 235012
    /// </summary>
    QualifyByJobTitle = 235012,

    /// <summary>
    /// TypeID = 235013
    /// </summary>
    QualifyByCourse = 235013,

    /// <summary>
    /// TypeID = 235014
    /// </summary>
    IsQualifyByAvgScore = 235014,

    /// <summary>
    /// TypeID = 235015
    /// </summary>
    IsQualifyByTotalScore = 235015,

    /// <summary>
    /// TypeID = 235016
    /// </summary>
    QualifyByAvgScore = 235016,

    /// <summary>
    /// TypeID = 235017
    /// </summary>
    QualifyByTotalScore = 235017,

    /// <summary>
    /// TypeID = 235018
    /// </summary>
    Skill = 235018,

    /// <summary>
    /// TypeID = 235019
    /// </summary>
    IsQualifyBySkillAvgScore = 235019,

    /// <summary>
    /// TypeID = 235020
    /// </summary>
    IsQualifyBySkillTotalScore = 235020,

    /// <summary>
    /// TypeID = 235021
    /// </summary>
    QualifyBySkillAvgScore = 235021,

    /// <summary>
    /// TypeID = 235022
    /// </summary>
    QualifyBySkillTotalScore = 235022,

    /// <summary>
    /// TypeID = 235023
    /// </summary>
    IsShowExcluded = 235023,

    /// <summary>
    /// TypeID = 235024
    /// </summary>
    ApplicationStatusForSearch = 235024,

    /// <summary>
    /// TypeID = 235025
    /// </summary>
    CanCommute = 235025,

    /// <summary>
    /// TypeID = 235026
    /// </summary>
    CanTravel = 235026,

    /// <summary>
    /// TypeID = 235027
    /// </summary>
    ShowAppProcessStatuses = 235027,

    /// <summary>
    /// TypeID = 235028
    /// </summary>
    LocationStateTypeID = 235028,

    /// <summary>
    /// TypeID = 235029
    /// </summary>
    LocationCity = 235029,

    /// <summary>
    /// TypeID = 235030
    /// </summary>
    LocationsNearby = 235030,

    /// <summary>
    /// TypeID = 235031
    /// </summary>
    MinimumDegree = 235031,

    /// <summary>
    /// TypeID = 235032
    /// </summary>
    IncludeDegreeInProgress = 235032
}

export enum ScheduleDefType {
    Course = 51000,
    Meal = 51001,
    Residency = 51002
}

export enum ScheduleDetailType {
    AllDays = 79000,
    SingleDay = 79001
}

export enum SchoolDegreeType {
    HighSchoolDiploma = 231000,

    BSBA = 231001,

    Masters = 231002,

    PHD = 231003,

    Associates = 231004
}

export enum SectionType {
    Single = 19000,
    Combo = 19001
}

/**
 * Allows classification of security questions for different functions.
 */
export enum SecurityQuestionType {
    /// <summary>
    /// Questions for user accounts for internal and public users.
    /// TypeID = 186000.
    /// </summary>
    UserAccount = 186000
}

/**
 * The status of the session availability shown in the Availability Chart.
 */
export enum SessionAvailabilityStatus {
    /// <summary>
    /// TypeID = 152000
    /// </summary>
    Open = 152000,

    /// <summary>
    /// TypeID = 152001
    /// </summary>
    AlmostFull = 152001,

    /// <summary>
    /// TypeID = 152002
    /// </summary>
    NoSpace = 152002,

    /// <summary>
    /// TypeID = 152003
    /// </summary>
    NA = 152003,

    /// <summary>
    /// TypeID = 152004
    /// </summary>
    Coming = 152004,

    /// <summary>
    /// TypeID = 152005
    /// </summary>
    Closed = 152005,

    /// <summary>
    /// TypeID = 152006
    /// </summary>
    CallUs = 152006,

    /// <summary>
    /// TypeID = 152007
    /// </summary>
    SoldOut = 152007,

    /// <summary>
    /// TypeID = 152008
    /// </summary>
    Space1 = 152008,

    /// <summary>
    /// TypeID = 152009
    /// </summary>
    Space2 = 152009,

    /// <summary>
    /// TypeID = 152010
    /// </summary>
    Space3 = 152010,

    /// <summary>
    /// TypeID = 152011
    /// </summary>
    NotOffered = 152011,

    /// <summary>
    /// This selection is not offered. Please choose a different course, session or location.
    /// TypeID = 152012
    /// </summary>
    SelectAnotherWeek = 152012,

    /// <summary>
    /// This section is sold out. Please choose a different course, session, or location.
    /// TypeID = 152013
    /// </summary>
    SoldOutDesktop = 152013,

    /// <summary>
    /// TypeID = 152014
    /// </summary>
    Space4 = 152014
}

export enum ShippingOptionType {
    CampinaBoxShipment = 284000,
    FedExDeliveriesforStaffPaychecks = 284001,
    ComputersUnloadingLoading = 284002,
    FedExDeliveriesforComputers = 284003,
    USPSCarePackagesLettersFromHome = 284004
}

/**
 * Shirt/T-Shirt Sizes. TypeClassID = 84.
 * Used in: Users.TeeShirtSizeID.
 */
export enum ShirtSizeType {
    /// <summary>
    /// TypeID = 84000.
    /// </summary>
    MenXXS = 84000,
    /// <summary>
    /// TypeID = 84001.
    /// </summary>
    MenXS = 84001,
    /// <summary>
    /// TypeID = 84002.
    /// </summary>
    MenS = 84002,
    /// <summary>
    /// TypeID = 84003.
    /// </summary>
    MenM = 84003,
    /// <summary>
    /// TypeID = 84004.
    /// </summary>
    MenL = 84004,
    /// <summary>
    /// TypeID = 84005.
    /// </summary>
    MenXL = 84005,
    /// <summary>
    /// TypeID = 84006.
    /// </summary>
    Men2XL = 84006,
    /// <summary>
    /// TypeID = 84007.
    /// </summary>
    Men3XL = 84007,
    /// <summary>
    /// TypeID = 84008.
    /// </summary>
    WomenXXS = 84008,
    /// <summary>
    /// TypeID = 84009.
    /// </summary>
    WomenXS = 84009,
    /// <summary>
    /// TypeID = 84010.
    /// </summary>
    WomenS = 84010,
    /// <summary>
    /// TypeID = 84011.
    /// </summary>
    WomenM = 84011,
    /// <summary>
    /// TypeID = 84012.
    /// </summary>
    WomenL = 84012,
    /// <summary>
    /// TypeID = 84013.
    /// </summary>
    WomenXL = 84013,
    /// <summary>
    /// TypeID = 84014.
    /// </summary>
    Women2XL = 84014,
    /// <summary>
    /// TypeID = 84016.
    /// </summary>
    AdultXXS = 84016,
    /// <summary>
    /// TypeID = 84017.
    /// </summary>
    YouthS = 84017,
    /// <summary>
    /// TypeID = 84018.
    /// </summary>
    YouthL = 84018,
    /// <summary>
    /// TypeID = 84019.
    /// </summary>
    Adult3XL = 84019,
    /// <summary>
    /// TypeID = 84020.
    /// </summary>
    Adult4XL = 84020
}

export enum ShirtSizeGroupType {
    /// <summary>
    /// TypeID = 296000
    /// </summary>
    Student = 296000,
    /// <summary>
    /// TypeID = 296000
    /// </summary>
    Staff = 296001
}

/**
 * Used in: UserBrowsing.CartTypeID
 * */
export enum ShoppingCartType {
    /// <summary>
    /// TypeID = 348000.
    /// </summary>
    Abandonment = 348000,
    /// <summary>
    /// TypeID = 348001.
    /// </summary>
    RegFlow = 348001,
    /// <summary>
    /// TypeID = 348002.
    /// </summary>
    ChangeOrder_Location = 348002,
    /// <summary>
    /// TypeID = 348003.
    /// </summary>
    ChangeOrder_SessionDate = 348003,
    /// <summary>
    /// TypeID = 348004.
    /// </summary>
    ChangeOrder_Course = 348004,
    /// <summary>
    /// TypeID = 348005.
    /// </summary>
    ChangeOrder_OptionsOnly = 348005,
    /// <summary>
    /// TypeID = 348006.
    /// </summary>
    ChangeOrder_From = 348006
}

/**
 * Used in: Skill.SkillTypeID.
 */
export enum SkillType {
    /// <summary>
    /// TypeID = 281000
    /// </summary>
    Staff = 281000,

    /// <summary>
    /// TypeID = 281001
    /// </summary>
    Student = 281001,

    /// <summary>
    /// Student Skill Level.
    /// TypeID = 281002
    /// </summary>
    StudentLevel = 281002,

    /// <summary>
    /// TypeID = 281003
    /// </summary>
    Transcript = 281003
}

export enum SqlAgentTaskType {
    /// <summary>
    /// TypeID = 144000
    /// </summary>
    PopulateDiscountSessionDataForSession = 144000,
    /// <summary>
    /// TypeID = 144001
    /// </summary>
    PushSessionProductToKermit = 144001,
    /// <summary>
    /// TypeID = 144002
    /// </summary>
    PopulateDiscountSessionDataForDiscount = 144002,
    /// <summary>
    /// TypeID = 144003
    /// </summary>
    UpdateCalculatedMinAndMaxAges = 144003,
    /// <summary>
    /// TypeID = 144004
    /// </summary>
    UpdateCalculatedMaxAges = 144004,
    /// <summary>
    /// TypeID = 144005
    /// </summary>
    UpdateCalculatedMinAges = 144005,
    /// <summary>
    /// TypeID = 144006
    /// </summary>
    UpdateUserFormDueDates = 144006,
    /// <summary>
    /// TypeID = 144007
    /// </summary>
    StaffTaskPopulation = 144007
}

export enum StaffAssignmentPubStatus {
    /// <summary>
    /// TypeID = 265000
    /// </summary>
    Unpublished = 265000,
    /// <summary>
    /// TypeID = 265001
    /// </summary>
    Published = 265001,
    /// <summary>
    /// TypeID = 265002
    /// </summary>
    Cancelled = 265002
}

export enum StaffAssignmentType {
    /// <summary>
    /// TypeID = 266000
    /// </summary>
    CourseTeachingJob = 266000,
    /// <summary>
    /// TypeID = 266001
    /// </summary>
    CampManagementJob = 266001,
    /// <summary>
    /// TypeID = 266002
    /// </summary>
    NonJobPayItems = 266002
}

export enum StaffTaskDisplayType {
    /// <summary>
    /// TypeID = 306000
    /// </summary>
    BeforeCamp = 306000,

    /// <summary>
    /// TypeID = 306001
    /// </summary>
    SampleSetup = 306001,

    /// <summary>
    /// TypeID = 306002
    /// </summary>
    SampleIDTech = 306002,

    /// <summary>
    /// TypeID = 306003
    /// </summary>
    SampleAcademy = 306003,

    /// <summary>
    /// TypeID = 306004
    /// </summary>
    SampleOrientation = 306004,

    /// <summary>
    /// TypeID = 306005
    /// </summary>
    SampleMini = 306005,

    /// <summary>
    /// TypeID = 306006
    /// </summary>
    SampleAlexaCafe = 306006
}

export enum StaffTaskUserStatusType {
    /// <summary>
    /// TypeID = 305000
    /// </summary>
    Incomplete = 305000,

    /// <summary>
    /// TypeID = 305001
    /// </summary>
    Complete = 305001
}

export enum StatementViewTimePeriodType {
    /// <summary>
    /// TypeID = 175000
    /// </summary>
    ViewByCalendarYear = 175000,
    /// <summary>
    /// TypeID = 175001
    /// </summary>
    ViewCompleteTransactionHistory = 175001,
    /// <summary>
    /// TypeID = 175002
    /// </summary>
    ViewByTransactionDate = 175002
}

export enum StatementViewTransactionsType {
    /// <summary>
    /// TypeID = 174000
    /// </summary>
    TransactionsForPrimaryCustomer = 174000,
    /// <summary>
    /// TypeID = 174001
    /// </summary>
    TransactionsForParentAndOrGuardian = 174001
}

export enum StateSubRegion {
    /// <summary>
    /// TypeID = 324000
    /// </summary>
    Northern = 324000,
    /// <summary>
    /// TypeID = 324001
    /// </summary>
    Southern = 324001
}

export enum SuffixType {
    /// <summary>
    /// Junior. TypeID = 85000.
    /// </summary>
    Jr = 85000,
    /// <summary>
    /// Senior. TypeID = 85001.
    /// </summary>
    Sr = 85001
}

export enum SupplyItemClass {
    /// <summary>
    /// Inventory Item (TypeID = 361000)
    /// </summary>
    InventoryItem = 361000,

    /// <summary>
    /// Serializable Item (TypeID = 361001)
    /// </summary>
    SerializableItem = 361001,

    /// <summary>
    /// Container (TypeID = 361002)
    /// </summary>
    Container = 361002
}

export enum SurveyAnswerCommentDispType {
    /// <summary>
    /// None. TypeID = 210000.
    /// </summary>
    None = 210000,
    /// <summary>
    /// Available When Selected. TypeID = 210001.
    /// </summary>
    AvailableWhenSelected = 210001,
    /// <summary>
    /// Always. TypeID = 210002.
    /// </summary>
    Always = 210002
}

export enum SurveyAnswerDataType {
    /// <summary>
    /// Text. TypeID = 209000.
    /// </summary>
    Text = 209000,
    /// <summary>
    /// Date. TypeID = 209001.
    /// </summary>
    Date = 209001,
    /// <summary>
    /// Number. TypeID = 209002.
    /// </summary>
    Number = 209002
}

export enum SurveyAnswerFormatType {
    /// <summary>
    /// Radio Button. TypeID = 208000.
    /// </summary>
    RadioButton = 208000,
    /// <summary>
    /// Check Box - Mid-Session TypeID = 208001.
    /// </summary>
    CheckBox = 208001,
    /// <summary>
    /// Text - Single Line TypeID = 208002.
    /// </summary>
    TextSingleLine = 208002,
    /// <summary>
    /// Text - Multi-line TypeID = 208003.
    /// </summary>
    TextMultiline = 208003,
    /// <summary>
    /// Date TypeID = 208004.
    /// </summary>
    Date = 208004,
    /// <summary>
    /// Single Select Dropdown TypeID = 208005.
    /// </summary>
    SingleSelectDropdown = 208005
}

export enum SurveyStatisticsAnswerType {
    /// <summary>
    /// Sentiment - Satisfied: TypeID = 215000
    /// </summary>
    Satisfied = 215000,
    /// <summary>
    /// Sentiment - NotSatisfied: TypeID = 215001
    /// </summary>
    NotSatisfied = 215001,
    /// <summary>
    /// Sentiment - NeutralorNotApplicable: TypeID = 215002
    /// </summary>
    NeutralorNotApplicable = 215002,
    ////// <summary>
    /// Sentiment - Yes: TypeID = 215003
    /// </summary>
    Yes = 215003,
    ////// <summary>
    /// Sentiment - No: TypeID = 215004
    /// </summary>
    No = 215004,
    /// <summary>
    /// Sentiment - NotSure: TypeID = 215005
    /// </summary>
    NotSure = 215005,
    ////// <summary>
    /// Sentiment - Positive: TypeID = 215006
    /// </summary>
    Positive = 215006,
    /// <summary>
    /// Sentiment - Negative: TypeID = 215007
    /// </summary>
    Negative = 215007,
    /// <summary>
    /// Sentiment - Neutral: TypeID = 215008
    /// </summary>
    Neutral = 215008
}

export enum SurveyStatisticsQuestionType {
    /// <summary>
    /// Satisfaction: TypeID = 216000
    /// </summary>
    Satisfaction = 216000,
    /// <summary>
    /// Will Return: TypeID = 216001
    /// </summary>
    WillReturn = 216001,
    /// <summary>
    /// Staff Above and Beyond: TypeID = 216002
    /// </summary>
    StaffAboveBeyond = 216002,
    /// <summary>
    /// Staff Review - Quality of Instruction: TypeID = 216003
    /// </summary>
    StaffReview_QualityOfInstruction = 216003,
    /// <summary>
    /// Staff Review - Supervision, Rapport with Students: TypeID = 216004
    /// </summary>
    StaffReview_SupervisionRapportWithStudents = 216004,
    /// <summary>
    /// Staff Review - Maturity, Flexibility, Team Rapport: TypeID = 216005
    /// </summary>
    StaffReview_MaturityFlexibilityTeamRapport = 216005,
    /// <summary>
    /// Staff Review - Promotion, Rehire: TypeID = 216007
    /// </summary>
    StaffReview_PromotionRehire = 216007,
    /// <summary>
    /// Director Rvw - Quality of Organization: TypeID = 216008
    /// </summary>
    DirectorReview_QualityOfOrganization = 216008,
    /// <summary>
    /// Director Rvw - Maturity, Stress Mgt, Team Repport: TypeID = 216009
    /// </summary>
    DirectorReview_MaturityStressMgtTeamRepport = 216009,
    /// <summary>
    /// Director Rvw - Supervision, Rapport with Students: TypeID = 216010
    /// </summary>
    DirectorReview_SupervisionRapportWithStudents = 216010,
    /// <summary>
    /// Director Rvw - Rehire: TypeID = 216011
    /// </summary>
    DirectorReview_Rehire = 216011,
    /// <summary>
    /// Sentiment: TypeID = 216012
    /// </summary>
    Sentiment = 216012,
    /// <summary>
    /// RM Review - Quality of Duties: TypeID = 216013
    /// </summary>
    RMReview_QualityOfDuties = 216013,
    /// <summary>
    /// RM Review - Maturity, Flexibility, Team Rapport, Stress Management: TypeID = 216014
    /// </summary>
    RMReview_MaturityFlexibilityTeamRapportStressMgmt = 216014,
    /// <summary>
    /// RM Review - Supervision, Rapport with Students: TypeID = 216015
    /// </summary>
    RMReview_SupervisionRapportWithStudents = 216015,
    /// <summary>
    /// RM Review - Rehire: TypeID = 216016
    /// </summary>
    RMReview_Rehire = 216016
}

/**
 * Bit masking flags used for tagging SurveyReponse
 * <remarks>This enum does not use the TypeIDs in the Type table.  Values are set to bit masks.</remarks>
 */
export enum SurveyTagTypeMask {
    None = 0x0,

    /// <summary>
    /// Flag = 0x1. Bit pos 1. Corporate Employee
    /// </summary>
    PositiveQuote = 0x1,
    ///// <summary>
    ///// Flag = 0x2. Bit pos 2. Employee of Partner corporation
    ///// </summary>
    //RedFlag = 0x2,

    All = 0xffff
}

export enum SurveyType {
    /// <summary>
    /// Participant Evaluation. TypeID = 207000.
    /// </summary>
    ParticipantEvaluation = 207000,
    /// <summary>
    /// Participant Evaluation - Mid-Session = 207001.
    /// </summary>
    ParticipantEvaluationMidSession = 207001,
    /// <summary>
    /// Family Showcase Evaluation = 207002.
    /// </summary>
    FamilyShowcaseEvaluation = 207002,
    /// <summary>
    /// Camp Setup Evaluation = 207003.
    /// </summary>
    CampSetupEvaluation = 207003,
    /// <summary>
    /// Periodic Camp Evaluation - Non-Director = 207004.
    /// </summary>
    PeriodicCampEvaluationNonDirector = 207004,
    /// <summary>
    /// Performance Review Of Instructors Mid Season = 207005.
    /// </summary>
    PerformanceReviewMidSeason = 207005,
    /// <summary>
    /// Parent Evaluation of Program = 207006.
    /// </summary>
    ParentEvaluationOfProgram = 207006,
    /// <summary>
    /// Instructor Evaluation of Director/Asst. Director = 207007.
    /// </summary>
    InstructorEvaluationOfDirectorAsstDirector = 207007,
    /// <summary>
    /// Performance Review Of Instructors End of Season = 207008.
    /// </summary>
    PerformanceReviewEndSeason = 207008,
    /// <summary>
    /// Periodic Camp Evaluation - MgmtStaff = 207009.
    /// </summary>
    PeriodicCampEvaluationMgmtStaff = 207009,
    /// <summary>
    /// Curriculum Evaluation = 207010.
    /// </summary>
    CurriculumEvaluation = 207010,
    /// <summary>
    /// Company Evaluation - Non-Director = 207011.
    /// </summary>
    CompanyEvaluationNonDirector = 207011,
    /// <summary>
    /// Company Evaluation - Director = 207012.
    /// </summary>
    CompanyEvaluationDirector = 207012,

    /// <summary>
    /// Questionnaire completed by references supplied by Term staff job applicants = 207013.
    /// </summary>
    TermStaffReferenceQuestionnaire = 207013,

    /// <summary>
    /// Questionnaire to be completed for a job applicant if the reference is a co-worker or supervisor = 207014.
    /// </summary>
    TermStaffReferenceQuestionnaireSupCoworker = 207014,

    /// <summary>
    /// RM Evaluation of Director/Asst. Director = 207015.
    /// </summary>
    RMEvaluationOfDirectorAsstDirector = 207015,

    /// <summary>
    /// RM Evaluation of Instructor = 207016.
    /// </summary>
    RMEvaluationOfInstructor = 207016,

    /// <summary>
    /// RM Evaluation of Health & Safety Coordinator = 207017.
    /// </summary>
    RMEvaluationOfHealthSafetyCoordinator = 207017,

    /// <summary>
    /// RM Evaluation of Activities Coordinator = 207018.
    /// </summary>
    RMEvaluationOfActivitiesCoordinator = 207018,

    /// <summary>
    /// Tuition Assistance Program = 207019.
    /// </summary>
    TuitionAssistanceProgram = 207019
}

export enum SupplyRequestStatusType {
    /// <summary>
    /// Supply Request Status TypeID = 213000.
    /// NOTE: No longer use this type.
    /// </summary>
    Draft = 213000,
    /// <summary>
    /// Supply Request Status TypeID = 213001.
    /// </summary>
    //Open = 213001, Renamed
    Submitted = 213001,
    /// <summary>
    /// Supply Request Status TypeID = 213002.
    /// </summary>
    //Closed = 213002, Nenamed
    Fulfilled = 213002
}

export enum SupplyCategoryType {
    /// <summary>
    /// Supply Category TypeID = 214000.
    /// </summary>
    GeneralSupplies = 214000,
    /// <summary>
    /// Supply Category TypeID = 214001.
    /// </summary>
    ElectronicEquipment = 214001
}

/**
 * Defines the type of the Terms and Conditions record.
 *  <see cref="TypeClassType.TermsAndConditionsType"/>
 */
export enum TermsAndConditionsType {
    /// <summary>
    /// TypeID = 106000
    /// </summary>
    CarpoolProgram = 106000,
    /// <summary>
    /// TypeID = 106001
    /// </summary>
    General = 106001,
    /// <summary>
    /// TypeID = 106002
    /// </summary>
    ReferAFriendProgram = 106002
}

/**
 * Defines the type of Term Group Status.
 */
export enum TermGroupStatusType {
    /// <summary>
    /// TypeID = 206000
    /// </summary>
    Current = 206000,
    /// <summary>
    /// TypeID = 206001
    /// </summary>
    Pending = 206001,
    /// <summary>
    /// TypeID = 206002
    /// </summary>
    Closed = 206002
}

export enum TermThresholdCapacityManagementAlertType {
    SessionSoldOut = 36000,
    CourseNoDemand = 36001,
    CourseLowDemand = 36002,
    CourseSoldOut = 36003,
    SectionNoDemand = 36004,
    SectionLowDemand = 36005,
    OvernightNoDemand = 36006,
    OvernightLowDemand = 36007,
    WeekendNoDemand = 36008,
    WeekendLowDemand = 36009
}

export enum TermThresholdCategoryType {
    ImportantDate = 75000,
    CapacityManagementAlert = 75001,
    PaymentOption = 75002
}

export enum TermThresholdDataCapacityType {
    /// <summary>
    /// DateOnly
    /// </summary>
    DateOnly = 34000,
    /// <summary>
    /// DateRange
    /// </summary>
    DateRange = 34001,
    /// <summary>
    /// LimitValueOnly
    /// </summary>
    LimitValueOnly = 34002,
    /// <summary>
    /// LimitValuePlusDate
    /// </summary>
    LimitValuePlusDate = 34003,
    /// <summary>
    /// LimitValuePlusDateRange
    /// </summary>
    LimitValuePlusDateRange = 34004
}

export enum TermThresholdImportantDateType {
    /// <summary>
    /// TypeID = 35000.
    /// </summary>
    PublicRegistrationOpen = 35000,

    /// <summary>
    /// TypeID = 35001.
    /// </summary>
    MyAccountAddSessionOpen = 35001,

    /// <summary>
    /// TypeID = 35002.
    /// </summary>
    MyAccountChangeSessionOpen = 35002,

    /// <summary>
    /// TypeID = 35003.
    /// </summary>
    CSRegistrationOpen = 35003,

    /// <summary>
    /// TypeID = 35004.
    /// </summary>
    CSAddSessionOpen = 35004,

    /// <summary>
    /// TypeID = 35005.
    /// </summary>
    CSChangeSessionOpen = 35005,

    /// <summary>
    /// TypeID = 35006.
    /// </summary>
    // Re: 6947
    //CatalogsNotAvailable = 35006,

    /// <summary>
    /// Previous Interactive Digital Catalog Available Online.
    /// TypeID = 35007.
    /// </summary>
    // Re: 6947
    //PreviousInteractiveDigitalCatalogAvailableOnline = 35007,

    /// <summary>
    /// Previous PDF Catalog Available Online.
    /// TypeID = 35008.
    /// </summary>
    // Re: 6947
    //PreviousPDFCatalogAvailableOnline = 35008,

    /// <summary>
    /// Previous Printed Catalogs Available.
    /// TypeID = 35009.
    /// </summary>
    // Re: 6947
    //PreviousPrintedCatalogsAvailable = 35009,

    /// <summary>
    /// Current Interactive Digital Catalog Available Online.
    /// TypeID = 35010.
    /// </summary>
    // Re: 6947
    //CurrentInteractiveDigitalCatalogAvailableOnline = 35010,

    /// <summary>
    /// Current PDF Catalog Available Online.
    /// TypeID = 35011.
    /// </summary>
    // Re: 6947
    //CurrentPDFCatalogAvailableOnline = 35011,

    /// <summary>
    /// Current Printed Catalogs Available.
    /// TypeID = 35012.
    /// </summary>
    // Re: 6947
    //CurrentPrintedCatalogsAvailable = 35012,

    /// <summary>
    /// TypeID = 35013.
    /// </summary>
    RequiredFormsDueDate = 35013,

    /// <summary>
    /// TypeID = 35014.
    /// </summary>
    FormsAvailableDate = 35014,

    /// <summary>
    /// TypeID = 35021.
    /// </summary>
    CEUFormViewable = 35021,

    /// <summary>
    /// TypeID = 35022.
    /// </summary>
    CEUFormEditable = 35022,

    /// <summary>
    /// TypeID = 35023.
    /// </summary>
    MapsOpen = 35023,

    /// <summary>
    /// TypeID = 35024.
    /// </summary>
    DirectorCellPhoneAvailable = 35024,

    /// <summary>
    /// TypeID = 35025.
    /// </summary>
    AdminChangeFeeChargedTimePeriod = 35025,

    /// <summary>
    /// TypeID = 35026.
    /// </summary>
    BalanceDueDate = 35026,

    /// <summary>
    /// TypeID = 35027.
    /// </summary>
    LateBalanceDueDate = 35027,

    /// <summary>
    /// TypeID = 35028.
    /// </summary>
    TermStaffApplicationAvailable = 35028,

    /// <summary>
    /// TypeID = 35029.
    /// </summary>
    TuitionAssistancePublicOpen = 35029,

    /// <summary>
    /// TypeID = 35030.
    /// </summary>
    AdditionalFormsOpen = 35030,

    /// <summary>
    /// TypeID = 35031.
    /// </summary>
    AdditionalFormsDueDate = 35031,

    /// <summary>
    /// TypeID = 35032.
    /// </summary>
    AdditionalFormsLateDueDate = 35032,

    /// <summary>
    /// TypeID = 35033.
    /// </summary>
    BalanceDueReminderEmailSent = 35033,

    /// <summary>
    /// TypeID = 35034.
    /// </summary>
    BalanceOverdueEmailSent1 = 35034,

    /// <summary>
    /// TypeID = 35035.
    /// </summary>
    BalanceOverdueEmailSent2 = 35035,

    /// <summary>
    /// TypeID = 35036.
    /// </summary>
    BalanceOverdueEmailSent3 = 35036,

    /// <summary>
    /// TypeID = 35037.
    /// </summary>
    BalanceOverdueEmailSent4 = 35037,

    /// <summary>
    /// TypeID = 35038.
    /// </summary>
    RequiredFormsReminderEmail1Sent = 35038,

    /// <summary>
    /// TypeID = 35039.
    /// </summary>
    RequiredFormReminderCalls1 = 35039,

    /// <summary>
    /// TypeID = 35040.
    /// </summary>
    RequiredFormReminderCalls2 = 35040,

    /// <summary>
    /// TypeID = 35041.
    /// </summary>
    PromotionReminderEmail = 35041,

    /// <summary>
    /// TypeID = 35042.
    /// </summary>
    CancellationRefundTuitionLessDeposit = 35042,

    /// <summary>
    /// TypeID = 35043.
    /// </summary>
    CreditsGivenForDowngrades = 35043,

    /// <summary>
    /// TypeID = 35044.
    /// </summary>
    FindOnlies = 35044,

    /// <summary>
    /// TypeID = 35047.
    /// </summary>
    MyAccountCancelSessionOpen = 35047,

    /// <summary>
    /// TypeID = 35048.
    /// </summary>
    CSCancelSessionOpen = 35048,

    /// <summary>
    /// TypeID = 35049.
    /// </summary>
    OverdueBalancesAutomaticallyCharged = 35049,

    /// <summary>
    /// Required online paperwork Due Date.
    /// TypeID = 35050.
    /// </summary>
    TermStaffREPDueDate = 35050,

    /// <summary>
    /// TypeID = 35051.
    /// </summary>
    TermStaffCertificationsDueDate = 35051,

    /// <summary>
    /// Location specific forms Due Date.
    /// TypeID = 35052.
    /// </summary>
    TermStaffARFDueDate = 35052,

    /// <summary>
    /// Applicant that accepted written offer later than this date is considered late hire.
    /// TypeID = 35053.
    /// </summary>
    TermStaffLateHire = 35053,

    /// <summary>
    /// The date range when location specific form download links are available.
    /// TypeID = 35054.
    /// </summary>
    TermStaffARFOpen = 35054,

    /// <summary>
    /// REP Payroll paperwork Due Date.
    /// TypeID = 35055.
    /// </summary>
    TermStaffPayrollPaperworkDueDate = 35055,

    /// <summary>
    /// Term Staff Training Open date.
    /// TypeID = 35056.
    /// </summary>
    TermStaffTrainingOpenDate = 35056,

    /// <summary>
    /// TypeID = 35057.
    /// </summary>
    TermStaffReferenceCheckEmailOpenDate = 35057,

    /// <summary>
    /// Number of days prior to assignment start date that term staff have access to student rosters and confidential data.
    /// TypeID = 35058
    /// </summary>
    TermStaffConfidentialDataOpen = 35058,

    /// <summary>
    /// Date after which published assignments appear on the My Account pages.
    /// TypeID = 35059
    /// </summary>
    TermStaffPublishWorkSchedule = 35059,

    /// <summary>
    /// Term Staff Tax StateID Auto Change Close date.
    /// TypeID = 35060
    /// </summary>
    TermStaffTaxStateIDAutoChangeClose = 35060,

    /// <summary>
    /// Term Staff Terminate Button Available date.
    /// TypeID = 35061
    /// </summary>
    TermStaffTerminateButtonAvailable = 35061,

    /// <summary>
    /// Term Staff Corner Available date.
    /// TypeID = 35062
    /// </summary>
    TermStaffCornerAvailable = 35062,

    /// <summary>
    /// Term Staff View My Emails Available date.
    /// TypeID = 35063
    /// </summary>
    TermStaffViewMyEmailsAvailable = 35063,

    /// <summary>
    /// Term group level Catalog Email Important Date.
    /// TypeID = 35064
    /// </summary>
    CatalogEmail = 35064,

    /// <summary>
    /// Term Group level Catalog Mail important date.
    /// TypeID = 35065
    /// </summary>
    CatalogMail = 35065,

    /// <summary>
    /// Term Staff Employee Handbook & REP Available date.
    /// TypeID = 35066
    /// </summary>
    TermStaffEHAndREPAvailable = 35066,

    /// <summary>
    /// Tuition Assistance Program CS Open
    /// TypeID = 35067.
    /// </summary>
    TuitionAssistanceCSOpen = 35067,

    /// <summary>
    /// iD Tech VIP Early Access Pass Open for purchase
    /// TypeID = 35067.
    /// </summary>
    VIPEarlyAccessPassOpen = 35068
}

export enum TermThresholdPaymentOptionType {
    /// <summary>
    /// TypeID = 37000
    /// </summary>
    PublicRegistrationFullPayment = 37000,
    /// <summary>
    /// TypeID = 37001
    /// </summary>
    PublicRegistrationDepositPayment = 37001,
    /// <summary>
    /// TypeID = 37002
    /// </summary>
    PublicRegistrationDepositPlusAdditionalPayment = 37002,
    /// <summary>
    /// TypeID = 37003
    /// </summary>
    MyAccountAddSessionFullPayment = 37003,
    /// <summary>
    /// TypeID = 37004
    /// </summary>
    MyAccountAddSessionDepositPayment = 37004,
    /// <summary>
    /// TypeID = 37005
    /// </summary>
    MyAccountAddSessionDepositPlusAdditionalPayment = 37005,
    /// <summary>
    /// TypeID = 37006
    /// </summary>
    CSRegistrationFullPayment = 37006,
    /// <summary>
    /// TypeID = 37007
    /// </summary>
    CSRegistrationDepositPayment = 37007,
    /// <summary>
    /// TypeID = 37008
    /// </summary>
    CSRegistrationDepositPlusAdditionalPayment = 37008,
    /// <summary>
    /// TypeID = 37009
    /// </summary>
    CSAddSessionFullPayment = 37009,
    /// <summary>
    /// TypeID = 37010
    /// </summary>
    CSAddSessionDepositPayment = 37010,
    /// <summary>
    /// TypeID = 37011
    /// </summary>
    CSAddSessionDepositPlusAdditionalPayment = 37011,
    /// <summary>
    /// TypeID = 37012
    /// </summary>
    CSChangeSessionFullPayment = 37012,
    /// <summary>
    /// TypeID = 37013
    /// </summary>
    CSChangeSessionDepositPlusAdditionalPayment = 37013,
    /// <summary>
    /// TypeID = 37014
    /// </summary>
    CSChangeSessionDepositPayment = 37014
}

/**
 * Used as part of the type structure to seperate term threshold important dates types into "Term" and "Term Group".
 */
export enum ThresholdType {
    /// <summary>
    /// Used for Term important dates.
    /// TypeID = 255000.
    /// </summary>
    Term = 255000,

    /// <summary>
    /// Used for Term Group important dates.
    /// TypeID = 255001.
    /// </summary>
    TermGroup = 255001
}

export enum TimeZoneType {
    Pacific = 32000,
    Mountain = 32001,
    Central = 32002,
    Eastern = 32003
}

export enum TokenUsageType {
    StaffCorner = 313000,
    GamePlan = 313001,
    iDTech365 = 313002,
    PulseSPA = 313003
}

export enum TuitionAssistanceLetterType {
    /// <summary>
    /// TypeID = 302000.
    /// </summary>
    Email_SubmissionConfirmationWithFile = 302000,

    /// <summary>
    /// TypeID = 302001.
    /// </summary>
    Email_SubmissionConfirmationWithoutFile = 302001,

    /// <summary>
    /// TypeID = 302002.
    /// </summary>
    Email_FinancialsMissing = 302002,

    /// <summary>
    /// TypeID = 302003.
    /// </summary>
    Email_FinancialsInvalid = 302003,

    /// <summary>
    /// TypeID = 302004.
    /// </summary>
    Email_ApplicationComplete = 302004,

    /// <summary>
    /// TypeID = 302005.
    /// </summary>
    Email_Declined = 302005,

    /// <summary>
    /// TypeID = 302006.
    /// </summary>
    Email_AppPreOpen = 302006,

    /// <summary>
    /// TypeID = 302007.
    /// </summary>
    Email_AppClosed = 302007
}

export enum TuitionAssistanceStatusType {
    /// <summary>
    /// TypeID = 300000.
    /// </summary>
    InReview = 300000,

    /// <summary>
    /// TypeID = 300001.
    /// </summary>
    FinancialMissing = 300001,

    /// <summary>
    /// TypeID = 300002.
    /// </summary>
    FinancialsInvalid = 300002,

    /// <summary>
    /// TypeID = 300003.
    /// </summary>
    Complete = 300003,

    /// <summary>
    /// TypeID = 300004.
    /// </summary>
    Approved = 300004,

    /// <summary>
    /// TypeID = 300005.
    /// </summary>
    Declined = 300005,

    /// <summary>
    /// TypeID = 300006.
    /// </summary>
    Invalid = 300006
}

export enum TuitionAssistanceSubStatusType {
    /// <summary>
    /// TypeID = 301000.
    /// </summary>
    FullTuitionMinusDeposit = 301000,

    /// <summary>
    /// TypeID = 301001.
    /// </summary>
    Discounted50Percent = 301001,

    /// <summary>
    /// TypeID = 301002.
    /// </summary>
    Discounted50Dollars = 301002,

    /// <summary>
    /// TypeID = 301003.
    /// </summary>
    AlreadyRegisteredForCurrentSession = 301003,

    /// <summary>
    /// TypeID = 301004.
    /// </summary>
    LackOfFinancialNeed = 301004,

    /// <summary>
    /// TypeID = 301005.
    /// </summary>
    LackOfInformationToConsider = 301005,

    /// <summary>
    /// TypeID = 301006.
    /// </summary>
    ApplicationIncomplete = 301006,

    /// <summary>
    /// TypeID = 301007.
    /// </summary>
    MultipleStudentsToConsider = 301007,

    /// <summary>
    /// TypeID = 301008.
    /// </summary>
    LateApplication = 301008
}

/**
 *	This is used internally by FAST:  Form and Status Tool
 *   It is not defined in the Type database table.
 */
export enum UploadedFormTypeFilter {
    StudentARFs = 10,
    StaffLSRP = 20
}

/**
 * Enumerates access restrictions like "Code Red."  Default is "None."
 */
export enum UserAccessRestrictionType {
    /// <summary>
    /// TypeID = 141000.
    /// </summary>
    None = 141000,

    /// <summary>
    /// TypeID = 141001.
    /// </summary>
    CodeRed = 141001,

    /// <summary>
    /// TypeID = 141002.
    /// </summary>
    Dissatisfied = 141002
}

/**
 * Values used to track user activity
 */
export enum UserAccountActivityType {
    /// <summary>
    /// PulseTypeID = 48000
    /// </summary>
    ChangePasswordEnterUserName = 48000,
    /// <summary>
    /// PulseTypeID = 48001
    /// </summary>
    ChangePasswordAnswerSecurityQuestion = 48001,
    /// <summary>
    /// PulseTypeID = 48002
    /// </summary>
    UnlockAccount = 48002,
    /// <summary>
    /// PulseTypeID = 48003
    /// </summary>
    ChangePassword = 48003,
    /// <summary>
    /// PulseTypeID = 48004
    /// </summary>
    LockAccount = 48004,
    /// <summary>
    /// PulseTypeID = 48005
    /// </summary>
    RequiredFormsReminderEmail = 48005,
    /// <summary>
    /// PulseTypeID = 48006
    /// </summary>
    WeekOutEmail = 48006,
    /// <summary>
    /// PulseTypeID = 48007
    /// </summary>
    Login = 48007,
    /// <summary>
    /// PulseTypeID = 48008
    /// </summary>
    Logout = 48008,
    /// <summary>
    /// PulseTypeID = 48009
    /// </summary>
    ChangeUserName = 48009,

    /// <summary>
    /// PulseTypeID = 48010
    /// </summary>
    ChangeDisplayName = 48010,

    /// <summary>
    /// Email sent to staff when REP important date range first opens.
    /// TypeID = 48011
    /// </summary>
    REPAvailableEmail = 48011,

    /// <summary>
    /// Email to remind staff to complete REP.
    /// TypeID = 48012
    /// </summary>
    REPReminderEmail = 48012
}

/**
 * Status of the user activity.
 * Used in the UserAccountActivity table.
 */
export enum UserActivityStatusCode {
    /// <summary>
    /// TypeID = 145000
    /// </summary>
    Success = 145000,

    /// <summary>
    /// TypeID = 145001
    /// </summary>
    Failure = 145001
}

/**
 * Defines the purpose of the record in the UserConfirmation table.
 */
export enum UserConfirmationType {
    /// <summary>
    /// Confirmation code that is generated for each participant for each order.
    /// TypeID = 137000.
    /// </summary>
    OrderConfirmationCode = 137000,

    /// <summary>
    /// Code which is generated when one user needs to grant access to participant
    /// to another user.
    /// TypeID = 137001.
    /// </summary>
    ParticipantAccessCode = 137001
}

/**
 * Defines user relationship: parent, siblings, etc.
 * Used in: UserRelation.UserRelationTypeID, OrderUserRelation.UserRelationTypeID.
 */
export enum UserRelationshipType {
    /// <summary>
    /// TypeID = 97000.
    /// </summary>
    ResidesWith = 97000,
    /// <summary>
    /// TypeID = 97002.
    /// </summary>
    ParentGuardian = 97002,
    /// <summary>
    /// TypeID = 97003.
    /// </summary>
    //Participant = 97003,
    /// <summary>
    /// TypeID = 97005.
    /// </summary>
    Parent = 97005,
    /// <summary>
    /// TypeID = 97006.
    /// </summary>
    Guardian = 97006,
    /// <summary>
    /// TypeID = 97007.
    /// </summary>
    Other = 97007
}

export enum UserRoleType {
    //SystemSuperAdmin = 2000,
    //ViewSystemData = 2001,
    //OperatingCompanyAdmin = 2002,
    //OperatingCompanyUserAdmin = 2003,
    //TermStaffUserAdmin = 2004,
    //ClientUserAdmin = 2005,
    //DivisionAdmin = 2006,
    //DivisionUserAdmin = 2007,
    //RegionAdmin = 2008,
    //ManageRegionalManagers = 2009,
    //RegionalManager = 2010,
    //ViewCompanyData = 2011,
    //LocationAdmin = 2012,
    //ViewDivisionData = 2013,
    //LocationManager = 2014,
    //LocationViewer = 2015,
    //ClientAddressDataManager = 2016,
    //CustomerServiceManager = 2017,
    //CapacityManager = 2018,
    //CapacityManagementLead = 2019,
    //CapacityManagmentViewer = 2020,
    //ProductManager = 2021,
    //ProductDeveloper = 2022,
    //ProductViewer = 2023,
    //DiscountManager = 2024,
    //MarketingManager = 2025,
    //MarketingCampaignLead = 2026,
    //MarketingPromotionsRep = 2027,
    //ScholarshipLead = 2028,
    //TuitionAssistanceLead = 2029,
    //VoucherLead = 2030,
    //CustomerServiceLead = 2031,

    ///// <summary>
    ///// Company Level Role.
    ///// TypeID = 2032.
    ///// </summary>
    //ComplianceManager = 2032,

    // NEW ROLE MATRIX.

    /// <summary>
    /// TypeID = 2033.
    /// </summary>
    Administrator = 2033,

    /// <summary>
    /// TypeID = 2034.
    /// </summary>
    ClientServices = 2034,

    /// <summary>
    /// TypeID = 2035.
    /// Peviously "Client" renamed to "Public"
    /// </summary>
    Public = 2035,

    /// <summary>
    /// TypeID = 2036.
    /// </summary>
    Corporate = 2036,

    /// <summary>
    /// TypeID = 2037.
    /// </summary>
    Compliance = 2037,

    /// <summary>
    /// TypeID = 2038.
    /// </summary>
    AdministrativeServices = 2038,

    /// <summary>
    /// TypeID = 2039.
    /// </summary>
    Accounting = 2039,

    /// <summary>
    /// TypeID = 2040.
    /// </summary>
    SalesAndMarketing = 2040,

    /// <summary>
    /// TypeID = 2041.
    /// </summary>
    Region = 2041,

    /// <summary>
    /// TypeID = 2042.
    /// </summary>
    TermStaff = 2042,

    /// <summary>
    /// TypeID = 2043.
    /// </summary>
    Logistics = 2043,

    /// <summary>
    /// TypeID = 2044.
    /// </summary>
    HR = 2044,

    /// <summary>
    /// TypeID = 2045.
    /// </summary>
    Payroll = 2045,

    /// <summary>
    /// TypeID = 2046.
    /// </summary>
    IT = 2046,

    /// <summary>
    /// TypeID = 2047.
    /// </summary>
    CDev = 2047,

    /// <summary>
    /// TypeID = 2048.
    /// </summary>
    TechRocket = 2048,

    /// <summary>
    /// TypeID = 2099.
    /// </summary>
    Unknown = 2099
}

export enum UserRoleLevelType {
    /// <summary>
    /// TypeID = 147020.
    /// </summary>
    TermStaffLevel1 = 147020,
    /// <summary>
    /// TypeID = 147021.
    /// </summary>
    TermStaffLevel2 = 147021,
    /// <summary>
    /// TypeID = 147022.
    /// </summary>
    TermStaffLevel3 = 147022,
    /// <summary>
    /// TypeID = 147023.
    /// </summary>
    TermStaffLevel4 = 147023,
    /// <summary>
    /// TypeID = 147024.
    /// </summary>
    TermStaffLevel5 = 147024
}

export enum UserRoleRequired {
    /// <summary>
    /// TypeID = 271000
    /// </summary>
    AlwaysRequired = 271000,
    /// <summary>
    /// TypeID = 271001
    /// </summary>
    RequiredIfNoJobAssignment = 271001,
    /// <summary>
    /// TypeID = 271002
    /// </summary>
    NeverRequired = 271002
}

/**UserType
 * Deprecated.  Do not use this.  User UserAccountTypeMask instead.
 */
//export enum UserType
//{
//    /// <summary>
//    /// PulseTypeID = 30000. Permanent Employee
//    /// </summary>
//    Employee = 30000,
//    /// <summary>
//    /// PulseTypeID = 30001. Term Employee
//    /// </summary>
//    TermEmployee = 30001,
//    /// <summary>
//    /// PulseTypeID = 30002. Employee of Partner corporation
//    /// </summary>
//    ExternalCorporate = 30002,
//    /// <summary>
//    /// PulseTypeID = 30003. Customers, Participants, etc.
//    /// </summary>
//    Public = 30003
//}

/**
 * Bit masking flags
 * <remarks>This enum does not use the TypeIDs in the Type table.  Values are set to bit masks.</remarks>
 */
export enum UserAccountTypeMask {
    None = 0x0,

    /// <summary>
    /// Flag = 0x1. Bit pos 1. Corporate Employee
    /// </summary>
    CorporateEmployee = 0x1,
    /// <summary>
    /// Flag = 0x2. Bit pos 2. Employee of Partner corporation
    /// </summary>
    ExternalCorporate = 0x2,
    /// <summary>
    /// Flag = 0x4. Bit pos 3. Term Staff - Job Applicant
    /// </summary>
    TermStaff_JobApplicant = 0x4,
    /// <summary>
    /// Flag = 0x8. Bit pos 4. Term Staff - Employee (not being used)
    /// </summary>
    TermStaff_Employee = 0x8,
    /// <summary>
    /// Flag = 0x10. Bit pos 5. Public - Client (has made a purchase)
    /// </summary>
    Public_HasPurchased = 0x10,
    /// <summary>
    /// Flag = 0x20. Bit pos 6. Public - Participant (has registered)
    /// </summary>
    Public_Participant = 0x20,

    /// <summary>
    /// Flag = 0x40. Bit pos 7. If set and if splash page should be shown, system
    /// should skip spalsh page and redirect user straight to Job Account.
    /// </summary>
    AlwaysRedirectToJobAccount = 0x40,

    /// <summary>
    /// Flag = 0x80. Bit pos 8. indicates if user can manage their account
    /// info for idTech365
    /// </summary>
    ParticipantCanManageAccount = 0x80,

    /// <summary>
    /// Flag = 0x100. Bit pos 9. indicates if account was created
    /// via the tech rocket site
    /// </summary>
    AccountCreatedByTechRocket = 0x100,

    /// <summary>
    /// Flag = 0x8000. Bit pos 16. indicates user opted in for SMS text message alerts
    /// </summary>
    SMSTextMessageAlertsOptIn = 0x8000,

    All = 0xffff
}

export enum USStateType {
    /// <summary>
    /// TypeID = 15012
    /// </summary>
    Hawaii = 15012,

    /// <summary>
    /// TypeID = 15022
    /// </summary>
    Massachusetts = 15022,

    /// <summary>
    /// TypeID = 15070
    /// </summary>
    International = 15070
}

/**
 * Interfaces for Pulse WebAPI services.
 */
export enum UTMCreationTriggerType {
    /// <summary>
    /// TypeID = 358000
    /// </summary>
    LeadGeneration = 358000,
    /// <summary>
    /// TypeID = 358001
    /// </summary>
    CreateAccount = 358001,
    /// <summary>
    /// TypeID = 358002
    /// </summary>
    Login = 358002,
    /// <summary>
    /// TypeID = 358003
    /// </summary>
    CatalogRequest = 358003,
    /// <summary>
    /// TypeID = 358004
    /// </summary>
    AddToCart = 358004,
    /// <summary>
    /// TypeID = 358005
    /// </summary>
    Purchase = 358005
}

/**
 * VIP clients can fall into one of the categories, defined by this type class.
 */
export enum VIPType {
    /// <summary>
    /// TypeID = 138000
    /// </summary>
    CorporatePartnerRelation = 138000,

    /// <summary>
    /// TypeID = 138001
    /// </summary>
    CelebrityClient = 138001,

    /// <summary>
    /// TypeID = 138002
    /// </summary>
    CelebrityParticipant = 138002,

    /// <summary>
    /// TypeID = 138003
    /// </summary>
    PressRelation = 138003,

    /// <summary>
    /// TypeID = 138004
    /// </summary>
    Other = 138004
}

/**
 * Used to indicate VisaTypeID in the UserFormVisa table.
 */
export enum Visa {
    /// <summary>
    /// TypeID = 259000.
    /// </summary>
    F1 = 259000,
    /// <summary>
    /// TypeID = 259001.
    /// </summary>
    H1B = 259001,
    /// <summary>
    /// TypeID = 259002.
    /// </summary>
    J1 = 259002,
    /// <summary>
    /// TypeID = 259003.
    /// </summary>
    M1 = 259003
}

/**
 * Used to indicate VisaStatusTypeID in the UserFormVisa table.
 */
export enum VisaStatus {
    /// <summary>
    /// TypeID = 261000.
    /// </summary>
    Complete = 261000,
    /// <summary>
    /// TypeID = 261001.
    /// </summary>
    Processing = 261001
}

export enum VisibilityType {
    Public = 5000,
    Internal = 5001
}

export enum WaitListStatus {
    /// <summary>
    /// Entry is active.  Client is waiting for an open spot in the current term group.
    /// TypeID = 318000.
    /// </summary>
    Waiting = 318000,

    /// <summary>
    /// Request has been processed.  Client has been offered an opening and is no longer considered waiting.
    /// TypeID = 318001
    /// </summary>
    Disposed = 318001
}

export enum WorkFlowStatus {
    /// <summary>
    /// TypeID = 272000
    /// </summary>
    Unprocessed = 272000,

    /// <summary>
    /// TypeID = 272001
    /// </summary>
    PayrollTransmitted = 272001,

    /// <summary>
    /// TypeID = 272002
    /// </summary>
    AlteredAfterTransmission = 272002
}

export enum SkillLevels {
    Beginner = 51,
    Intermediate = 52,
    Advanced = 53
}
